
// object with all the store details
	var storeObject = {
    "store": [{
        "storeId": "570",
        "name": "R & M HOCKEY SUPPLY LLC",
        "address1": "101 JOHN CAMPBELL ROAD",
        "city": "NEWARK",
        "postalCode": "19711",
        "stateCode": "DE",
        "countryCode": "US",
        "email": "DelawareSales@rmhockeysupply.com",
        "phone": "302-266-9840",
        "latitude": "39.68188",
        "longitude": "-75.728608",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19305"
            },
            {
              "attributeId": "soldToID",
              "text": "19305"
            }
          ]
        }
      },
      {
        "storeId": "80",
        "name": "THE STICK RACK INC",
        "address1": "7900 FAIRGROUNDS AVE",
        "city": "FORT COLLINS",
        "postalCode": "80528",
        "stateCode": "CO",
        "countryCode": "US",
        "email": "steve@thestickrack.com",
        "phone": "970.222.1887",
        "latitude": "40.4750595",
        "longitude": "-104.9813272",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19013"
            },
            {
              "attributeId": "soldToID",
              "text": "19013"
            }
          ]
        }
      },
      {
        "storeId": "540",
        "name": "HOCKEY X SUPERSTORE",
        "address1": "210 HEGENBERGER LOOP",
        "city": "OAKLAND",
        "postalCode": "94621",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "hockeyxsport@yahoo.com",
        "phone": "510-638-6004",
        "latitude": "37.737252",
        "longitude": "-122.195091",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "10949"
            },
            {
              "attributeId": "soldToID",
              "text": "10949"
            }
          ]
        }
      },
      {
        "storeId": "600",
        "name": "THE SKATER'S EDGE LLC",
        "address1": "1625 DEERCROFT CT",
        "city": "GREENSBORO",
        "postalCode": "27407",
        "stateCode": "NC",
        "countryCode": "US",
        "phone": "336-285-9485",
        "latitude": "36.0279256",
        "longitude": "-79.90433929999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "15120"
            }
          ]
        }
      },
      {
        "storeId": "30",
        "name": "HOCKEY ZONE MINNESOTA LLC SFS",
        "address1": "724 3RD STREET SOUTH",
        "city": "WAITE PARK",
        "postalCode": "56387",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "gary@hockeyzonemn.com",
        "phone": "320-251-7012",
        "latitude": "45.547721",
        "longitude": "-94.225927",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211197"
            },
            {
              "attributeId": "soldToID",
              "text": "9191"
            }
          ]
        }
      },
      {
        "storeId": "638",
        "name": "KEVIN SMITH SPORTS CONNECTION SFS",
        "address1": "38 SOUTH MAIN STREET",
        "city": "SAINT ALBANS",
        "postalCode": "05478",
        "stateCode": "VT",
        "countryCode": "US",
        "phone": "802-524-3312",
        "latitude": "44.8099472",
        "longitude": "-73.08395999999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5367"
            }
          ]
        }
      },
      {
        "storeId": "94",
        "name": "ASPEN ICE INC.",
        "address1": "10 MIDDLEBURY BOULEVARD",
        "city": "RANDOLPH",
        "postalCode": "07869",
        "stateCode": "NJ",
        "countryCode": "US",
        "email": "phil@middleburysports.com",
        "phone": "93-927-9110",
        "latitude": "40.8607538",
        "longitude": "-74.6179918",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211198"
            },
            {
              "attributeId": "soldToID",
              "text": "13191"
            }
          ]
        }
      },
      {
        "storeId": "1222",
        "name": "PURE HOCKEY MEQUON",
        "address1": "10930 N. PORT WASHINGTON ROAD",
        "city": "MEQUON",
        "postalCode": "53092",
        "stateCode": "WI",
        "countryCode": "US",
        "latitude": "43.21658",
        "longitude": "-87.92245",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224416"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "28",
        "name": "STRAUSS SKATES INC SFS",
        "address1": "1751 EAST COPE AVE",
        "city": "SAINT PAUL",
        "postalCode": "55109",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "shaun@shopstrauss.com",
        "phone": "651-770-1344",
        "latitude": "45.010534",
        "longitude": "-93.026412",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "hockeygl@gmail.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6565"
            },
            {
              "attributeId": "soldToID",
              "text": "6565"
            }
          ]
        }
      },
      {
        "storeId": "148",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "2121 OAK VALLEY DR",
        "city": "ANN ARBOR",
        "postalCode": "48103",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "734-332-1480",
        "latitude": "42.254361",
        "longitude": "-83.778166",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211485"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "214",
        "name": "PURE HOCKEY",
        "address1": "1299 HIGHLAND AVE",
        "city": "NEEDHAM",
        "postalCode": "02492",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "needham@purehockey.com",
        "phone": "781-444-5356",
        "latitude": "42.284108",
        "longitude": "-71.236423",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223183"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "621",
        "name": "JERRY'S HOCKEY",
        "address1": "320 PRAIRIE STREET",
        "city": "CRYSTAL LAKE",
        "postalCode": "60014",
        "stateCode": "IL",
        "countryCode": "US",
        "phone": "815-479-0700",
        "latitude": "42.246165",
        "longitude": "-88.308896",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "5279"
            }
          ]
        }
      },
      {
        "storeId": "10",
        "name": "RG HOCKEY SOURCE FOR SPORTS",
        "address1": "3869 ICE WAY STE A",
        "city": "FORT WAYNE",
        "postalCode": "46805",
        "stateCode": "IN",
        "countryCode": "US",
        "phone": "260-745-6423",
        "latitude": "41.111995",
        "longitude": "-85.147399",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4591"
            },
            {
              "attributeId": "soldToID",
              "text": "4591"
            }
          ]
        }
      },
      {
        "storeId": "189",
        "name": "MONKEYSPORTS INC",
        "address1": "19500E W PLUMMER ST",
        "city": "NORTHRIDGE",
        "postalCode": "91324",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "retail-la@monkeysports.com",
        "phone": "818-626-8240",
        "latitude": "34.242402",
        "longitude": "-118.558282",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "matthew.fox@MonkeySports.com",
                "Kathryn.elkins@MonkeySports.com"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223556"
            },
            {
              "attributeId": "soldToID",
              "text": "15909"
            }
          ]
        }
      },
      {
        "storeId": "631",
        "name": "JOHNNY MAC'S SPTG GOODS SEC",
        "address1": "5819 SUEMANDY ROAD",
        "city": "ST PETERS",
        "postalCode": "63376",
        "stateCode": "MO",
        "countryCode": "US",
        "phone": "636-278-6300",
        "latitude": "38.796617",
        "longitude": "-90.62450799999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5291"
            }
          ]
        }
      },
      {
        "storeId": "650",
        "name": "SPORTS ARENA LLC",
        "address1": "236 W RIVER RD",
        "city": "HOOKSETT",
        "postalCode": "03106",
        "stateCode": "NH",
        "countryCode": "US",
        "phone": "603 669-8654",
        "latitude": "43.0662123",
        "longitude": "-71.468167",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6488"
            }
          ]
        }
      },
      {
        "storeId": "1193",
        "name": "HOCKEY MONKEY",
        "address1": "1500 Route 9 North",
        "city": "WOODBRIDGE",
        "postalCode": "07095",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "732-634-1446",
        "latitude": "42.06989",
        "longitude": "-73.83801",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "15119"
            },
            {
              "attributeId": "soldToID",
              "text": "15119"
            }
          ]
        }
      },
      {
        "storeId": "OHL",
        "name": "OHL",
        "address1": "2856 S RONALD REAGAN PKWY",
        "city": "INDIANAPOLIS",
        "postalCode": "46231-3320",
        "stateCode": "INDIANA",
        "countryCode": "US",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            }
          ]
        }
      },
      {
        "storeId": "639",
        "name": "STATELINE SPORTS SEC",
        "address1": "22 BRIDGE ST",
        "city": "WEST LEBANON",
        "postalCode": "03784",
        "stateCode": "NH",
        "countryCode": "US",
        "phone": "603-298-8090",
        "latitude": "43.6509173",
        "longitude": "-72.31298509999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6550"
            }
          ]
        }
      },
      {
        "storeId": "34",
        "name": "HAT TRICK HOCKEY II SEC",
        "address1": "4109 7TH AVENUE NORTH",
        "city": "ANOKA",
        "postalCode": "55303",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "763-427-4545",
        "latitude": "45.2272256",
        "longitude": "-93.37884269999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "13617"
            },
            {
              "attributeId": "soldToID",
              "text": "13617"
            }
          ]
        }
      },
      {
        "storeId": "1180",
        "name": "GUNN'S SPORT SHOP",
        "address1": "32 GREEN POINT ROAD",
        "city": "BREWER",
        "postalCode": "04412",
        "stateCode": "ME",
        "countryCode": "US",
        "phone": "207-989- 9838",
        "latitude": "44.777296",
        "longitude": "-68.744372",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false"
      },
      {
        "storeId": "154",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "5264 HICKORY HOLLOW PARKWAY",
        "city": "ANTIOCH",
        "postalCode": "37013",
        "stateCode": "TN",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "615-717-3020",
        "latitude": "36.053264",
        "longitude": "-86.657173",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221769"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "139",
        "name": "MCKIE SPORTS INC SEC",
        "address1": "1007 STATE FAIR BLVD",
        "city": "SYRACUSE",
        "postalCode": "13209",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "ben@mckiesports.com",
        "phone": "315-487-2010",
        "latitude": "43.099283",
        "longitude": "-76.248141",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "ben@mckiesports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19765"
            },
            {
              "attributeId": "soldToID",
              "text": "19765"
            }
          ]
        }
      },
      {
        "storeId": "537",
        "name": "PLAY IT AGAIN SPORTS FAIRBANKS",
        "address1": "160 OLD STEESE HIGHWAY",
        "city": "FAIRBANKS",
        "postalCode": "99701",
        "stateCode": "AK",
        "countryCode": "US",
        "email": "playitak@alaska.net",
        "phone": "907-457-7427",
        "latitude": "64.847532",
        "longitude": "-147.707729",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6167"
            },
            {
              "attributeId": "soldToID",
              "text": "6167"
            }
          ]
        }
      },
      {
        "storeId": "229",
        "name": "PURE HOCKEY",
        "address1": "343 ROUTE 46 WEST",
        "city": "FAIRFIELD",
        "postalCode": "07004",
        "stateCode": "NJ",
        "countryCode": "US",
        "email": "fairfield@purehockey.com",
        "phone": "973-287-6720",
        "latitude": "40.881156",
        "longitude": "-74.29429",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223181"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "516",
        "name": "STEWARTS BIKES SPORTS & TROPHIES",
        "address1": "102 S 29TH AVE WEST",
        "city": "DULUTH",
        "postalCode": "55806",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "steve@stewartsbikesand sports.com",
        "phone": "218-724-5101",
        "latitude": "46.7589023",
        "longitude": "-92.13325909999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "10681"
            },
            {
              "attributeId": "soldToID",
              "text": "10681"
            }
          ]
        }
      },
      {
        "storeId": "104",
        "name": "X HOCKEY PRODUCTS BREAKAWAY PRO SE",
        "address1": "91 FAIRVIEW PARK DRIVE",
        "city": "ELMSFORD",
        "postalCode": "10523",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "msetola@xhockeyproducts.com",
        "phone": "914-34-0425",
        "latitude": "41.0669195",
        "longitude": "-73.81645040000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224075"
            },
            {
              "attributeId": "soldToID",
              "text": "15551"
            }
          ]
        }
      },
      {
        "storeId": "466",
        "name": "FERGUSONS CENTER ICE SPORTS",
        "address1": "641 NEW LONDON TURNPIKE",
        "city": "NORWICH",
        "postalCode": "06320",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "860-892-2555",
        "latitude": "41.5050213",
        "longitude": "-72.1032096",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4420"
            }
          ]
        }
      },
      {
        "storeId": "644",
        "name": "GOAL LINE PRO SHOP LLC SFS",
        "address1": "10 E BELCHER RD",
        "city": "FOXBORO",
        "postalCode": "02035",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "508-698-9150",
        "latitude": "42.0621103",
        "longitude": "-71.22858029999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14713"
            }
          ]
        }
      },
      {
        "storeId": "588",
        "name": "THE COOLER",
        "address1": "10800 DAVIS DRIVE",
        "city": "ALPHARETTA",
        "postalCode": "30004",
        "stateCode": "GA",
        "countryCode": "US",
        "phone": "770-649-6600 ex2242",
        "latitude": "34.043445",
        "longitude": "-84.31119699999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4611"
            }
          ]
        }
      },
      {
        "storeId": "103",
        "name": "X HOCKEY PRODUCTS BREAKAWAY PRO SE",
        "address1": "1000 CORNWALL ROAD",
        "city": "MONMOUTH JUNCT",
        "postalCode": "08852",
        "stateCode": "NJ",
        "countryCode": "US",
        "email": "msetola@xhockeyproducts.com",
        "phone": "732-940-6400 ext 21",
        "latitude": "40.4153853",
        "longitude": "-74.5282933",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222596"
            },
            {
              "attributeId": "soldToID",
              "text": "15551"
            }
          ]
        }
      },
      {
        "storeId": "200",
        "name": "PURE HOCKEY",
        "address1": "2690 EAST COUNTY LINE ROAD SUITE",
        "city": "LITTLETON",
        "postalCode": "80126",
        "stateCode": "CO",
        "countryCode": "US",
        "email": "littleton@purehockey.com",
        "phone": "303-738-9784",
        "latitude": "39.564807",
        "longitude": "-104.956796",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223189"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "145",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "3600 SOUTH DORT HIGHWAY",
        "city": "FLINT",
        "postalCode": "48503",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "810-744-3338",
        "latitude": "42.989927",
        "longitude": "-83.656288",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4258"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "134",
        "name": "BROADWAY RINKS LTD PTNRSP",
        "address1": "75 WEISS RD",
        "city": "BUFFALO",
        "postalCode": "14224",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "716-675 8992",
        "latitude": "42.8689279",
        "longitude": "-78.80844599999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "203713"
            },
            {
              "attributeId": "soldToID",
              "text": "4274"
            }
          ]
        }
      },
      {
        "storeId": "20",
        "name": "DAVE'S SPORT SHOP INC SEC",
        "address1": "1001 E. MOORE LAKE DR",
        "city": "FRIDLEY",
        "postalCode": "55432",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "763-571-4110",
        "latitude": "45.08133",
        "longitude": "-93.24166149999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4632"
            },
            {
              "attributeId": "soldToID",
              "text": "4632"
            }
          ]
        }
      },
      {
        "storeId": "18",
        "name": "NORTHLAND PRO SHOP LLC",
        "address1": "10400 READING RD",
        "city": "CINCINNATI",
        "postalCode": "45241",
        "stateCode": "OH",
        "countryCode": "US",
        "phone": "513-604-6777",
        "latitude": "39.2528965",
        "longitude": "-84.4208548",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "15011"
            },
            {
              "attributeId": "soldToID",
              "text": "15011"
            }
          ]
        }
      },
      {
        "storeId": "476",
        "name": "WESCO SPTS CENTER WCHS SEC",
        "address1": "1063 HOPE ST.",
        "city": "STAMFORD",
        "postalCode": "06907",
        "stateCode": "CT",
        "countryCode": "US",
        "email": "email@wescosports.com",
        "phone": "203-504-8454",
        "latitude": "41.0952",
        "longitude": "-73.517938",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "210385"
            },
            {
              "attributeId": "soldToID",
              "text": "7169"
            }
          ]
        }
      },
      {
        "storeId": "237",
        "name": "PURE HOCKEY",
        "address1": "20267 ROUTE 19 #2",
        "city": "CRANBERRY TOWN",
        "postalCode": "16066",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "cranberry@purehockey.com",
        "phone": "724-776-7500",
        "latitude": "40.689294",
        "longitude": "-80.102654",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223193"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "569",
        "name": "BEACON HILL SKATE SHOP",
        "address1": "250 HOBART AVE",
        "city": "SUMMIT",
        "postalCode": "07901",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "908-277-6688",
        "latitude": "40.728",
        "longitude": "-74.348",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "15800"
            }
          ]
        }
      },
      {
        "storeId": "629",
        "name": "JOHNNY MAC'S SPTG GOODS SEC",
        "address1": "14649 MANCHESTER ROAD",
        "city": "BALLWIN",
        "postalCode": "63011",
        "stateCode": "MO",
        "countryCode": "US",
        "phone": "636.391.6450",
        "latitude": "38.5933908",
        "longitude": "-90.5305456",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5291"
            }
          ]
        }
      },
      {
        "storeId": "98",
        "name": "COZZI SPORTS INC",
        "address1": "1001 STEWART AVE",
        "city": "BETHPAGE",
        "postalCode": "11714",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "516-433-7465",
        "latitude": "40.7556709",
        "longitude": "-73.485599",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "15527"
            },
            {
              "attributeId": "soldToID",
              "text": "15527"
            }
          ]
        }
      },
      {
        "storeId": "475",
        "name": "WESCO SPTS CENTER WCHS SEC",
        "address1": "270 FEDERAL ROAD",
        "city": "BROOKFIELD",
        "postalCode": "06804",
        "stateCode": "CT",
        "countryCode": "US",
        "email": "email@wescosports.com",
        "phone": "203-775-2227",
        "latitude": "41.446761",
        "longitude": "-73.404679",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7169"
            },
            {
              "attributeId": "soldToID",
              "text": "7169"
            }
          ]
        }
      },
      {
        "storeId": "659",
        "name": "TOTAL SPORTS REPAIR INC. SEC",
        "address1": "311 WEST RIVER ROAD",
        "city": "HOOKSETT",
        "postalCode": "03106",
        "stateCode": "NH",
        "countryCode": "US",
        "phone": "603 210-5281",
        "latitude": "43.0755503",
        "longitude": "-71.4683392",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9802"
            }
          ]
        }
      },
      {
        "storeId": "85",
        "name": "AMITY HARBOR SPORTS SEC",
        "address1": "270 INDIAN HEAD ROAD",
        "city": "KINGS PARK",
        "postalCode": "11754",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "631-269-3900",
        "latitude": "40.8727162",
        "longitude": "-73.2572934",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4056"
            }
          ]
        }
      },
      {
        "storeId": "109",
        "name": "BEHIND THE MASK INC",
        "address1": "2305 E. KNOX ROAD # 2",
        "city": "GILBERT",
        "postalCode": "85296",
        "stateCode": "AZ",
        "countryCode": "US",
        "phone": "480-785-5941",
        "latitude": "33.3270955",
        "longitude": "-111.7407851",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "212718"
            },
            {
              "attributeId": "soldToID",
              "text": "4221"
            }
          ]
        }
      },
      {
        "storeId": "208",
        "name": "PURE HOCKEY",
        "address1": "220 WOOD RD",
        "city": "BRAINTREE",
        "postalCode": "02184",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "braintree@purehockey.com",
        "phone": "781-794-2910",
        "latitude": "42.220631",
        "longitude": "-71.037055",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223168"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "137",
        "name": "LOCKER ROOM SPORTS, INC",
        "address1": "2700 BRIGHTON HENRIETTA TOWNLINE RD",
        "city": "ROCHESTER",
        "postalCode": "14623",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "585-272-9592",
        "latitude": "43.098305",
        "longitude": "-77.602414",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "5469"
            }
          ]
        }
      },
      {
        "storeId": "535",
        "name": "PLAY IT AGAIN SPORTS ANCHORAGE SOUTH",
        "address1": "1461 S SEWARD MERIDIAN PKWY",
        "city": "WASILLA",
        "postalCode": "99654",
        "stateCode": "AK",
        "countryCode": "US",
        "phone": "907-376-8046",
        "latitude": "61.5675676",
        "longitude": "-149.3589304",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5992"
            }
          ]
        }
      },
      {
        "storeId": "204",
        "name": "PURE HOCKEY",
        "address1": "170 BARRINGTON ROAD",
        "city": "SCHAUMBURG",
        "postalCode": "60194",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "schaumburg@purehockey.com",
        "phone": "847-798-9820",
        "latitude": "42.028072",
        "longitude": "-88.145689",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223202"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "91",
        "name": "PARAGON ATHLETIC GOODS LLC",
        "address1": "867 BROADWAY",
        "city": "NEW YORK",
        "postalCode": "10003",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "212-255-8889",
        "latitude": "40.7377239",
        "longitude": "-73.9905581",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5890"
            },
            {
              "attributeId": "soldToID",
              "text": "5890"
            }
          ]
        }
      },
      {
        "storeId": "168",
        "name": "B & R SPORTING GOODS",
        "address1": "200 NORTH GROESBECK HIGHWAY",
        "city": "MOUNT CLEMENS",
        "postalCode": "48043",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "586-557-4604",
        "latitude": "42.609266",
        "longitude": "-82.8931649",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "213301"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "538",
        "name": "NORTHWEST SKATE AUTHORITIES",
        "address1": "20407 SW BORCHERS DRIVE",
        "city": "SHERWOOD",
        "postalCode": "97140",
        "stateCode": "OR",
        "countryCode": "US",
        "email": "nwskate@comcast.net",
        "phone": "503-925-8097",
        "latitude": "45.368536",
        "longitude": "-122.848592",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "209669"
            },
            {
              "attributeId": "soldToID",
              "text": "10941"
            }
          ]
        }
      },
      {
        "storeId": "226",
        "name": "PURE HOCKEY",
        "address1": "40 INDUSTRIAL DR",
        "city": "EXETER",
        "postalCode": "03833",
        "stateCode": "NH",
        "countryCode": "US",
        "email": "exeter@purehockey.com",
        "phone": "603-583-4572",
        "latitude": "42.9944",
        "longitude": "-70.967497",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223169"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "138",
        "name": "M V P SPORTS INC SEC",
        "address1": "11 PINE ST",
        "city": "POTSDAM",
        "postalCode": "13676",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "315-265-3960",
        "latitude": "44.6687324",
        "longitude": "-74.9951588",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5550"
            },
            {
              "attributeId": "soldToID",
              "text": "5550"
            }
          ]
        }
      },
      {
        "storeId": "203",
        "name": "PURE HOCKEY",
        "address1": "550 ST CHARLES ROAD",
        "city": "ELMHURST",
        "postalCode": "60126",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "elmhurst@purehockey.com",
        "phone": "630-279-7221",
        "latitude": "41.88985",
        "longitude": "-87.960503",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223200"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "100",
        "name": "COZZI SPORTS INC",
        "address1": "575 VANDERBILT PKY",
        "city": "DIX HILLS",
        "postalCode": "11746",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "631-486-4491",
        "latitude": "40.818693",
        "longitude": "-73.331308",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "15527"
            }
          ]
        }
      },
      {
        "storeId": "596",
        "name": "J & H HOCKEY INC.",
        "address1": "8125 LAKE WORTH ROAD",
        "city": "LAKE WORTH",
        "postalCode": "33467",
        "stateCode": "FL",
        "countryCode": "US",
        "phone": "561-434-1222",
        "latitude": "26.6193984",
        "longitude": "-80.1760477",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9059"
            }
          ]
        }
      },
      {
        "storeId": "543",
        "name": "ELEVATE SPORTING",
        "address1": "7610 TACOMA WAY",
        "city": "TACOMA",
        "postalCode": "98409",
        "stateCode": "WA",
        "countryCode": "US",
        "email": "EddieToy@elevatesporting.com",
        "phone": "253-212-0909",
        "latitude": "47.187619",
        "longitude": "-122.484317",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18800"
            },
            {
              "attributeId": "soldToID",
              "text": "18800"
            }
          ]
        }
      },
      {
        "storeId": "108",
        "name": "BEHIND THE MASK INC",
        "address1": "8666 E SHEA BLVD #150",
        "city": "SCOTTSDALE",
        "postalCode": "85260",
        "stateCode": "AZ",
        "countryCode": "US",
        "email": "Info@behindthemask.com",
        "phone": "480-998-1260",
        "latitude": "33.601973",
        "longitude": "-111.88792",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "custom@behindthemask.com",
                "mmoore@behindthemask.com"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4221"
            },
            {
              "attributeId": "soldToID",
              "text": "4221"
            }
          ]
        }
      },
      {
        "storeId": "12",
        "name": "TAM-O-SHANTER PRO SHOP SEC",
        "address1": "7060 SYLVANIA AVE",
        "city": "SYLVANIA",
        "postalCode": "43560",
        "stateCode": "OH",
        "countryCode": "US",
        "phone": "419-885-1167 EXT. 311",
        "latitude": "41.6910005",
        "longitude": "-83.7131055",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "6890"
            },
            {
              "attributeId": "soldToID",
              "text": "6890"
            }
          ]
        }
      },
      {
        "storeId": "653",
        "name": "TOTAL SPORTS REPAIR INC. SEC",
        "address1": "5 KELLY ROAD",
        "city": "SALEM",
        "postalCode": "03079",
        "stateCode": "NH",
        "countryCode": "US",
        "email": "Jasonpaiva@tsrhockey.com",
        "phone": "603 898-7777",
        "latitude": "42.755761",
        "longitude": "-71.211057",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "Adamgray@tsrhockey.com",
                "brendansheehy@tsrhockey.com"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "9802"
            },
            {
              "attributeId": "soldToID",
              "text": "9802"
            }
          ]
        }
      },
      {
        "storeId": "31",
        "name": "GOAL LINE GOLF AND HOCKEY SFS",
        "address1": "1430 GRAND AVE.",
        "city": "SCHOFIELD",
        "postalCode": "54476",
        "stateCode": "WI",
        "countryCode": "US",
        "email": "44rjd44@gmail.com",
        "phone": "715-355-1790",
        "latitude": "44.90055",
        "longitude": "-89.608985",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "goaline@goalinegolf.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "10978"
            },
            {
              "attributeId": "soldToID",
              "text": "10978"
            }
          ]
        }
      },
      {
        "storeId": "558",
        "name": "ICE WORKS",
        "address1": "3100 DUTTON MILL RD",
        "city": "ASTON",
        "postalCode": "19014",
        "stateCode": "PA",
        "countryCode": "US",
        "phone": "610-497-2200 ext 122",
        "latitude": "39.85847140000001",
        "longitude": "-75.4240937",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4721"
            }
          ]
        }
      },
      {
        "storeId": "156",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "2810 HANNAH BLVD",
        "city": "EAST LANSING",
        "postalCode": "48823",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "517-336-4242",
        "latitude": "42.720422",
        "longitude": "-84.454228",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211492"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "1198",
        "name": "HOCKEY MONKEY",
        "address1": "105 W Bethany Drive",
        "city": "ALLEN",
        "postalCode": "75013",
        "stateCode": "TX",
        "countryCode": "US",
        "phone": "214-383-8888",
        "latitude": "33.09125",
        "longitude": "-96.676",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "221611"
            },
            {
              "attributeId": "soldToID",
              "text": "7422"
            }
          ]
        }
      },
      {
        "storeId": "246",
        "name": "PURE HOCKEY",
        "address1": "21031 TRIPLE SEVEN RD SUITE 100",
        "city": "STERLING",
        "postalCode": "20165",
        "stateCode": "VA",
        "countryCode": "US",
        "email": "sterling@purehockey.com",
        "phone": "571-434-7404",
        "latitude": "39.03499",
        "longitude": "-77.407528",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223191"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "152",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "8301 MARKET EXCHANGE DR",
        "city": "WESTERVILLE",
        "postalCode": "43081",
        "stateCode": "OH",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "614-396-9370",
        "latitude": "40.134741",
        "longitude": "-82.989331",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221775"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "24",
        "name": "HANUS SPORTS INC SFS",
        "address1": "3311 HIGHWAY 101 SOUTH",
        "city": "WAYZATA",
        "postalCode": "55391",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "952-473-1580",
        "latitude": "44.9425646",
        "longitude": "-93.5014156",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5036"
            },
            {
              "attributeId": "soldToID",
              "text": "5036"
            }
          ]
        }
      },
      {
        "storeId": "533",
        "name": "INLINE WAREHOUSE LLC",
        "address1": "21 ZACA LANE STE 120",
        "city": "SAN LUIS OBISPO",
        "postalCode": "93401",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "cory@inlinewarehouse.com",
        "phone": "800-366-3070",
        "latitude": "35.251576",
        "longitude": "-120.67472",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5959"
            },
            {
              "attributeId": "soldToID",
              "text": "5959"
            }
          ]
        }
      },
      {
        "storeId": "562",
        "name": "COMCAST SPECTACOR SEC",
        "address1": "6725 RIVER RD.",
        "city": "PENNSAUKEN",
        "postalCode": "08110",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "856-488-9300 ",
        "latitude": "39.9718098",
        "longitude": "-75.0616814",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9951"
            }
          ]
        }
      },
      {
        "storeId": "166",
        "name": "B & R SPORTING GOODS",
        "address1": "34400 UTICA ROAD",
        "city": "FRASER",
        "postalCode": "48026",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "586-293-7941",
        "latitude": "42.549172",
        "longitude": "-82.956373",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212162"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "645",
        "name": "DYNAMIK SPORTS SFS",
        "address1": "163 MAIN STREET",
        "city": "READING",
        "postalCode": "01867",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "info@dynamiksports.com",
        "phone": "781 942-1153",
        "latitude": "42.509701",
        "longitude": "-71.103687",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4667"
            },
            {
              "attributeId": "soldToID",
              "text": "4667"
            }
          ]
        }
      },
      {
        "storeId": "648",
        "name": "PLAY IT AGAIN SPORTS",
        "address1": "315 MARGINAL WAY",
        "city": "PORTLAND",
        "postalCode": "04101",
        "stateCode": "ME",
        "countryCode": "US",
        "email": "scott.rousseau@piasme.com",
        "phone": "207 773-6063",
        "latitude": "43.667553",
        "longitude": "-70.257974",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5942"
            },
            {
              "attributeId": "soldToID",
              "text": "5942"
            }
          ]
        }
      },
      {
        "storeId": "591",
        "name": "FLORIDA EVERBLADES SEC",
        "address1": "11000 EVERBLADES PARKWAY",
        "city": "ESTERO",
        "postalCode": "33928",
        "stateCode": "FL",
        "countryCode": "US",
        "email": "BillM@floridaeverblades.com",
        "phone": "239-948-7825 ex1350",
        "latitude": "26.440561",
        "longitude": "-81.778873",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5427"
            },
            {
              "attributeId": "soldToID",
              "text": "5427"
            }
          ]
        }
      },
      {
        "storeId": "140",
        "name": "PLAY IT AGAIN SPORTS",
        "address1": "30 PLATTSBURGH PLAZA",
        "city": "PLATTSBURGH",
        "postalCode": "12901",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "518-566-6026",
        "latitude": "44.698465",
        "longitude": "-73.477954",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "6127"
            },
            {
              "attributeId": "soldToID",
              "text": "6127"
            }
          ]
        }
      },
      {
        "storeId": "544",
        "name": "PLAY IT AGAIN SPORTS LYNWOOD",
        "address1": "16929 HIGHWAY 99, SUITE 110",
        "city": "LYNWOOD",
        "postalCode": "98037",
        "stateCode": "WA",
        "countryCode": "US",
        "email": "piaslynn@live.com",
        "phone": "425-670-1184",
        "latitude": "47.8446958",
        "longitude": "-122.2944968",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19011"
            },
            {
              "attributeId": "soldToID",
              "text": "19011"
            }
          ]
        }
      },
      {
        "storeId": "111",
        "name": "COYOTES ICE, LLC",
        "address1": "9375 E. BELL RD, SUITE 101",
        "city": "SCOTTSDALE",
        "postalCode": "85260",
        "stateCode": "AZ",
        "countryCode": "US",
        "phone": "480-585-7465",
        "latitude": "33.6387944",
        "longitude": "-111.8820106",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4381"
            },
            {
              "attributeId": "soldToID",
              "text": "4381"
            }
          ]
        }
      },
      {
        "storeId": "99",
        "name": "COZZI SPORTS INC",
        "address1": "3345 HILLSIDE AVE",
        "city": "HEW HYDE PARK",
        "postalCode": "11040",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "516-746-1100",
        "latitude": "40.7536011",
        "longitude": "-73.6601513",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "15527"
            }
          ]
        }
      },
      {
        "storeId": "467",
        "name": "HAMDEN SPORTS",
        "address1": "2858 WHITNEY AVE",
        "city": "HAMDEN",
        "postalCode": "06518",
        "stateCode": "CT",
        "countryCode": "US",
        "email": "hamdensports@yahoo.com",
        "phone": "203-248-9898",
        "latitude": "41.3998077",
        "longitude": "-72.8978609",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212466"
            },
            {
              "attributeId": "soldToID",
              "text": "4439"
            }
          ]
        }
      },
      {
        "storeId": "89",
        "name": "KOSPORTS INC. SFS",
        "address1": "700 CRAIGDELL ROAD",
        "city": "NEW KENSINGTON",
        "postalCode": "15068",
        "stateCode": "PA",
        "countryCode": "US",
        "phone": "724-337-3137",
        "latitude": "40.5777012",
        "longitude": "-79.73800969999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5420"
            }
          ]
        }
      },
      {
        "storeId": "1196",
        "name": "HOCKEY MONKEY",
        "address1": "213 Airport Plaza STE. 22",
        "city": "FARMINGDALE",
        "postalCode": "11735",
        "stateCode": "NY",
        "countryCode": "US",
        "latitude": "40.73858",
        "longitude": "-73.41904",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19997"
            },
            {
              "attributeId": "soldToID",
              "text": "19997"
            }
          ]
        }
      },
      {
        "storeId": "188",
        "name": "MONKEYSPORTS INC",
        "address1": "105 WEST BETHANY DRIVE",
        "city": "ALLEN",
        "postalCode": "75013",
        "stateCode": "TX",
        "countryCode": "US",
        "email": "retailmanager-aln@monkeysports.com",
        "phone": "214-383-8888",
        "latitude": "33.090374",
        "longitude": "-96.676843",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "customerservicesupervisor@monkeysports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221611"
            },
            {
              "attributeId": "soldToID",
              "text": "7422"
            }
          ]
        }
      },
      {
        "storeId": "101",
        "name": "X HOCKEY PRODUCTS BREAKAWAY PRO SE",
        "address1": "1425 FRONTIER RD",
        "city": "BRIDGEWATER",
        "postalCode": "08807",
        "stateCode": "NJ",
        "countryCode": "US",
        "email": "msetola@xhockeyproducts.com",
        "phone": "732-627-0006 ext 109",
        "latitude": "40.577989",
        "longitude": "-74.56848",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "15551"
            },
            {
              "attributeId": "soldToID",
              "text": "15551"
            }
          ]
        }
      },
      {
        "storeId": "84",
        "name": "AMITY HARBOR SPORTS SEC",
        "address1": "660 TERRY ROAD",
        "city": "HAUPPAUGE",
        "postalCode": "11788",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "631-232-3222",
        "latitude": "40.81880779999999",
        "longitude": "-73.167277",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4056"
            }
          ]
        }
      },
      {
        "storeId": "207",
        "name": "PURE HOCKEY",
        "address1": "134 CAPITAL DRIVE",
        "city": "WEST SPRINGFIELD",
        "postalCode": "01089",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "springfield@purehockey.com",
        "phone": "413-455-1800",
        "latitude": "42.136865",
        "longitude": "-72.619796",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221762"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "88",
        "name": "KOSPORTS INC. SFS",
        "address1": "100 CENTER ICE BLVD.",
        "city": "DELMONT",
        "postalCode": "15626",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "curt@kosports.com",
        "phone": "724-461-7160",
        "latitude": "40.4011804",
        "longitude": "-79.57610100000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224135"
            },
            {
              "attributeId": "soldToID",
              "text": "5420"
            }
          ]
        }
      },
      {
        "storeId": "82",
        "name": "CENTRE ICE HOCKEY LLC SEC",
        "address1": "6255 CORPORATE DR",
        "city": "COLORADO SPRINGS",
        "postalCode": "80919",
        "stateCode": "CO",
        "countryCode": "US",
        "email": "rboh@totalteamsales.com",
        "phone": "720.280.4355",
        "latitude": "38.919702",
        "longitude": "-104.81584",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223740"
            },
            {
              "attributeId": "soldToID",
              "text": "19366"
            }
          ]
        }
      },
      {
        "storeId": "161",
        "name": "B & R SPORTING GOODS",
        "address1": "31W330 NORTH AURORA ROAD",
        "city": "NAPERVILLE",
        "postalCode": "60563",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "jeffbielecki@yahoo.com",
        "phone": "630-851-0155",
        "latitude": "41.7821",
        "longitude": "-88.2341",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213298"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "515",
        "name": "STAUBER BROS INC. SEC",
        "address1": "2541 MAPLE GROVE RD",
        "city": "DULUTH",
        "postalCode": "55811",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "218-727-3018",
        "latitude": "46.8079115",
        "longitude": "-92.1741617",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6547"
            }
          ]
        }
      },
      {
        "storeId": "640",
        "name": "PLAY IT AGAIN SPORTS",
        "address1": "606 WASHINGTON STREET",
        "city": "DEDHAM",
        "postalCode": "02026",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "781-493-6796",
        "latitude": "42.2410948",
        "longitude": "-71.1786719",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "11336"
            }
          ]
        }
      },
      {
        "storeId": "11",
        "name": "HOCKEY SERVICES SFS",
        "address1": "6958 WEST MAIN STREET",
        "city": "KALAMAZOO",
        "postalCode": "49009",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "players@hockeyservices.com",
        "phone": "269-375-3313",
        "latitude": "42.29615140000001",
        "longitude": "-85.686853",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5075"
            },
            {
              "attributeId": "soldToID",
              "text": "5075"
            }
          ]
        }
      },
      {
        "storeId": "1220",
        "name": "BAUER RINK EXPERIENCE",
        "address1": "750 CASINO CENTER DRIVE",
        "address2": "SUITE 600",
        "city": "MARYLAND HEIGHTS",
        "postalCode": "63043",
        "stateCode": "MO",
        "countryCode": "US",
        "latitude": "38.74951",
        "longitude": "-90.47685",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224470"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "153",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "1600 COCHRAN RD",
        "city": "PITTSBURGH",
        "postalCode": "15220",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "412-343-5857",
        "latitude": "40.391455",
        "longitude": "-80.059124",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211489"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "163",
        "name": "B & R SPORTING GOODS",
        "address1": "13333 TELEGRAPH ROAD",
        "city": "TAYLOR",
        "postalCode": "48180",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jeffbielecki@yahoo.com",
        "phone": "734-374-8130",
        "latitude": "42.209462",
        "longitude": "-83.266155",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "214207"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "461",
        "name": "BLUELINE SPORTS INC. SFS",
        "address1": "55 OLD KINGS HWY N",
        "city": "DARIEN",
        "postalCode": "06820",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "203-656-0324",
        "latitude": "41.08088710000001",
        "longitude": "-73.4632288",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4253"
            }
          ]
        }
      },
      {
        "storeId": "215",
        "name": "PURE HOCKEY",
        "address1": "815 ROCKVILLE PIKE",
        "city": "ROCKVILLE",
        "postalCode": "20852",
        "stateCode": "MD",
        "countryCode": "US",
        "email": "rockville@purehockey.com",
        "phone": "301-444-4800",
        "latitude": "39.075518",
        "longitude": "-77.138158",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223194"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "463",
        "name": "BLUELINE SPORTS WEST",
        "address1": "2 HALSTEAD AVE.",
        "city": "HARRISON",
        "postalCode": "10528",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "914-820-9974",
        "latitude": "40.9619711",
        "longitude": "-73.7237659",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4253"
            }
          ]
        }
      },
      {
        "storeId": "567",
        "name": "FOR SPORTS LLC SFS",
        "address1": "50 SOUTHLAWN CT",
        "city": "ROCKVILLE",
        "postalCode": "20850",
        "stateCode": "MD",
        "countryCode": "US",
        "email": "hendrix1122@hotmail.com",
        "phone": "301-610-7500",
        "latitude": "39.1034718",
        "longitude": "-77.12928099999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224128"
            },
            {
              "attributeId": "soldToID",
              "text": "13112"
            }
          ]
        }
      },
      {
        "storeId": "532",
        "name": "OAKLAND ICE CENTER",
        "address1": "519 18TH STREET",
        "city": "OAKLAND",
        "postalCode": "94612",
        "stateCode": "CA",
        "countryCode": "US",
        "phone": "510-268-9000",
        "latitude": "37.80745539999999",
        "longitude": "-122.2715918",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "212496"
            },
            {
              "attributeId": "soldToID",
              "text": "5184"
            }
          ]
        }
      },
      {
        "storeId": "93",
        "name": "ICE VAULT ARENA SEC",
        "address1": "10 NEVINS DRIVE",
        "city": "WAYNE",
        "postalCode": "07470",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "973-628-1500",
        "latitude": "40.9645836",
        "longitude": "-74.2280206",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "12781"
            },
            {
              "attributeId": "soldToID",
              "text": "12781"
            }
          ]
        }
      },
      {
        "storeId": "1175",
        "name": "PLAY IT AGAIN SPORTS FARGO",
        "address1": "2501 45th STREET S",
        "city": "FARGO",
        "postalCode": "58104",
        "stateCode": "ND",
        "countryCode": "US",
        "latitude": "46.84158",
        "longitude": "-96.86263",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "15511"
            },
            {
              "attributeId": "soldToID",
              "text": "15511"
            }
          ]
        }
      },
      {
        "storeId": "195",
        "name": "MONKEYSPORTS INC",
        "address1": "1500 US HWY 9N",
        "city": "WOODBRIDGE",
        "postalCode": "07095",
        "stateCode": "NJ",
        "countryCode": "US",
        "email": "retail-nj@monkeysports.com",
        "phone": "732-634-1446",
        "latitude": "40.56223",
        "longitude": "-74.295819",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "payables@monkeysports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "15119"
            },
            {
              "attributeId": "soldToID",
              "text": "15119"
            }
          ]
        }
      },
      {
        "storeId": "13",
        "name": "PERFECT EDGE HOCKEY LLC SEC",
        "address1": "3621 E GRAND RIVER AVENUE",
        "city": "HOWELL",
        "postalCode": "48843",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "perfectedge@gmail.com",
        "phone": "517-546-1897",
        "latitude": "42.626662",
        "longitude": "-83.985789",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13962"
            },
            {
              "attributeId": "soldToID",
              "text": "13962"
            }
          ]
        }
      },
      {
        "storeId": "642",
        "name": "MANNY'S SPORTS",
        "address1": "1725 MENDON RD UNIT 106",
        "city": "CUMBERLAND",
        "postalCode": "02864",
        "stateCode": "RI",
        "countryCode": "US",
        "phone": "401-721-5990",
        "latitude": "41.943223",
        "longitude": "-71.434111",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213891"
            },
            {
              "attributeId": "soldToID",
              "text": "14654"
            }
          ]
        }
      },
      {
        "storeId": "472",
        "name": "SOUTH WINDSOR ARENA INC",
        "address1": "585 JOHN FITCH BLVD - RT5",
        "city": "SOUTH WINDSOR",
        "postalCode": "06074",
        "stateCode": "CT",
        "countryCode": "US",
        "email": "lenny@hockey1.com",
        "phone": "860-289-3401",
        "latitude": "41.845733",
        "longitude": "-72.600309",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6461"
            },
            {
              "attributeId": "soldToID",
              "text": "6461"
            }
          ]
        }
      },
      {
        "storeId": "595",
        "name": "SKATEWORLD SFS",
        "address1": "3185 LEEMAN FERRY ROAD",
        "city": "HUNTSVILLE",
        "postalCode": "35801",
        "stateCode": "AL",
        "countryCode": "US",
        "email": "sk8world@hiwaay.net",
        "phone": "256-880-7860",
        "latitude": "34.6962084",
        "longitude": "-86.5908037",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6428"
            },
            {
              "attributeId": "soldToID",
              "text": "6428"
            }
          ]
        }
      },
      {
        "storeId": "147",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "37150 VAN DYKE AVE",
        "city": "STERLING HEIGHTS",
        "postalCode": "48312",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "586-264-7860",
        "latitude": "42.569256",
        "longitude": "-83.028289",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211440"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "36",
        "name": "DAVES SPORT SHOP SEC",
        "address1": "13950 GROVE DR #200",
        "city": "MAPLE GROVE",
        "postalCode": "55311",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "sales@davessportsshop.biz",
        "phone": "763-420-8837",
        "latitude": "45.104011",
        "longitude": "-93.457496",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "14543"
            },
            {
              "attributeId": "soldToID",
              "text": "14543"
            }
          ]
        }
      },
      {
        "storeId": "INDY",
        "name": "Bauer Hockey Indianapolis",
        "address1": "2856 South Ronald Reagan Parkway",
        "city": "Indianapolis",
        "postalCode": "46231",
        "stateCode": "Indiana",
        "countryCode": "US",
        "latitude": "39.722652",
        "longitude": "-86.30895",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            }
          ]
        }
      },
      {
        "storeId": "234",
        "name": "PURE HOCKEY",
        "address1": "231 A GLEN COVE RD",
        "city": "CARLE PLACE",
        "postalCode": "11514",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "carleplace@purehockey.com",
        "phone": "516-742-0471",
        "latitude": "40.748866",
        "longitude": "-73.616919",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223178"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "223",
        "name": "PURE HOCKEY",
        "address1": "254 THF BLVD.",
        "city": "CHESTERFIELD",
        "postalCode": "63005",
        "stateCode": "MO",
        "countryCode": "US",
        "email": "chesterfield@purehockey.com",
        "phone": "636-537-4882",
        "latitude": "38.666233",
        "longitude": "-90.599797",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223203"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "95",
        "name": "ASPEN ICE INC.",
        "address1": "16 ASPEN DRIVE",
        "city": "RANDOLPH",
        "postalCode": "07869",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "973-927-9122",
        "latitude": "40.8587988",
        "longitude": "-74.6184814",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "13191"
            },
            {
              "attributeId": "soldToID",
              "text": "13191"
            }
          ]
        }
      },
      {
        "storeId": "250",
        "name": "PURE HOCKEY",
        "address1": "2355 W BROADWAY",
        "city": "MONONA",
        "postalCode": "53713",
        "stateCode": "WI",
        "countryCode": "US",
        "email": "monona@purehockey.com",
        "phone": "608-709-0040",
        "latitude": "43.0446",
        "longitude": "-89.35152",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222797"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "1174",
        "name": "PURE HOCKEY",
        "address1": "375 Amherst Street Somerset Plaza Unit 2",
        "city": "Nashua",
        "postalCode": "03060",
        "stateCode": "New Hampshire",
        "countryCode": "US",
        "email": "nashua@purehockey.com",
        "phone": "603-598-9008",
        "latitude": "42.78523",
        "longitude": "-71.50621",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "223170"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "241",
        "name": "PURE HOCKEY",
        "address1": "1155 WASHINGTON PIKE UNIT #11",
        "city": "BRIDGEVILLE",
        "postalCode": "15017",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "bridgeville@purehockey.com",
        "phone": "412-564-5135",
        "latitude": "40.368852",
        "longitude": "-80.104699",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223173"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "83",
        "name": "AMITY HARBOR SPORTS SEC",
        "address1": "149 MERRICK ROAD",
        "city": "AMITYVILLE",
        "postalCode": "11701",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "amitysports@optonline.net",
        "phone": "631-691-7505",
        "latitude": "40.670868",
        "longitude": "-73.416788",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4056"
            },
            {
              "attributeId": "soldToID",
              "text": "4056"
            }
          ]
        }
      },
      {
        "storeId": "471",
        "name": "GATEWAY HARDWARE INC",
        "address1": "125 CAPITAL DRIVE",
        "city": "WEST SPRINGFIELD",
        "postalCode": "01089",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "413-746-0512",
        "latitude": "42.138409",
        "longitude": "-72.62022499999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4904"
            }
          ]
        }
      },
      {
        "storeId": "474",
        "name": "BERTELLI'S SKATE SHOP SEC",
        "address1": "726 MAIN ST",
        "city": "WEST SPRINGFIELD",
        "postalCode": "01089",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "413-736-0633",
        "latitude": "42.100357",
        "longitude": "-72.606554",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6772"
            }
          ]
        }
      },
      {
        "storeId": "656",
        "name": "TOTAL SPORTS REPAIR INC. SEC",
        "address1": "315 TURNPIKE ROAD",
        "city": "NORTH ANDOVER",
        "postalCode": "01845",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "978 655-4629",
        "latitude": "42.6677049",
        "longitude": "-71.12257050000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9802"
            }
          ]
        }
      },
      {
        "storeId": "630",
        "name": "JOHNNY MAC'S SPTG GOODS SEC",
        "address1": "2715 N HWY 67",
        "city": "FLORISSANT",
        "postalCode": "63033",
        "stateCode": "MO",
        "countryCode": "US",
        "phone": "314.838.1888",
        "latitude": "38.806906",
        "longitude": "-90.3041435",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5291"
            }
          ]
        }
      },
      {
        "storeId": "598",
        "name": "FIVE HOLE SPORTS SFS",
        "address1": "4705 INDIAN TRAIL-FAIRVIEW",
        "city": "INDIAN TRAIL",
        "postalCode": "28079",
        "stateCode": "NC",
        "countryCode": "US",
        "email": "andrew@fiveholesports.com",
        "phone": "704-882-1830",
        "latitude": "35.09192609999999",
        "longitude": "-80.6522873",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213442"
            },
            {
              "attributeId": "soldToID",
              "text": "14736"
            }
          ]
        }
      },
      {
        "storeId": "526",
        "name": "ST CLOUD SCHEELS",
        "address1": "40 NORTH WAITE AVE",
        "city": "WAITE PARK",
        "postalCode": "56387",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "320-252-9494",
        "latitude": "45.5558916",
        "longitude": "-94.2116542",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "213665"
            },
            {
              "attributeId": "soldToID",
              "text": "15680"
            }
          ]
        }
      },
      {
        "storeId": "77",
        "name": "FAMILY SPORTS PRO SHOP",
        "address1": "6901 S. PEORIA",
        "city": "CENTENNIAL",
        "postalCode": "80112",
        "stateCode": "CO",
        "countryCode": "US",
        "email": "MarvinS@ssprd.org",
        "phone": "303.649.1115",
        "latitude": "39.583256",
        "longitude": "-104.845108",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "13654"
            },
            {
              "attributeId": "soldToID",
              "text": "13654"
            }
          ]
        }
      },
      {
        "storeId": "625",
        "name": "JOHNNY MAC'S SPTG GOODS SEC",
        "address1": "3500 L SO GLENSTONE ROAD",
        "city": "SPRINGFIELD",
        "postalCode": "65804",
        "stateCode": "MO",
        "countryCode": "US",
        "email": "amorse@johnnymacs.com",
        "phone": "417.799.2600",
        "latitude": "37.1491913",
        "longitude": "-93.2560776",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221319"
            },
            {
              "attributeId": "soldToID",
              "text": "5291"
            }
          ]
        }
      },
      {
        "storeId": "169",
        "name": "B & R SPORTING GOODS",
        "address1": "20000 STEPHENS STREET",
        "city": "SAINT CLAIR SHORES",
        "postalCode": "48080",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "586-772-7941",
        "latitude": "42.47164739999999",
        "longitude": "-82.91404179999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "213299"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "221",
        "name": "PURE HOCKEY",
        "address1": "14150 NICOLLET AVE S",
        "city": "BURNSVILLE",
        "postalCode": "55337",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "burnsville@purehockey.com",
        "phone": "952-303-3594",
        "latitude": "44.747282",
        "longitude": "-93.278613",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223196"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "21",
        "name": "DAVE'S SPORT SHOP INC SEC",
        "address1": "10517 NASSAU STREET NE",
        "city": "BLAINE",
        "postalCode": "55449",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "763-780-0078",
        "latitude": "45.161292",
        "longitude": "-93.217304",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4632"
            }
          ]
        }
      },
      {
        "storeId": "197",
        "name": "PURE HOCKEY",
        "address1": "517 E KATELLA AVE",
        "city": "ANAHEIM",
        "postalCode": "92805",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "anaheim@purehockey.com",
        "phone": "714-300-0708",
        "latitude": "33.803768",
        "longitude": "-117.899909",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222787"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "563",
        "name": "COMCAST SPECTACOR SEC",
        "address1": "501 N ALBANY AVE",
        "city": "ATLANTIC CITY",
        "postalCode": "08401",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "609-441-1780",
        "latitude": "39.3573807",
        "longitude": "-74.4583329",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9951"
            }
          ]
        }
      },
      {
        "storeId": "587",
        "name": "ATLANTA ICEPLEX",
        "address1": "2300 SATELLITE BLVD",
        "city": "DULUTH",
        "postalCode": "30097",
        "stateCode": "GA",
        "countryCode": "US",
        "phone": "770-813-1010",
        "latitude": "33.9779218",
        "longitude": "-84.0932014",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4090"
            }
          ]
        }
      },
      {
        "storeId": "654",
        "name": "TOTAL SPORTS REPAIR INC. SEC",
        "address1": "7 PARKRIDGE ROAD",
        "city": "HAVERHILL",
        "postalCode": "01835",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "978 702-4801",
        "latitude": "42.76493079999999",
        "longitude": "-71.1123578",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9802"
            }
          ]
        }
      },
      {
        "storeId": "1300",
        "name": "PURE HOCKEY CLIFTON PARK",
        "address1": "54 CROSSING BLVD SUITE 13",
        "city": "CLIFTON PARK",
        "postalCode": "12065",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "cliftonpark@purehockey.com",
        "latitude": "42.860428",
        "longitude": "-73.77009",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222795"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "599",
        "name": "FIVE HOLE SPORTS SFS",
        "address1": "1839 S MAIN STREET",
        "city": "WAKE FOREST",
        "postalCode": "27587",
        "stateCode": "NC",
        "countryCode": "US",
        "email": "andrew@fiveholesports.com",
        "phone": "919-453-1508",
        "latitude": "35.951665",
        "longitude": "-78.527291",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223612"
            },
            {
              "attributeId": "soldToID",
              "text": "14736"
            }
          ]
        }
      },
      {
        "storeId": "222",
        "name": "PURE HOCKEY",
        "address1": "1237 S KIRKWOOD",
        "city": "KIRKWOOD",
        "postalCode": "63122",
        "stateCode": "MO",
        "countryCode": "US",
        "email": "kirkwood@purehockey.com",
        "phone": "314-835-9131",
        "latitude": "38.562773",
        "longitude": "-90.408534",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223204"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "470",
        "name": "GATEWAY HARDWARE INC",
        "address1": "150 BOSTON ROAD",
        "city": "SPRINGFIELD",
        "postalCode": "01109",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "gatewayhardware@gmail.com",
        "phone": "413-782-4636",
        "latitude": "42.1256223",
        "longitude": "-72.5350983",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4904"
            },
            {
              "attributeId": "soldToID",
              "text": "4904"
            }
          ]
        }
      },
      {
        "storeId": "232",
        "name": "PURE HOCKEY",
        "address1": "1000 HYLAN DRIVE",
        "city": "ROCHESTER",
        "postalCode": "14623",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "rochester@purehockey.com",
        "phone": "585-978-7352",
        "latitude": "43.080717",
        "longitude": "-77.628233",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221761"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "205",
        "name": "PURE HOCKEY",
        "address1": "2751 PFINGSTEN ROAD",
        "city": "GLENVIEW",
        "postalCode": "60026",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "glenview@purehockey.com",
        "phone": "847-272-8930",
        "latitude": "42.1041",
        "longitude": "-87.846886",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223199"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "157",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "5711 BAY ROAD",
        "city": "SAGINAW",
        "postalCode": "48604",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "989-799-5604",
        "latitude": "43.491082",
        "longitude": "-83.974755",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211491"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "513",
        "name": "CLAFTON SKATE",
        "address1": "1932 GLENWOOD DR",
        "city": "GRAND RAPIDS",
        "postalCode": "55744",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "claftons@paulbunyan.net",
        "phone": "218-326-1571",
        "latitude": "47.2380503",
        "longitude": "-93.49388979999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4604"
            },
            {
              "attributeId": "soldToID",
              "text": "4604"
            }
          ]
        }
      },
      {
        "storeId": "628",
        "name": "JOHNNY MAC'S SPTG GOODS SEC",
        "address1": "1928 STAR BATT DRIVE SUITE E",
        "city": "ROCHESTER HILLS",
        "postalCode": "48309",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "248.852.2700",
        "latitude": "42.64836349999999",
        "longitude": "-83.1688361",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5291"
            }
          ]
        }
      },
      {
        "storeId": "464",
        "name": "FERGUSONS CENTER ICE SPORTS",
        "address1": "123 GLENWOOD AVE.",
        "city": "BRIDGEPORT",
        "postalCode": "06610",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "203-338-0202",
        "latitude": "41.2057072",
        "longitude": "-73.1882462",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4420"
            }
          ]
        }
      },
      {
        "storeId": "523",
        "name": "DUFFY'S HOCKEY AND SPORTS",
        "address1": "216 WEST FRONT AVENUE",
        "city": "BISMARCK",
        "postalCode": "58504",
        "stateCode": "ND",
        "countryCode": "US",
        "email": "duffy@srt.com",
        "phone": "701-223-4008",
        "latitude": "46.80457850000001",
        "longitude": "-100.7927024",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212360"
            },
            {
              "attributeId": "soldToID",
              "text": "13764"
            }
          ]
        }
      },
      {
        "storeId": "90",
        "name": "KOSPORTS INC. SFS",
        "address1": "103 MARSHALL DRIVE",
        "city": "PITTSBURGH",
        "postalCode": "15086",
        "stateCode": "PA",
        "countryCode": "US",
        "phone": "724-252-4804",
        "latitude": "40.5054082",
        "longitude": "-79.91299529999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5420"
            }
          ]
        }
      },
      {
        "storeId": "78",
        "name": "HOCKEYWOLF",
        "address1": "1010 NORTH AVE WEST",
        "city": "MISSOULA",
        "postalCode": "59801",
        "stateCode": "MT",
        "countryCode": "US",
        "email": "travermt@gmail.com",
        "phone": "406.239.5395",
        "latitude": "46.852744",
        "longitude": "-114.013884",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "15420"
            },
            {
              "attributeId": "soldToID",
              "text": "15420"
            }
          ]
        }
      },
      {
        "storeId": "627",
        "name": "JOHNNY MAC'S SPTG GOODS SEC",
        "address1": "4255 FIVE OAKS DRIVE",
        "city": "LANSING",
        "postalCode": "48911",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "517.393.2221",
        "latitude": "42.6814093",
        "longitude": "-84.51410820000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5291"
            }
          ]
        }
      },
      {
        "storeId": "561",
        "name": "COMCAST SPECTACOR SEC",
        "address1": "601 LAUREL OAK ROAD",
        "city": "VOORHEES",
        "postalCode": "08043",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "856-309-4400",
        "latitude": "39.8428922",
        "longitude": "-74.9823258",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9951"
            }
          ]
        }
      },
      {
        "storeId": "216",
        "name": "PURE HOCKEY",
        "address1": "43111 CRESCENT BLVD",
        "city": "NOVI",
        "postalCode": "48375",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "novi@purehockey.com",
        "phone": "248-344-1061",
        "latitude": "42.484526",
        "longitude": "-83.471022",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223208"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "649",
        "name": "PLAY IT AGAIN SPORTS #5942",
        "address1": "473 ALFRED ST - STE 101",
        "city": "BIDDEFORD",
        "postalCode": "04005",
        "stateCode": "ME",
        "countryCode": "US",
        "phone": "207 602-6007",
        "latitude": "43.4792965",
        "longitude": "-70.487209",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5942"
            }
          ]
        }
      },
      {
        "storeId": "9",
        "name": "RG HOCKEY SOURCE FOR SPORTS",
        "address1": "1581 W NORMANTOWN RD",
        "city": "ROMEOVILLE",
        "postalCode": "60446",
        "stateCode": "IL",
        "countryCode": "US",
        "phone": "815-372-9423",
        "latitude": "41.646512",
        "longitude": "-88.140271",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "213830"
            },
            {
              "attributeId": "soldToID",
              "text": "4591"
            }
          ]
        }
      },
      {
        "storeId": "41",
        "name": "ZERO CELSIUS",
        "address1": "27745 SMYTH DRIVE",
        "city": "VALENCIA",
        "postalCode": "91355",
        "stateCode": "CA",
        "countryCode": "US",
        "phone": "661-294-8068",
        "latitude": "34.43879",
        "longitude": "-118.565402",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "12821"
            },
            {
              "attributeId": "soldToID",
              "text": "12821"
            }
          ]
        }
      },
      {
        "storeId": "42",
        "name": "PLAY IT AGAIN SPORTS",
        "address1": "9999 MIRA MESA BLVD STE-102",
        "city": "SAN DIEGO",
        "postalCode": "92131",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "pias.sandiego@gmail.com",
        "phone": "858-695-3030",
        "latitude": "32.91633",
        "longitude": "-117.111737",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13411"
            },
            {
              "attributeId": "soldToID",
              "text": "13411"
            }
          ]
        }
      },
      {
        "storeId": "590",
        "name": "INCREDIBLE ICE SFS",
        "address1": "3299 SPORTSPLEX DRIVE",
        "city": "CORAL SPRINGS",
        "postalCode": "33065",
        "stateCode": "FL",
        "countryCode": "US",
        "phone": "954-341-9956",
        "latitude": "26.270821",
        "longitude": "-80.292233",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5239"
            },
            {
              "attributeId": "soldToID",
              "text": "5239"
            }
          ]
        }
      },
      {
        "storeId": "468",
        "name": "CHESHIRE BIKE & SPORT SEC",
        "address1": "34 WALLINGFORD ROAD",
        "city": "CHESHIRE",
        "postalCode": "06410",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "203-272-3451",
        "latitude": "41.49705890000001",
        "longitude": "-72.90081430000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4439"
            }
          ]
        }
      },
      {
        "storeId": "92",
        "name": "ICE CASTLE INC",
        "address1": "990 CASTLE SHANNON BLVD",
        "city": "PITTSBURGH",
        "postalCode": "15234",
        "stateCode": "PA",
        "countryCode": "US",
        "phone": "412-561-9090",
        "latitude": "40.3660903",
        "longitude": "-80.0265822",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "11062"
            },
            {
              "attributeId": "soldToID",
              "text": "11062"
            }
          ]
        }
      },
      {
        "storeId": "86",
        "name": "BOB PECKS SKATE & SPT",
        "address1": "31 LAKE ST",
        "city": "WHITE PLAINS",
        "postalCode": "10603",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "914-949-0579",
        "latitude": "41.0377975",
        "longitude": "-73.7606334",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4257"
            },
            {
              "attributeId": "soldToID",
              "text": "4257"
            }
          ]
        }
      },
      {
        "storeId": "17",
        "name": "PERFECT EDGE",
        "address1": "2755 ARENA DR",
        "city": "HARTLAND",
        "postalCode": "48353",
        "stateCode": "MI",
        "countryCode": "US",
        "latitude": "42.639906",
        "longitude": "-83.7303732",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "13962"
            }
          ]
        }
      },
      {
        "storeId": "614",
        "name": "GUNZO'S SPORT CENTER",
        "address1": "7706 MADISON",
        "city": "RIVER FOREST",
        "postalCode": "60305",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "gunzosinfo@gunzos.com",
        "phone": "708-771-8666",
        "latitude": "41.879617",
        "longitude": "-87.816555",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5024"
            },
            {
              "attributeId": "soldToID",
              "text": "5024"
            }
          ]
        }
      },
      {
        "storeId": "151",
        "name": "BOB PERANIS SPORT SHOP",
        "address1": "24126 LORAIN RD",
        "city": "NORTH OLMSTED",
        "postalCode": "44070",
        "stateCode": "OH",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "440-979-9700",
        "latitude": "41.430197",
        "longitude": "-81.889853",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211488"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "637",
        "name": "KEVIN SMITH SPORTS CONNECTION SFS",
        "address1": "1174 WILLISTON ROAD",
        "city": "SOUTH BURLINGTON",
        "postalCode": "05403",
        "stateCode": "VT",
        "countryCode": "US",
        "email": "Kevin@KevinSmithSports.com",
        "phone": "802-658-0848",
        "latitude": "44.468375",
        "longitude": "-73.176879",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211713"
            },
            {
              "attributeId": "soldToID",
              "text": "5367"
            }
          ]
        }
      },
      {
        "storeId": "1195",
        "name": "HOCKEY MONKEY",
        "address1": "6578 S. Yosemite Cir",
        "city": "GREENWOOD VILLAGE",
        "postalCode": "80111",
        "stateCode": "CO",
        "countryCode": "US",
        "phone": "303-615-3734",
        "latitude": "39.59673",
        "longitude": "-104.88708",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19226"
            },
            {
              "attributeId": "soldToID",
              "text": "19226"
            }
          ]
        }
      },
      {
        "storeId": "164",
        "name": "B & R SPORTING GOODS",
        "address1": "1819 EAST BIG BEAVER ROAD",
        "city": "TROY",
        "postalCode": "48083",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jeffbielecki@yahoo.com",
        "phone": "248-526-7941",
        "latitude": "42.56534",
        "longitude": "-83.111783",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "203715"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "87",
        "name": "KOSPORTS INC. SFS",
        "address1": "2588 WASHINGTON ROAD",
        "city": "CANONSBURG",
        "postalCode": "15317",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "curt@kosports.com",
        "phone": "724-745-5801",
        "latitude": "40.254324",
        "longitude": "-80.157538",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5420"
            },
            {
              "attributeId": "soldToID",
              "text": "5420"
            }
          ]
        }
      },
      {
        "storeId": "589",
        "name": "CAROLINA ICE PALACE LLC",
        "address1": "7665 NORTHWOODS BLVD",
        "city": "N CHARLESTON",
        "postalCode": "29406",
        "stateCode": "SC",
        "countryCode": "US",
        "email": "jwilliams@carolinaicepalace.com",
        "phone": "843-572-2717 x 14",
        "latitude": "32.9399894",
        "longitude": "-80.0487771",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4613"
            },
            {
              "attributeId": "soldToID",
              "text": "4613"
            }
          ]
        }
      },
      {
        "storeId": "1197",
        "name": "HOCKEY MONKEY",
        "address1": "1962 Barranca Parkway",
        "city": "IRVINE",
        "postalCode": "92606",
        "stateCode": "CA",
        "countryCode": "US",
        "phone": "714-887-7973",
        "latitude": "33.70114",
        "longitude": "-117.83782",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "214227"
            },
            {
              "attributeId": "soldToID",
              "text": "7422"
            }
          ]
        }
      },
      {
        "storeId": "219",
        "name": "PURE HOCKEY",
        "address1": "14200 WAYZATA BOULEVARD",
        "city": "MINNETONKA",
        "postalCode": "55305",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "minnetonka@purehockey.com",
        "phone": "763-208-3494",
        "latitude": "44.972882",
        "longitude": "-93.457092",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223197"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "520",
        "name": "THE HOCKEY HEADQUARTERS",
        "address1": "4024 N HERCULES AVE",
        "city": "SIOUX FALLS",
        "postalCode": "57107",
        "stateCode": "SD",
        "countryCode": "US",
        "email": "stickshack@earthlink.net",
        "phone": "605-366-7131",
        "latitude": "43.5907402",
        "longitude": "-96.757725",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13668"
            },
            {
              "attributeId": "soldToID",
              "text": "13668"
            }
          ]
        }
      },
      {
        "storeId": "633",
        "name": "FRED'S PRO SHOP",
        "address1": "935 LAKE VIEW PKWY - STE 111",
        "city": "VERNON HILLS",
        "postalCode": "60061",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "fredsproshop@sbcglobal.net",
        "phone": "847-247-6066",
        "latitude": "42.242533",
        "longitude": "-87.956836",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7361"
            },
            {
              "attributeId": "soldToID",
              "text": "7361"
            }
          ]
        }
      },
      {
        "storeId": "217",
        "name": "PURE HOCKEY",
        "address1": "686 EAST BIG BEAVER",
        "city": "TROY",
        "postalCode": "48083",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "troy1@purehockey.com",
        "phone": "248-528-2003",
        "latitude": "42.560849",
        "longitude": "-83.133969",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223206"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "29",
        "name": "WESTWOOD SPORTS INC SEC",
        "address1": "14805 GRANADA AVE",
        "city": "APPLE VALLEY",
        "postalCode": "55124",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "952-431-5590",
        "latitude": "44.734789",
        "longitude": "-93.221927",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7180"
            },
            {
              "attributeId": "soldToID",
              "text": "7180"
            }
          ]
        }
      },
      {
        "storeId": "623",
        "name": "JERRY'S HOCKEY",
        "address1": "1501 FEEHANVILLE DR",
        "city": "MT. PROSPECT",
        "postalCode": "60056",
        "stateCode": "IL",
        "countryCode": "US",
        "phone": "847-493-8696",
        "latitude": "42.074806",
        "longitude": "-87.912724",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "5279"
            }
          ]
        }
      },
      {
        "storeId": "622",
        "name": "JERRY'S HOCKEY",
        "address1": "1996 S. KIRK RD",
        "city": "GENEVA",
        "postalCode": "60134",
        "stateCode": "IL",
        "countryCode": "US",
        "phone": "630-313-8038",
        "latitude": "41.873158",
        "longitude": "-88.280026",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5279"
            }
          ]
        }
      },
      {
        "storeId": "25",
        "name": "LETTERMEN SPORTS",
        "address1": "9199 CENTRAL AVENUE NORTH",
        "city": "BLAINE",
        "postalCode": "55434",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "nick@lettermensports.com",
        "phone": "763-780-8077",
        "latitude": "45.137118",
        "longitude": "-93.234068",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5464"
            },
            {
              "attributeId": "soldToID",
              "text": "5464"
            }
          ]
        }
      },
      {
        "storeId": "541",
        "name": "THE HOCKEY SOURCE LLC",
        "address1": "6501 W GRANDRIDGE BLVD STE E",
        "city": "KENNEWICK",
        "postalCode": "99336",
        "stateCode": "WA",
        "countryCode": "US",
        "phone": "509-737-0515",
        "latitude": "46.221119",
        "longitude": "-119.212896",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "13818"
            }
          ]
        }
      },
      {
        "storeId": "564",
        "name": "COMCAST SPECTACOR SEC",
        "address1": "10990 DECATUR ROAD",
        "city": "PHILADELPHIA",
        "postalCode": "19154",
        "stateCode": "PA",
        "countryCode": "US",
        "phone": "215-618-0060",
        "latitude": "40.0934863",
        "longitude": "-74.99069779999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9951"
            }
          ]
        }
      },
      {
        "storeId": "529",
        "name": "CHAMPION'S CHOICE",
        "address1": "3901 OLD SEWARD HWY",
        "city": "ANCHORAGE",
        "postalCode": "99503",
        "stateCode": "AK",
        "countryCode": "US",
        "email": "rayblackadar@yahoo.com",
        "phone": "907-563-3503",
        "latitude": "61.185128",
        "longitude": "-149.865152",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4428"
            },
            {
              "attributeId": "soldToID",
              "text": "4428"
            }
          ]
        }
      },
      {
        "storeId": "236",
        "name": "PURE HOCKEY",
        "address1": "2015 WALDEN AVE 1A",
        "city": "CHEEKTOWAGA",
        "postalCode": "14225",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "buffalo@purehockey.com",
        "phone": "716-989-0881",
        "latitude": "42.907376",
        "longitude": "-78.761347",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222799"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "243",
        "name": "PURE HOCKEY",
        "address1": "1800 POST RD",
        "city": "WARWICK",
        "postalCode": "02886",
        "stateCode": "RI",
        "countryCode": "US",
        "email": "warwick@purehockey.com",
        "phone": "401-732-3914",
        "latitude": "41.731305",
        "longitude": "-71.435198",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223182"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "44",
        "name": "GOLDEN EDGE SPORTS",
        "address1": "12455 KERRAN ST",
        "city": "POWAY",
        "postalCode": "92064",
        "stateCode": "CA",
        "countryCode": "US",
        "phone": "858-668-8083",
        "latitude": "32.939816",
        "longitude": "-117.0531122",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19139"
            },
            {
              "attributeId": "soldToID",
              "text": "19139"
            }
          ]
        }
      },
      {
        "storeId": "517",
        "name": "PLAY IT AGAIN SPORTS",
        "address1": "1668 MADISON AVE",
        "city": "MANKATO",
        "postalCode": "56001",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "507-625-2000",
        "latitude": "44.167656",
        "longitude": "-93.961115",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "11178"
            }
          ]
        }
      },
      {
        "storeId": "198",
        "name": "PURE HOCKEY",
        "address1": "1290 TULLY RD SUITE 50",
        "city": "SAN JOSE",
        "postalCode": "95122",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "sanjose@purehockey.com",
        "phone": "408-550-7087",
        "latitude": "37.31569",
        "longitude": "-121.83484",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222793"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "159",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "52999 DEQUINDRE ROAD",
        "city": "ROCHESTER",
        "postalCode": "48307",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "248-651-4943",
        "latitude": "42.681659",
        "longitude": "-83.095846",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213478"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "641",
        "name": "2ND TIME AROUND SPORTS PLUS SEC",
        "address1": "453 ATWOOD AVE",
        "city": "CRANSTON",
        "postalCode": "02920",
        "stateCode": "RI",
        "countryCode": "US",
        "email": "BauerOrders@gmail.com",
        "phone": "401-944-9380",
        "latitude": "41.788307",
        "longitude": "-71.471708",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "14654"
            },
            {
              "attributeId": "soldToID",
              "text": "14654"
            }
          ]
        }
      },
      {
        "storeId": "566",
        "name": "FOR SPORTS LLC SFS",
        "address1": "13800 OLD GUNPOWDER ROAD",
        "city": "LAUREL",
        "postalCode": "20707",
        "stateCode": "MD",
        "countryCode": "US",
        "email": "hendrix1122@hotmail.com",
        "phone": "301-604-8200",
        "latitude": "39.078777",
        "longitude": "-76.921631",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13112"
            },
            {
              "attributeId": "soldToID",
              "text": "13112"
            }
          ]
        }
      },
      {
        "storeId": "114",
        "name": "BLACK KNIGHTS SPORTS & ENTERTAINMEN",
        "address1": "1550 SOUTH PAVILION CENTER DR",
        "city": "LAS VEGAS",
        "postalCode": "89135",
        "stateCode": "NV",
        "countryCode": "US",
        "phone": "702-790-2676",
        "latitude": "36.154155",
        "longitude": "-115.329769",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19479"
            },
            {
              "attributeId": "soldToID",
              "text": "19479"
            }
          ]
        }
      },
      {
        "storeId": "144",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "7325 EAST 96TH ST.",
        "city": "INDIANAPOLIS",
        "postalCode": "46250",
        "stateCode": "IN",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "317-288-5210",
        "latitude": "39.925537",
        "longitude": "-86.038219",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222469"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "16",
        "name": "HOCKEYDEALS.COM",
        "address1": "42400 ARENA DR",
        "city": "NOVI",
        "postalCode": "48375",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "248-380-5633",
        "latitude": "42.4601225",
        "longitude": "-83.4685313",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "213002"
            },
            {
              "attributeId": "soldToID",
              "text": "14956"
            }
          ]
        }
      },
      {
        "storeId": "477",
        "name": "WHITIE BENSEN ATL EQP INC SFS",
        "address1": "38 SAWMILL ROAD",
        "city": "WEST HAVEN",
        "postalCode": "06516",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "203-932-0035",
        "latitude": "41.2708089",
        "longitude": "-72.95986669999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "7188"
            }
          ]
        }
      },
      {
        "storeId": "1191",
        "name": "PURE HOCKEY",
        "address1": "10130 DAVENPORT STREET NE",
        "city": "BLAINE",
        "postalCode": "55449",
        "stateCode": "MN",
        "countryCode": "US",
        "latitude": "45.164434",
        "longitude": "-93.230022",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "shipToID",
              "text": "224178"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "239",
        "name": "PURE HOCKEY",
        "address1": "782B BETHLEHEM PIKE",
        "city": "NORTH WALES",
        "postalCode": "19454",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "northwales@purehockey.com",
        "phone": "215-855-8710",
        "latitude": "40.23945",
        "longitude": "-75.244169",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223207"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "1194",
        "name": "HOCKEY MONKEY",
        "address1": "949 Providence Highway",
        "city": "NORWOOD",
        "postalCode": "07095",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "781-769-1754",
        "latitude": "42.14071",
        "longitude": "-71.2186",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "15451"
            },
            {
              "attributeId": "soldToID",
              "text": "15451"
            }
          ]
        }
      },
      {
        "storeId": "212",
        "name": "PURE HOCKEY",
        "address1": "187 SUMMER ST",
        "city": "KINGSTON",
        "postalCode": "02364",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "kingston@purehockey.com",
        "phone": "781-582-1329",
        "latitude": "42.011966",
        "longitude": "-70.730135",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223176"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "33",
        "name": "CENTER ICE SKATE & SPORT INC SFS",
        "address1": "401 EAST LAKESHORE DRIVE",
        "city": "HOUGHTON",
        "postalCode": "49931",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "906-482-3438",
        "latitude": "47.12171350000001",
        "longitude": "-88.57670900000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "210848"
            },
            {
              "attributeId": "soldToID",
              "text": "12761"
            }
          ]
        }
      },
      {
        "storeId": "146",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "19330 MIDDLEBELT RD",
        "city": "LIVONIA",
        "postalCode": "48152",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "248-476-8100",
        "latitude": "42.429472",
        "longitude": "-83.334016",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211439"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "213",
        "name": "PURE HOCKEY",
        "address1": "739 DONALD J LYNCH BLVD",
        "city": "MARLBOROUGH",
        "postalCode": "01752",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "marlborough@purehockey.com",
        "phone": "508-460-0306",
        "latitude": "42.352967",
        "longitude": "-71.617466",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223179"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "518",
        "name": "PLAY IT AGAIN SPORTS",
        "address1": "1256 W ARROWHEAD RD",
        "city": "DULUTH",
        "postalCode": "55811",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "218-724-1700",
        "latitude": "46.821248",
        "longitude": "-92.096695",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "11359"
            }
          ]
        }
      },
      {
        "storeId": "22",
        "name": "GENERAL SPORTS CORP SEC",
        "address1": "7505 IKOLA WAY",
        "city": "EDINA",
        "postalCode": "55439",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "mhaapala@generalsports.us",
        "phone": "612-925-1333",
        "latitude": "44.869284",
        "longitude": "-93.395255",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222978"
            },
            {
              "attributeId": "soldToID",
              "text": "4907"
            }
          ]
        }
      },
      {
        "storeId": "514",
        "name": "GERRELLS SPORTS CTR INC",
        "address1": "1004 SO WASHINGTON ST",
        "city": "GRAND FORKS",
        "postalCode": "58201",
        "stateCode": "ND",
        "countryCode": "US",
        "email": "eknudson@gerrells.net",
        "phone": "701-775-0553",
        "latitude": "47.911922",
        "longitude": "-97.045521",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4914"
            },
            {
              "attributeId": "soldToID",
              "text": "4914"
            }
          ]
        }
      },
      {
        "storeId": "636",
        "name": "BUTLER SPT GOODS SEC",
        "address1": "815 WEST MAIN STREET",
        "city": "HYANNIS",
        "postalCode": "02601",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "samfedele@butlersportinggoods.com",
        "phone": "508-771-4595",
        "latitude": "41.6542584",
        "longitude": "-70.32437469999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4289"
            },
            {
              "attributeId": "soldToID",
              "text": "4289"
            }
          ]
        }
      },
      {
        "storeId": "615",
        "name": "GUNZO'S SPORT CENTER",
        "address1": "6730 W DEMPSTER",
        "city": "MORTON GROVE",
        "postalCode": "60053",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "gunzosinfo@gunzos.com",
        "phone": "847-965-2300",
        "latitude": "42.041103",
        "longitude": "-87.794709",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212421"
            },
            {
              "attributeId": "soldToID",
              "text": "5024"
            }
          ]
        }
      },
      {
        "storeId": "220",
        "name": "PURE HOCKEY",
        "address1": "4210 WEST 78TH STREET",
        "city": "EDINA",
        "postalCode": "55435",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "edina@purehockey.com",
        "phone": "952-831-0021",
        "latitude": "44.86063",
        "longitude": "-93.331887",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223195"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "230",
        "name": "PURE HOCKEY",
        "address1": "2100 ROUTE 38 AND MALL DRIVE",
        "city": "CHERRY HILL",
        "postalCode": "08002",
        "stateCode": "NJ",
        "countryCode": "US",
        "email": "cherryhill@purehockey.com",
        "phone": "856-324-6617",
        "latitude": "39.941554",
        "longitude": "-75.019677",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222791"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "165",
        "name": "B & R SPORTING GOODS",
        "address1": "566 100TH STREET SOUTHWEST",
        "city": "BYRON CENTER",
        "postalCode": "49315",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jeffbielecki@yahoo.com",
        "phone": "616-877-4833",
        "latitude": "42.782666",
        "longitude": "-85.677205",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213790"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "206",
        "name": "BAUER HOCKEY EXPERIENCE/PURE HOCKEY",
        "address1": "240 MIDDLESEX TURNPIKE",
        "city": "BURLINGTON",
        "postalCode": "01803",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "burlington@purehockey.com",
        "phone": "781-365-1664",
        "latitude": "42.500705",
        "longitude": "-71.229973",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221313"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "245",
        "name": "PURE HOCKEY",
        "address1": "5993 SOUTH STATE STREET",
        "city": "MURRAY",
        "postalCode": "84107",
        "stateCode": "UT",
        "countryCode": "US",
        "email": "murray@purehockey.com",
        "phone": "801-281-2800",
        "latitude": "40.640358",
        "longitude": "-111.888138",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223190"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "572",
        "name": "HOCKEY PLUS",
        "address1": "994 BRIARSDALE ROAD",
        "city": "HARRISBURG",
        "postalCode": "17109",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "goaliesplus@yahoo.com",
        "phone": "800-599-2440",
        "latitude": "40.275005",
        "longitude": "-76.821546",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19318"
            },
            {
              "attributeId": "soldToID",
              "text": "19318"
            }
          ]
        }
      },
      {
        "storeId": "136",
        "name": "LOCKER ROOM SPORTS, INC",
        "address1": "2184 W RIDGE ROAD",
        "city": "ROCHESTER",
        "postalCode": "14626",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "lockerroomsports@aol.com",
        "phone": "585-723-8550",
        "latitude": "43.2087409",
        "longitude": "-77.68598279999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5469"
            },
            {
              "attributeId": "soldToID",
              "text": "5469"
            }
          ]
        }
      },
      {
        "storeId": "661",
        "name": "COOKE'S SKATE SUPPLY INC. SEC",
        "address1": "34 MASS AVE",
        "city": "BOXBORO",
        "postalCode": "01719",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "978 657-4087",
        "latitude": "42.3504042",
        "longitude": "-71.0890806",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "13742"
            }
          ]
        }
      },
      {
        "storeId": "568",
        "name": "KETTLER CAPITALS ICEPLEX",
        "address1": "627 N GLEBE RD STE 800",
        "city": "ARLINGTON",
        "postalCode": "22203",
        "stateCode": "VA",
        "countryCode": "US",
        "phone": "571-224-0598",
        "latitude": "38.8659538",
        "longitude": "-77.0930996",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14052"
            }
          ]
        }
      },
      {
        "storeId": "19",
        "name": "USA HOCKEY ARENA",
        "address1": "14900 BECK ROAD",
        "city": "PLYMOUTH",
        "postalCode": "48170",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "734-453-9862",
        "latitude": "42.3892013",
        "longitude": "-83.5065204",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "18964"
            },
            {
              "attributeId": "soldToID",
              "text": "18964"
            }
          ]
        }
      },
      {
        "storeId": "228",
        "name": "PURE HOCKEY",
        "address1": "159 PORTLAND AVE",
        "city": "DOVER",
        "postalCode": "03820",
        "stateCode": "NH",
        "countryCode": "US",
        "email": "dover@purehockey.com",
        "phone": "603-740-9804",
        "latitude": "43.204394",
        "longitude": "-70.860073",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223177"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "559",
        "name": "OCEAN HOCKEY SUPPLY",
        "address1": "197 CHAMBERS BRIDGE ROAD",
        "city": "BRICKTOWN",
        "postalCode": "08723",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "732-477-4411",
        "latitude": "40.0674572",
        "longitude": "-74.1451909",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5805"
            }
          ]
        }
      },
      {
        "storeId": "209",
        "name": "PURE HOCKEY",
        "address1": "139 ENDICOTT ST",
        "city": "DANVERS",
        "postalCode": "01923",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "danvers@purehockey.com",
        "phone": "978-750-6030",
        "latitude": "42.5511",
        "longitude": "-70.933503",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223172"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "594",
        "name": "RDV SPORTSPLEX",
        "address1": "8701 MAITLAND SUMMMIT BLVD",
        "city": "ORLANDO",
        "postalCode": "32810",
        "stateCode": "FL",
        "countryCode": "US",
        "email": "jleisten@rdvsportsplex.com",
        "phone": "407-916-2552",
        "latitude": "28.635669",
        "longitude": "-81.399907",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6333"
            },
            {
              "attributeId": "soldToID",
              "text": "6333"
            }
          ]
        }
      },
      {
        "storeId": "643",
        "name": "2ND TIME AROUND SPORTS PLUS SEC",
        "address1": "1 KEANEY ROAD",
        "city": "KINGSTON",
        "postalCode": "02881",
        "stateCode": "RI",
        "countryCode": "US",
        "phone": "401-874-7411",
        "latitude": "41.4839267",
        "longitude": "-71.5379916",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14654"
            }
          ]
        }
      },
      {
        "storeId": "155",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "22321 EUREKA RD",
        "city": "TAYLOR",
        "postalCode": "48180",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "734-287-8026",
        "latitude": "42.197327",
        "longitude": "-83.251302",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211451"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "626",
        "name": "JOHNNY MAC'S SPTG GOODS SEC",
        "address1": "4500 N. ILLINOIS ST.",
        "city": "SWANSEA",
        "postalCode": "62226",
        "stateCode": "IL",
        "countryCode": "US",
        "phone": "618.222.2828",
        "latitude": "38.5691638",
        "longitude": "-89.9841507",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5291"
            }
          ]
        }
      },
      {
        "storeId": "43",
        "name": "DISCOUNT HOCKEY INC SEC",
        "address1": "6465 DE SOTO AVE",
        "city": "WOODLAND HILLS",
        "postalCode": "91367",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "chrisg@discounthockey.com",
        "phone": "818-735-0699",
        "latitude": "34.187913",
        "longitude": "-118.589195",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "15604"
            },
            {
              "attributeId": "soldToID",
              "text": "15604"
            }
          ]
        }
      },
      {
        "storeId": "651",
        "name": "SPORTS ETC SFS",
        "address1": "1303 MASSACHUSETTS AVENUE",
        "city": "ARLINGTON",
        "postalCode": "02476",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "info@sportsetc.net",
        "phone": "781 646-1600",
        "latitude": "42.424403",
        "longitude": "-71.182102",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "pjstanton12@gmail.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6494"
            },
            {
              "attributeId": "soldToID",
              "text": "6494"
            }
          ]
        }
      },
      {
        "storeId": "191",
        "name": "MONKEYSPORTS INC",
        "address1": "1420 S VILLAGE WAY",
        "city": "SANTA ANA",
        "postalCode": "92705",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "retail-sa@monkeysports.com",
        "phone": "714-210-2949",
        "latitude": "33.730916",
        "longitude": "-117.837096",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "payables@monkeysports.com"
            },
            {
              "attributeId": "shipToID",
              "text": "15909"
            },
            {
              "attributeId": "soldToID",
              "text": "15909"
            }
          ]
        }
      },
      {
        "storeId": "528",
        "name": "BISMARCK KIRKWOOD SCHEELS SPORTS",
        "address1": "800 KIRKWOOD MALL",
        "city": "BISMARCK",
        "postalCode": "58504",
        "stateCode": "ND",
        "countryCode": "US",
        "phone": "701-255-7255",
        "latitude": "46.79677",
        "longitude": "-100.7864531",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "213672"
            },
            {
              "attributeId": "soldToID",
              "text": "15680"
            }
          ]
        }
      },
      {
        "storeId": "539",
        "name": "NORTHWEST SKATE AUTHORITIES",
        "address1": "9260 SW BEAVERTON HILLSDALE",
        "city": "BEAVERTON",
        "postalCode": "97225",
        "stateCode": "OR",
        "countryCode": "US",
        "phone": "503-477-9178",
        "latitude": "45.48635789999999",
        "longitude": "-122.7724584",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "10941"
            }
          ]
        }
      },
      {
        "storeId": "521",
        "name": "JT'S SLAPSHOT HOCKEY SHOP SFS",
        "address1": "7380 HICKMAN RD",
        "city": "WINDSOR HEIGHTS",
        "postalCode": "50324",
        "stateCode": "IA",
        "countryCode": "US",
        "email": "bottoms14@yahoo.com",
        "phone": "515-331-2659",
        "latitude": "41.61386",
        "longitude": "-93.719362",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13748"
            },
            {
              "attributeId": "soldToID",
              "text": "13748"
            }
          ]
        }
      },
      {
        "storeId": "618",
        "name": "JERRY'S HOCKEY",
        "address1": "13127 RIVERCREST DRIVE",
        "city": "CRESTWOOD",
        "postalCode": "60418",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "tom@jerryshockeywarehouse.net",
        "phone": "708-597-1144",
        "latitude": "41.654136",
        "longitude": "-87.745193",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "bob@jerryshockeywarehouse.net"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224130"
            },
            {
              "attributeId": "soldToID",
              "text": "5279"
            }
          ]
        }
      },
      {
        "storeId": "192",
        "name": "MONKEYSPORTS INC",
        "address1": "6578 SOUTH YOSEMITE CIRCLE",
        "city": "GREENWOOD VILLAGE",
        "postalCode": "80111",
        "stateCode": "CO",
        "countryCode": "US",
        "email": "retail-gwd@monkeysports.com",
        "phone": "303-615-3734",
        "latitude": "39.596802",
        "longitude": "-104.887149",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "payables@monkeysports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19226"
            },
            {
              "attributeId": "soldToID",
              "text": "19226"
            }
          ]
        }
      },
      {
        "storeId": "160",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "222 25TH AVE. N",
        "city": "NASHVILLE",
        "postalCode": "37203",
        "stateCode": "TN",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "629-203-6953",
        "latitude": "36.145618",
        "longitude": "-86.807182",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "15",
        "name": "PERFECT EDGE",
        "address1": "10540 CITATION DR",
        "city": "BRIGHTON",
        "postalCode": "48116",
        "stateCode": "MI",
        "countryCode": "US",
        "latitude": "42.5194743",
        "longitude": "-83.7429889",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "13962"
            }
          ]
        }
      },
      {
        "storeId": "106",
        "name": "X HOCKEY PRODUCTS BREAKAWAY PRO SE",
        "address1": "1 HALL DRIVE",
        "city": "LITTLE FALLS",
        "postalCode": "07424",
        "stateCode": "NJ",
        "countryCode": "US",
        "email": "msetola@xhockeyproducts.com",
        "phone": "973-783-2015",
        "latitude": "40.8658746",
        "longitude": "-74.1987369",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222595"
            },
            {
              "attributeId": "soldToID",
              "text": "15551"
            }
          ]
        }
      },
      {
        "storeId": "142",
        "name": "FRONT ROW SPORTS USA SEC",
        "address1": "1615 AMHERST MANOR DR",
        "city": "WILLIAMSVILLE",
        "postalCode": "14221",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "716-633-8924",
        "latitude": "42.994416",
        "longitude": "-78.782653",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221772"
            },
            {
              "attributeId": "soldToID",
              "text": "18797"
            }
          ]
        }
      },
      {
        "storeId": "194",
        "name": "MONKEYSPORTS INC",
        "address1": "30 MANCHESTER RD",
        "city": "DERRY",
        "postalCode": "03038",
        "stateCode": "NH",
        "countryCode": "US",
        "email": "retail-der@monkeysports.com",
        "phone": "603-505-4004",
        "latitude": "42.896668",
        "longitude": "-71.335431",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "payables@monkeysports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18781"
            },
            {
              "attributeId": "soldToID",
              "text": "18781"
            }
          ]
        }
      },
      {
        "storeId": "201",
        "name": "PURE HOCKEY",
        "address1": "677 CONNECTICUT AVE",
        "city": "NORWALK",
        "postalCode": "06854",
        "stateCode": "CT",
        "countryCode": "US",
        "email": "norwalk@purehockey.com",
        "phone": "203-956-0387",
        "latitude": "41.094339",
        "longitude": "-73.449202",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223180"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "531",
        "name": "SOLAR4AMERICA ICE @ FREMONT",
        "address1": "44388 OLD WARM SPRINGS RD",
        "city": "FREMONT",
        "postalCode": "94538",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "rglasow@sharksice.com",
        "phone": "510-623-7200",
        "latitude": "37.507643",
        "longitude": "-121.943578",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212168"
            },
            {
              "attributeId": "soldToID",
              "text": "5184"
            }
          ]
        }
      },
      {
        "storeId": "571",
        "name": "R & M HOCKEY SUPPLY LLC",
        "address1": "601 HOLLYDELL DRIVE",
        "city": "SEWELL",
        "postalCode": "08080",
        "stateCode": "NJ",
        "countryCode": "US",
        "email": "Hollydell@rmhockeysupply.com",
        "phone": "856-589-7000",
        "latitude": "39.745837",
        "longitude": "-75.109019",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "bmeussner@rmhockeysupply.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223131"
            },
            {
              "attributeId": "soldToID",
              "text": "19305"
            }
          ]
        }
      },
      {
        "storeId": "38",
        "name": "ULTIMATE SKATE AND HOCKEY",
        "address1": "300 WEST LINCOLN",
        "city": "ANAHEIM",
        "postalCode": "92805",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "sandyms1111@yahoo.com",
        "phone": "714-518-340",
        "latitude": "33.834214",
        "longitude": "-117.91776",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6260"
            },
            {
              "attributeId": "soldToID",
              "text": "6260"
            }
          ]
        }
      },
      {
        "storeId": "556",
        "name": "ICE LINE SEC",
        "address1": "700 LAWRENCE DRIVE",
        "city": "WEST CHESTER",
        "postalCode": "19380",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "proshop@iceline.info",
        "phone": "610-436-9670",
        "latitude": "39.983283",
        "longitude": "-75.584251",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4238"
            },
            {
              "attributeId": "soldToID",
              "text": "4238"
            }
          ]
        }
      },
      {
        "storeId": "560",
        "name": "ASHBURN ICE HOUSE",
        "address1": "21595 SMITH SWITCH RD",
        "city": "ASHBURN",
        "postalCode": "20147",
        "stateCode": "VA",
        "countryCode": "US",
        "phone": "703-858-0300",
        "latitude": "39.0194388",
        "longitude": "-77.467908",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "7326"
            }
          ]
        }
      },
      {
        "storeId": "660",
        "name": "COOKE'S SKATE SUPPLY INC. SEC",
        "address1": "446 MAIN STREET",
        "city": "WILMINGTON",
        "postalCode": "01887",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "mkebedell@gmail.com",
        "phone": "978 657-4087",
        "latitude": "42.546158",
        "longitude": "-71.173049",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13742"
            },
            {
              "attributeId": "soldToID",
              "text": "13742"
            }
          ]
        }
      },
      {
        "storeId": "193",
        "name": "MONKEYSPORTS INC",
        "address1": "949 BOSTON PROVIDENCE HWY",
        "city": "NORWOOD",
        "postalCode": "02062",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "retail-nor@monkeysports.com",
        "phone": "781-769-1754",
        "latitude": "42.180479",
        "longitude": "-71.190202",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "payables@monkeysports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "15451"
            },
            {
              "attributeId": "soldToID",
              "text": "15451"
            }
          ]
        }
      },
      {
        "storeId": "110",
        "name": "BEHIND THE MASK INC",
        "address1": "15829 NORTH 83RD AVE #101",
        "city": "PEORIA",
        "postalCode": "85382",
        "stateCode": "AZ",
        "countryCode": "US",
        "phone": "623-412-3377",
        "latitude": "33.626177",
        "longitude": "-112.23598",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "203678"
            },
            {
              "attributeId": "soldToID",
              "text": "4221"
            }
          ]
        }
      },
      {
        "storeId": "135",
        "name": "GREAT SKATE HOCKEY SUP CO",
        "address1": "3395 SHERIDAN DRIVE",
        "city": "AMHERST",
        "postalCode": "14226",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "tfarkas44@yahoo.com",
        "phone": "716-838-5100",
        "latitude": "42.979505",
        "longitude": "-78.807203",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "kfarkas@greatskate.com",
                "mfarkas@greatskate.com"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4939"
            },
            {
              "attributeId": "soldToID",
              "text": "4939"
            }
          ]
        }
      },
      {
        "storeId": "37",
        "name": "SUPERIOR HOCKEY LLC",
        "address1": "401 EAST FAIR AVE",
        "city": "MARQUETTE",
        "postalCode": "49855",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "dabeer979@yahoo.com",
        "phone": "906-225-9008",
        "latitude": "46.5571729",
        "longitude": "-87.3866368",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18653"
            },
            {
              "attributeId": "soldToID",
              "text": "18653"
            }
          ]
        }
      },
      {
        "storeId": "473",
        "name": "SOUTH WINDSOR ARENA @ NEWINGTON ICE ARENA",
        "address1": "300 ALUMNI RD.",
        "city": "NEWINGTON",
        "postalCode": "06111",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "860-436-5113",
        "latitude": "41.70339999999999",
        "longitude": "-72.74314989999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6461"
            }
          ]
        }
      },
      {
        "storeId": "655",
        "name": "TOTAL SPORTS REPAIR INC. SEC",
        "address1": "654 SOUTH UNION STREET",
        "city": "LAWRENCE",
        "postalCode": "01842",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "978 208-4740",
        "latitude": "42.6845671",
        "longitude": "-71.15181419999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9802"
            }
          ]
        }
      },
      {
        "storeId": "1178",
        "name": "SPORTS HEADQUARTERS",
        "address1": "1920 S BROADWAY",
        "city": "ROCHESTER",
        "postalCode": "55904",
        "stateCode": "MN",
        "countryCode": "US",
        "latitude": "43.97952",
        "longitude": "-92.46302",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "shipToID",
              "text": "14217"
            },
            {
              "attributeId": "soldToID",
              "text": "14217"
            }
          ]
        }
      },
      {
        "storeId": "616",
        "name": "GUNZO'S SPORT CENTER",
        "address1": "1501 W. MADISON STREET",
        "city": "CHICAGO",
        "postalCode": "60607",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "gunzosinfo@gunzos.com",
        "phone": "312-432-9433",
        "latitude": "41.881253",
        "longitude": "-87.664968",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224129"
            },
            {
              "attributeId": "soldToID",
              "text": "5024"
            }
          ]
        }
      },
      {
        "storeId": "249",
        "name": "BAUER HOCKEY EXPERIENCE/PURE HOCKEY",
        "address1": "758 AMERICAN BLVD W",
        "city": "BLOOMINGTON",
        "postalCode": "55420",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "Bloomington@purehockey.com",
        "phone": "612-915-0790",
        "latitude": "44.859783",
        "longitude": "-93.289437",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224049"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "225",
        "name": "PURE HOCKEY",
        "address1": "1271 HOOKSETT ROAD",
        "city": "HOOKSETT",
        "postalCode": "03106",
        "stateCode": "NH",
        "countryCode": "US",
        "email": "hooksett@purehockey.com",
        "phone": "603-518-7458",
        "latitude": "43.049007",
        "longitude": "-71.434894",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221311"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "469",
        "name": "THE PRO SHOP OF NORTHFORD",
        "address1": "24 FIRE-LITE PLACE",
        "city": "NORTHFORD",
        "postalCode": "06472",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "203-248-9898",
        "latitude": "41.3966954",
        "longitude": "-72.8133014",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4439"
            }
          ]
        }
      },
      {
        "storeId": "107",
        "name": "WESTSIDE SKATE & STICK NY LLC SFS",
        "address1": "4732 32nd Place, Suite 1160",
        "city": "Long Island City",
        "postalCode": "11101",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "info@wsskate.com",
        "phone": "212-228-8400",
        "latitude": "40.74184",
        "longitude": "-73.9332",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19071"
            },
            {
              "attributeId": "soldToID",
              "text": "19071"
            }
          ]
        }
      },
      {
        "storeId": "652",
        "name": "TOTAL SPORTS REPAIR INC. SEC",
        "address1": "48 SOUTH MAIN STREET",
        "city": "MANCHESTER",
        "postalCode": "03102",
        "stateCode": "NH",
        "countryCode": "US",
        "email": "Jaysonpaiva@tsrhockey.com",
        "phone": "603 668-9100",
        "latitude": "42.9832986",
        "longitude": "-71.4736522",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "brendansheehy@tsrhockey.com"
            },
            {
              "attributeId": "shipToID",
              "text": "223688"
            },
            {
              "attributeId": "soldToID",
              "text": "9802"
            }
          ]
        }
      },
      {
        "storeId": "592",
        "name": "RINKSIDE SPORTS SFS",
        "address1": "10222 ELIZABETH PLACE",
        "city": "TAMPA",
        "postalCode": "33619",
        "stateCode": "FL",
        "countryCode": "US",
        "email": "allen@rinksidesportstampa.com",
        "phone": "813-643-6404",
        "latitude": "27.94898",
        "longitude": "-82.329703",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5867"
            },
            {
              "attributeId": "soldToID",
              "text": "5867"
            }
          ]
        }
      },
      {
        "storeId": "190",
        "name": "MONKEYSPORTS INC",
        "address1": "1962 BARRANCA",
        "city": "IRVINE",
        "postalCode": "92606",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "retail-irv@monkeysports.com",
        "phone": "949-337-4980",
        "latitude": "33.701031",
        "longitude": "-117.837462",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213967"
            },
            {
              "attributeId": "soldToID",
              "text": "15909"
            }
          ]
        }
      },
      {
        "storeId": "141",
        "name": "FRONT ROW SPORTS USA SEC",
        "address1": "1060 UNION RD",
        "city": "WEST SENECA",
        "postalCode": "14224",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "d.borsuk@frontrowsport.com",
        "phone": "716-674-4588",
        "latitude": "42.829411",
        "longitude": "-78.753059",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "marrone@frontrowsport.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18797"
            },
            {
              "attributeId": "soldToID",
              "text": "18797"
            }
          ]
        }
      },
      {
        "storeId": "632",
        "name": "THE HOCKEY HAVEN INC. SFS",
        "address1": "19555 W BLUEMOUND #14",
        "city": "BROOKFIELD",
        "postalCode": "53045",
        "stateCode": "WI",
        "countryCode": "US",
        "email": "hockeyhaven@hotmail.com",
        "phone": "262-784-7825",
        "latitude": "43.036385",
        "longitude": "-88.192764",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6980"
            },
            {
              "attributeId": "soldToID",
              "text": "6980"
            }
          ]
        }
      },
      {
        "storeId": "102",
        "name": "X HOCKEY PRODUCTS BREAKAWAY PRO SE",
        "address1": "2441-A RT22 WEST",
        "city": "UNION",
        "postalCode": "07083",
        "stateCode": "NJ",
        "countryCode": "US",
        "phone": "908-258-0670",
        "latitude": "40.6927562",
        "longitude": "-74.2955968",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "213897"
            },
            {
              "attributeId": "soldToID",
              "text": "15551"
            }
          ]
        }
      },
      {
        "storeId": "519",
        "name": "PLAY IT AGAIN SPORTS #10423",
        "address1": "126 BELKNAP STREET",
        "city": "SUPERIOR",
        "postalCode": "54880",
        "stateCode": "WI",
        "countryCode": "US",
        "phone": "715-392-3700",
        "latitude": "46.7201694",
        "longitude": "-92.08040989999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "11359"
            }
          ]
        }
      },
      {
        "storeId": "14",
        "name": "PERFECT EDGE TC",
        "address1": "1784 S GARFIELD AVE",
        "city": "TRAVERSE CITY",
        "postalCode": "49686",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "231-237-4443",
        "latitude": "44.7348621",
        "longitude": "-85.595397",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "223621"
            },
            {
              "attributeId": "soldToID",
              "text": "13962"
            }
          ]
        }
      },
      {
        "storeId": "601",
        "name": "NORTH GEORGIA HOCKEY",
        "address1": "900 MANSELL RD #9",
        "city": "ROSWELL",
        "postalCode": "30076",
        "stateCode": "GA",
        "countryCode": "US",
        "email": "geoff@northgeorgiahockey.com",
        "phone": "770-992-8819",
        "latitude": "34.043912",
        "longitude": "-84.338141",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "15482"
            },
            {
              "attributeId": "soldToID",
              "text": "15482"
            }
          ]
        }
      },
      {
        "storeId": "218",
        "name": "PURE HOCKEY",
        "address1": "1845 EAST COUNTY RD SUITE 120",
        "city": "MAPLEWOOD",
        "postalCode": "55109",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "maplewood@purehockey.com",
        "phone": "651-777-7410",
        "latitude": "45.036414",
        "longitude": "-93.023666",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223198"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "81",
        "name": "CENTRE ICE HOCKEY LLC SEC",
        "address1": "8351 BELLEVIEW DR.",
        "city": "DENVER",
        "postalCode": "80237",
        "stateCode": "CO",
        "countryCode": "US",
        "email": "cs@centreicehockey.net",
        "phone": "303.725.1596",
        "latitude": "39.624603",
        "longitude": "-104.891893",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19366"
            },
            {
              "attributeId": "soldToID",
              "text": "19366"
            }
          ]
        }
      },
      {
        "storeId": "23",
        "name": "GENERAL SPORTS CORP SEC",
        "address1": "5025 FRANCE AVE SOUTH",
        "city": "MINNEAPOLIS",
        "postalCode": "55410",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "612-925-4010",
        "latitude": "44.911741",
        "longitude": "-93.328799",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4907"
            },
            {
              "attributeId": "soldToID",
              "text": "4907"
            }
          ]
        }
      },
      {
        "storeId": "238",
        "name": "PURE HOCKEY",
        "address1": "127 WEST LINCOLN HIGHWAY",
        "city": "EXTON",
        "postalCode": "19341",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "exton@purehockey.com",
        "phone": "484-879-6764",
        "latitude": "40.028236",
        "longitude": "-75.629358",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223188"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "525",
        "name": "FARGO SCHEELS ALL SPORTS",
        "address1": "1551 45TH ST S",
        "city": "FARGO",
        "postalCode": "58103",
        "stateCode": "ND",
        "countryCode": "US",
        "email": "jsaikens@scheels.com",
        "phone": "701-298-2918",
        "latitude": "46.857414",
        "longitude": "-96.864214",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213669"
            },
            {
              "attributeId": "soldToID",
              "text": "15680"
            }
          ]
        }
      },
      {
        "storeId": "79",
        "name": "MAULERS HOCKEY CENTRAL INC",
        "address1": "22202 70TH AVE. WEST",
        "city": "MOUNTLAKE TERRACE",
        "postalCode": "98043",
        "stateCode": "WA",
        "countryCode": "US",
        "email": "travermt@gmail.com",
        "phone": "406.239.5396",
        "latitude": "47.7971102",
        "longitude": "-122.3283648",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "224074"
            },
            {
              "attributeId": "soldToID",
              "text": "15420"
            }
          ]
        }
      },
      {
        "storeId": "40",
        "name": "USA SKATES INC",
        "address1": "13071 SPRINGDALE ST",
        "city": "WESTMINSTER",
        "postalCode": "92683",
        "stateCode": "CA",
        "countryCode": "US",
        "phone": "714-999-1400",
        "latitude": "33.773232",
        "longitude": "-118.0234339",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "11177"
            },
            {
              "attributeId": "soldToID",
              "text": "11177"
            }
          ]
        }
      },
      {
        "storeId": "542",
        "name": "KAPOLEI INLINE HOCKEY ARENAS",
        "address1": "1057 OPAKAPAKA ST",
        "city": "KAPOLEI",
        "postalCode": "96707",
        "stateCode": "HI",
        "countryCode": "US",
        "email": "richardpentecost57@hotmail.com",
        "phone": "808-372-9270",
        "latitude": "21.3193497",
        "longitude": "-158.0938622",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "15065"
            },
            {
              "attributeId": "soldToID",
              "text": "15065"
            }
          ]
        }
      },
      {
        "storeId": "462",
        "name": "BLUELINE SPORTS INC. SFS",
        "address1": "784 RIVER RD.",
        "city": "SHELTON",
        "postalCode": "06484",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "203-701-7924",
        "latitude": "41.2648108",
        "longitude": "-73.0913455",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4253"
            }
          ]
        }
      },
      {
        "storeId": "524",
        "name": "HOCKEY ZONE",
        "address1": "415 MAIN AVENUE",
        "city": "MOORHEAD",
        "postalCode": "56560",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "218-227-0344",
        "latitude": "46.8735405",
        "longitude": "-96.7736152",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "13768"
            }
          ]
        }
      },
      {
        "storeId": "1199",
        "name": "HOCKEY MONKEY",
        "address1": "30 MANCHESTER ROAD",
        "city": "DERRY",
        "postalCode": "03038",
        "stateCode": "NH",
        "countryCode": "US",
        "phone": "603-505-4004",
        "latitude": "42.89707",
        "longitude": "-71.33554",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "223007"
            },
            {
              "attributeId": "soldToID",
              "text": "15119"
            }
          ]
        }
      },
      {
        "storeId": "26",
        "name": "LETTERMEN SPORTS",
        "address1": "15600 37TH AVE N STE 150",
        "city": "PLYMOUTH",
        "postalCode": "55446",
        "stateCode": "MN",
        "countryCode": "US",
        "email": "nick@lettermensports.com",
        "phone": "763-780-8077",
        "latitude": "45.024963",
        "longitude": "-93.478421",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212208"
            },
            {
              "attributeId": "soldToID",
              "text": "5464"
            }
          ]
        }
      },
      {
        "storeId": "105",
        "name": "X HOCKEY PRODUCTS BREAKAWAY PRO SE",
        "address1": "102 WEST COMMERCIAL AVE",
        "city": "MOONACHIE",
        "postalCode": "07074",
        "stateCode": "NJ",
        "countryCode": "US",
        "latitude": "40.8341017",
        "longitude": "-74.0620491",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "222563"
            },
            {
              "attributeId": "soldToID",
              "text": "15551"
            }
          ]
        }
      },
      {
        "storeId": "244",
        "name": "PURE HOCKEY",
        "address1": "8700 PRESTON RD",
        "city": "PLANO",
        "postalCode": "75024",
        "stateCode": "TX",
        "countryCode": "US",
        "email": "plano@purehockey.com",
        "phone": "972-704-1080",
        "latitude": "33.096092",
        "longitude": "-96.801441",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222796"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "647",
        "name": "H A ZWICKER INC SFS",
        "address1": "379 NORTH ROAD",
        "city": "BEDFORD",
        "postalCode": "01730",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "wayne@zwickers.com",
        "phone": "781 275-0900",
        "latitude": "42.5184413",
        "longitude": "-71.2854953",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5027"
            },
            {
              "attributeId": "soldToID",
              "text": "5027"
            }
          ]
        }
      },
      {
        "storeId": "1190",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "2067 S TELEGRAPH ROAD",
        "city": "BLOOMFIELD",
        "postalCode": "48302",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "latitude": "42.608413",
        "longitude": "-83.299692",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "shipToID",
              "text": "224329"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "619",
        "name": "JERRY'S HOCKEY",
        "address1": "801 WESEMANN DR",
        "city": "WEST DUNDEE",
        "postalCode": "60118",
        "stateCode": "IL",
        "countryCode": "US",
        "phone": "847-428-7825",
        "latitude": "42.105706",
        "longitude": "-88.345942",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5279"
            }
          ]
        }
      },
      {
        "storeId": "597",
        "name": "FIVE HOLE SPORTS SFS",
        "address1": "1410 BUCK JONES ROAD",
        "city": "RALEIGH",
        "postalCode": "27606",
        "stateCode": "NC",
        "countryCode": "US",
        "email": "andrew@fiveholesports.com",
        "phone": "919-481-4475",
        "latitude": "35.765401",
        "longitude": "-78.745478",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "14736"
            },
            {
              "attributeId": "soldToID",
              "text": "14736"
            }
          ]
        }
      },
      {
        "storeId": "624",
        "name": "JOHNNY MAC'S SPTG GOODS SEC",
        "address1": "10100 WATSON RD",
        "city": "SAINT LOUIS",
        "postalCode": "63127",
        "stateCode": "MO",
        "countryCode": "US",
        "email": "amorse@johnnymacs.com",
        "phone": "314.966.5444",
        "latitude": "38.5555187",
        "longitude": "-90.3981265",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221158"
            },
            {
              "attributeId": "soldToID",
              "text": "5291"
            }
          ]
        }
      },
      {
        "storeId": "617",
        "name": "JERRY'S HOCKEY",
        "address1": "501 MORSE, UNIT G",
        "city": "SCHAUMBURG",
        "postalCode": "60193",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "tom@jerryshockeywarehouse.net",
        "phone": "847-584-0700",
        "latitude": "42.000131",
        "longitude": "-88.092595",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "bob@jerryshockeywarehouse.net"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5279"
            },
            {
              "attributeId": "soldToID",
              "text": "5279"
            }
          ]
        }
      },
      {
        "storeId": "646",
        "name": "DYNAMIK SPORTS SFS",
        "address1": "20 CARTER ST",
        "city": "TEWKSBURY",
        "postalCode": "01876",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "781 942-1153",
        "latitude": "42.6207775",
        "longitude": "-71.1945155",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4667"
            }
          ]
        }
      },
      {
        "storeId": "657",
        "name": "TOTAL SPORTS REPAIR INC. SEC",
        "address1": "15 MANNING ROAD",
        "city": "MIDDLETON",
        "postalCode": "01949",
        "stateCode": "MA",
        "countryCode": "US",
        "phone": "978 539-8920",
        "latitude": "42.596385",
        "longitude": "-70.980977",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "9802"
            }
          ]
        }
      },
      {
        "storeId": "158",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "54755 BROUGHTON",
        "city": "MACOMB",
        "postalCode": "48042",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "586-677-5368",
        "latitude": "42.700164",
        "longitude": "-82.921078",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213479"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "9999",
        "name": "JD's SKATE HAUS",
        "address1": "100 DOMAIN DRIVE",
        "city": "EXETER",
        "postalCode": "03833",
        "stateCode": "NH",
        "countryCode": "US",
        "email": "donald.drake@bauer.com",
        "latitude": "42.981477",
        "longitude": "-70.947834",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19718"
            },
            {
              "attributeId": "soldToID",
              "text": "19718"
            }
          ]
        }
      },
      {
        "storeId": "167",
        "name": "B & R SPORTING GOODS",
        "address1": "1555 EAST WOODWARD HEIGHTS BOULEVARD",
        "city": "HAZEL PARK",
        "postalCode": "48030",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "248-545-2217",
        "latitude": "42.4693913",
        "longitude": "-83.08965169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "221666"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "112",
        "name": "COYOTES ICE, LLC",
        "address1": "7225 W HARRISON ST",
        "city": "CHANDLER",
        "postalCode": "85226",
        "stateCode": "AZ",
        "countryCode": "US",
        "phone": "480-598-9400",
        "latitude": "33.3150997",
        "longitude": "-111.96734",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "221746"
            },
            {
              "attributeId": "soldToID",
              "text": "4381"
            }
          ]
        }
      },
      {
        "storeId": "113",
        "name": "LAS VEGAS HOCKEY LLC",
        "address1": "9295 W FLAMINGO STE 130",
        "city": "LAS VEGAS",
        "postalCode": "89147",
        "stateCode": "NV",
        "countryCode": "US",
        "email": "cole@lasvegasice.com",
        "phone": "702-320-7777",
        "latitude": "36.114581",
        "longitude": "-115.2944037",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13247"
            },
            {
              "attributeId": "soldToID",
              "text": "13247"
            }
          ]
        }
      },
      {
        "storeId": "620",
        "name": "JERRY'S HOCKEY",
        "address1": "3939 WINNETKA AVE",
        "city": "ROLLING MEADOWS",
        "postalCode": "60008",
        "stateCode": "IL",
        "countryCode": "US",
        "phone": "847-398-7446",
        "latitude": "42.092409",
        "longitude": "-88.030959",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5279"
            }
          ]
        }
      },
      {
        "storeId": "522",
        "name": "DUFFY'S HOCKEY AND SPORTS",
        "address1": "1525 31ST AVENUE SW SUITE B",
        "city": "MINOT",
        "postalCode": "58701",
        "stateCode": "ND",
        "countryCode": "US",
        "email": "duffy@srt.com",
        "phone": "701-839-9220",
        "latitude": "48.203118",
        "longitude": "-101.316317",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13764"
            },
            {
              "attributeId": "soldToID",
              "text": "13764"
            }
          ]
        }
      },
      {
        "storeId": "233",
        "name": "PURE HOCKEY",
        "address1": "310 MAIN STREET",
        "city": "NEW ROCHELLE",
        "postalCode": "10801",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "newrochelle@purehockey.com",
        "phone": "914-278-9210",
        "latitude": "40.912765",
        "longitude": "-73.774928",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222095"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "149",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "2661 29TH STREET",
        "city": "GRAND RAPIDS",
        "postalCode": "49512",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "616-975-3700",
        "latitude": "42.91125",
        "longitude": "-85.601248",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211452"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "143",
        "name": "ROCHESTER ICE CENTER PRO SHOP",
        "address1": "80 LYNDON RD",
        "city": "FAIRPORT",
        "postalCode": "14450",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "585-223-2160 x26",
        "latitude": "43.0920045",
        "longitude": "-77.401161",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19321"
            },
            {
              "attributeId": "soldToID",
              "text": "19321"
            }
          ]
        }
      },
      {
        "storeId": "32",
        "name": "CENTER ICE SKATE & SPORT INC SFS",
        "address1": "110 RED JACKET ROAD",
        "city": "CALUMET",
        "postalCode": "49913",
        "stateCode": "MI",
        "countryCode": "US",
        "phone": "906-337-1990",
        "latitude": "47.2275698",
        "longitude": "-88.4381156",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "12761"
            }
          ]
        }
      },
      {
        "storeId": "465",
        "name": "FERGUSONS CENTER ICE SPORTS",
        "address1": "307 RACEBROOK RD",
        "city": "ORANGE",
        "postalCode": "06477",
        "stateCode": "CT",
        "countryCode": "US",
        "phone": "203-799-7200",
        "latitude": "41.268933",
        "longitude": "-73.000022",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4420"
            }
          ]
        }
      },
      {
        "storeId": "565",
        "name": "SKATEQUEST / PROSUS LLC SEC",
        "address1": "1800 MICHAEL FARADAY CT",
        "city": "RESTON",
        "postalCode": "20190",
        "stateCode": "VA",
        "countryCode": "US",
        "phone": "703-709-1010",
        "latitude": "38.949616",
        "longitude": "-77.33094299999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "11108"
            }
          ]
        }
      },
      {
        "storeId": "534",
        "name": "PLAY IT AGAIN SPORTS ANCHORAGE",
        "address1": "2636 SPENARD ROAD",
        "city": "ANCHORAGE",
        "postalCode": "99503",
        "stateCode": "AK",
        "countryCode": "US",
        "email": "don@piasak.com",
        "phone": "907-278-7529",
        "latitude": "61.196622",
        "longitude": "-149.905992",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5992"
            },
            {
              "attributeId": "soldToID",
              "text": "5992"
            }
          ]
        }
      },
      {
        "storeId": "162",
        "name": "B & R SPORTING GOODS",
        "address1": "46719 HAYES ROAD",
        "city": "SHELBY TOWNSHIP",
        "postalCode": "48315",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jeffbielecki@yahoo.com",
        "phone": "586-263-7941",
        "latitude": "42.639849",
        "longitude": "-82.975269",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4284"
            },
            {
              "attributeId": "soldToID",
              "text": "4284"
            }
          ]
        }
      },
      {
        "storeId": "96",
        "name": "NY ISLANDERS PRO SHOP",
        "address1": "175 UNDER HILL BLVD",
        "city": "SYOSSET",
        "postalCode": "11791",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "516-496-2277",
        "latitude": "40.82053519999999",
        "longitude": "-73.5072304",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "14979"
            },
            {
              "attributeId": "soldToID",
              "text": "14979"
            }
          ]
        }
      },
      {
        "storeId": "530",
        "name": "SOLAR4AMERICA ICE @ SAN JOSE",
        "address1": "1500 S TENTH ST",
        "city": "SAN JOSE",
        "postalCode": "95112",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "rglasow@sharksice.com",
        "phone": "408-279-6000",
        "latitude": "37.3194275",
        "longitude": "-121.8642665",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5184"
            },
            {
              "attributeId": "soldToID",
              "text": "5184"
            }
          ]
        }
      },
      {
        "storeId": "536",
        "name": "PLAY IT AGAIN SPORTS WASILLA",
        "address1": "8840 OLD SEWARD HWY",
        "city": "ANCHORAGE",
        "postalCode": "99515",
        "stateCode": "AK",
        "countryCode": "US",
        "phone": "907-272-7529",
        "latitude": "61.14036569999999",
        "longitude": "-149.8650916",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5992"
            }
          ]
        }
      },
      {
        "storeId": "202",
        "name": "PURE HOCKEY",
        "address1": "1230 WEST 75TH STREET",
        "city": "DOWNERS GROVE",
        "postalCode": "60516",
        "stateCode": "IL",
        "countryCode": "US",
        "email": "downersgrove@purehockey.com",
        "phone": "630-322-9850",
        "latitude": "41.747625",
        "longitude": "-88.171881",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223201"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "593",
        "name": "RINKSIDE SPORTS SFS",
        "address1": "3173 CYPRESS RIDGE ROAD",
        "city": "WESLEY CHAPEL",
        "postalCode": "33544",
        "stateCode": "FL",
        "countryCode": "US",
        "email": "allen@rinksidesportstampa.com",
        "phone": "813-8037269",
        "latitude": "28.195519",
        "longitude": "-82.380291",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223453"
            },
            {
              "attributeId": "soldToID",
              "text": "5867"
            }
          ]
        }
      },
      {
        "storeId": "557",
        "name": "ICE LINE SEC",
        "address1": "87 BROWER AVE",
        "city": "OAKS",
        "postalCode": "19456",
        "stateCode": "PA",
        "countryCode": "US",
        "email": "proshop@iceline.info",
        "phone": "610-666-5450",
        "latitude": "40.127815",
        "longitude": "-75.461293",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212411"
            },
            {
              "attributeId": "soldToID",
              "text": "4238"
            }
          ]
        }
      },
      {
        "storeId": "527",
        "name": "SCHEELS",
        "address1": "2800 S COLUMBIA RD",
        "city": "GRAND FORKS",
        "postalCode": "58201",
        "stateCode": "ND",
        "countryCode": "US",
        "phone": "701-780-9424",
        "latitude": "47.8930679",
        "longitude": "-97.07116789999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "221486"
            },
            {
              "attributeId": "soldToID",
              "text": "15680"
            }
          ]
        }
      },
      {
        "storeId": "199",
        "name": "PURE HOCKEY",
        "address1": "9979 WADSWORTH PARKWAY #400",
        "city": "WESTMINSTER",
        "postalCode": "80021",
        "stateCode": "CO",
        "countryCode": "US",
        "email": "westminster@purehockey.com",
        "phone": "303-428-6709",
        "latitude": "39.876387",
        "longitude": "-105.097921",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223192"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "211",
        "name": "PURE HOCKEY",
        "address1": "70 SALEM ST",
        "city": "MEDFORD",
        "postalCode": "02155",
        "stateCode": "MA",
        "countryCode": "US",
        "email": "medfordsquare@purehockey.com",
        "phone": "781-306-0278",
        "latitude": "42.418839",
        "longitude": "-71.106694",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223175"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "1221",
        "name": "PURE HOCKEY LUTZ",
        "address1": "25629 SIERRA CENTER BLVD",
        "city": "LUTZ",
        "postalCode": "33559",
        "stateCode": "FL",
        "countryCode": "US",
        "latitude": "28.19476",
        "longitude": "-82.3942",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224416"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "35",
        "name": "HAT TRICK HOCKEY II SEC",
        "address1": "5721 LA CENTRE AVE #304",
        "city": "ALBERTVILLE",
        "postalCode": "55301",
        "stateCode": "MN",
        "countryCode": "US",
        "phone": "763-595-1616",
        "latitude": "45.23426329999999",
        "longitude": "-93.6634528",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "223162"
            },
            {
              "attributeId": "soldToID",
              "text": "13617"
            }
          ]
        }
      },
      {
        "storeId": "150",
        "name": "BOB PERANI'S SPORT SHOP",
        "address1": "1019 EAST GRAND RIVER AVE.",
        "city": "BRIGHTON",
        "postalCode": "48116",
        "stateCode": "MI",
        "countryCode": "US",
        "email": "jwainio@peranis.com",
        "phone": "810-588-6546",
        "latitude": "42.523862",
        "longitude": "-83.772194",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213889"
            },
            {
              "attributeId": "soldToID",
              "text": "4258"
            }
          ]
        }
      },
      {
        "storeId": "224",
        "name": "PURE HOCKEY",
        "address1": "5833 SUEMANDY DRIVE",
        "city": "SAINT PETERS",
        "postalCode": "63376",
        "stateCode": "MO",
        "countryCode": "US",
        "email": "saintpeters@purehockey.com",
        "phone": "636-397-6370",
        "latitude": "38.798183",
        "longitude": "-90.625607",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223205"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "231",
        "name": "PURE HOCKEY",
        "address1": "3265 SHERIDAN DRIVE",
        "city": "AMHERST",
        "postalCode": "14226",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "amherst@purehockey.com",
        "phone": "716-551-0594",
        "latitude": "42.979613",
        "longitude": "-78.812868",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221312"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "248",
        "name": "PURE HOCKEY",
        "address1": "134 E. MAIN STREET, SUITE 6",
        "city": "SMITHTOWN",
        "postalCode": "11787",
        "stateCode": "NY",
        "countryCode": "US",
        "email": "smithtown@purehockey.com",
        "phone": "631-982-9440",
        "latitude": "40.854655",
        "longitude": "-73.188891",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Custom_skates@purehockey.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "223001"
            },
            {
              "attributeId": "soldToID",
              "text": "14493"
            }
          ]
        }
      },
      {
        "storeId": "634",
        "name": "ARCTIC ICE ARENA INC.",
        "address1": "10700 W. 160TH STREET",
        "city": "ORLAND PARK",
        "postalCode": "60467",
        "stateCode": "IL",
        "countryCode": "US",
        "phone": "708-403-4231",
        "latitude": "41.5996183",
        "longitude": "-87.8790629",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "10981"
            }
          ]
        }
      },
      {
        "storeId": "1200",
        "name": "ULTIMATE SKATE AND HOCKEY",
        "address1": "888 RIDGE VALLEY",
        "city": "IRVINE",
        "postalCode": "92618",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "sandyms1111@yahoo.com",
        "phone": "310-535-4535",
        "latitude": "33.69166",
        "longitude": "-117.73577",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "221804"
            },
            {
              "attributeId": "soldToID",
              "text": "6260"
            }
          ]
        }
      },
      {
        "storeId": "658",
        "name": "TOTAL SPORTS REPAIR INC. SEC",
        "address1": "60 LOWELL ROAD",
        "city": "SALEM",
        "postalCode": "03079",
        "stateCode": "NH",
        "countryCode": "US",
        "phone": "603 458-5941",
        "latitude": "42.7656782",
        "longitude": "-71.248628",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9802"
            }
          ]
        }
      },
      {
        "storeId": "133",
        "name": "BROADWAY RINKS LTD PTNRSP",
        "address1": "3465 BROADWAY",
        "city": "BUFFALO",
        "postalCode": "14227",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "716-685-3660",
        "latitude": "42.9029713",
        "longitude": "-78.7465138",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4274"
            },
            {
              "attributeId": "soldToID",
              "text": "4274"
            }
          ]
        }
      },
      {
        "storeId": "39",
        "name": "ULTIMATE SKATE & HOCKEY",
        "address1": "555 N NASH STREET",
        "city": "EL SEGUNDO",
        "postalCode": "90245",
        "stateCode": "CA",
        "countryCode": "US",
        "email": "sandyms1111@yahoo.com",
        "phone": "310-535-4535",
        "latitude": "33.922003",
        "longitude": "-118.388195",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "221804"
            },
            {
              "attributeId": "soldToID",
              "text": "6260"
            }
          ]
        }
      },
      {
        "storeId": "97",
        "name": "NY ISLANDERS PRO SHOP",
        "address1": "200 MERRICK AVE",
        "city": "EAST MEADOW",
        "postalCode": "11554",
        "stateCode": "NY",
        "countryCode": "US",
        "phone": "516-441-0070",
        "latitude": "40.7269652",
        "longitude": "-73.57642609999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "223731"
            },
            {
              "attributeId": "soldToID",
              "text": "14979"
            }
          ]
        }
      },
      {
        "storeId": "278",
        "name": "PRO HOCKEY LIFE",
        "address1": "655 SYDNEY AVE UNIT #1",
        "city": "WINDSOR",
        "postalCode": "N8X 5C4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "42.271632",
        "longitude": "-82.998031",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213377"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "584",
        "name": "OT SPORTS",
        "address1": "10028 101 ST",
        "city": "PEACE RIVER",
        "postalCode": "T8S 2A5",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "780-624-3737",
        "latitude": "56.232386",
        "longitude": "-117.289179",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "15956"
            }
          ]
        }
      },
      {
        "storeId": "71",
        "name": "EXTREME HOCKEY",
        "address1": "1425 MCINTYRE ST",
        "city": "REGINA",
        "postalCode": "S4R 8B5",
        "stateCode": "SK",
        "countryCode": "CA",
        "email": "jason@extremehockey.net",
        "phone": "306 721 8326",
        "latitude": "50.456412",
        "longitude": "-104.61602",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "jasondolliver@extremehockey.net"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "9968"
            },
            {
              "attributeId": "soldToID",
              "text": "9968"
            }
          ]
        }
      },
      {
        "storeId": "327",
        "name": "SPORT CHEK",
        "address1": "32900 SOUTH FRASER HWY",
        "city": "ABBOTSFORD",
        "postalCode": "V2S 5A1",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.0551614",
        "longitude": "-122.3707795",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "130",
        "name": "KAMLOOPS PLAYERS BENCH INC",
        "address1": "451 LANSDOWNE ST",
        "city": "KAMLOOPS",
        "postalCode": "V2C 1Y2",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "pbkamloops@hotmail.com",
        "phone": "250-851-0344",
        "latitude": "50.676576",
        "longitude": "-120.330551",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "playersbench@shaw.ca"
            },
            {
              "attributeId": "shipToID",
              "text": "18704"
            },
            {
              "attributeId": "soldToID",
              "text": "18704"
            }
          ]
        }
      },
      {
        "storeId": "131",
        "name": "COAST TO COAST HOCKEY SHOP",
        "address1": "1739 MAIN ST",
        "city": "VANCOUVER",
        "postalCode": "V5T 3B5",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "604-647-0094",
        "latitude": "49.2698074",
        "longitude": "-123.100945",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "18801"
            },
            {
              "attributeId": "soldToID",
              "text": "18801"
            }
          ]
        }
      },
      {
        "storeId": "8",
        "name": "TORONTO PRO",
        "address1": "27 ROYTEC RD BLDG B UNIT 5B BOX",
        "city": "VAUGHAN",
        "postalCode": "L4L 8E3",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "inquiries@toronto-pro.com",
        "phone": "905-264-4433",
        "latitude": "43.80291",
        "longitude": "-79.549238",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "13886"
            },
            {
              "attributeId": "soldToID",
              "text": "13886"
            }
          ]
        }
      },
      {
        "storeId": "363",
        "name": "SPORT CHEK",
        "address1": "UNIT 200, 390 NORTH FRONT STREET",
        "city": "BELLEVILLE",
        "postalCode": "K8P 3E1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "44.1881425",
        "longitude": "-77.40250619999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "372",
        "name": "SPORT CHEK",
        "address1": "293 BAY ST UNIT 61",
        "city": "SAULT ST MARIE",
        "postalCode": "P6A 1X3",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "46.5124381",
        "longitude": "-84.3390775",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "121",
        "name": "SUN VALLEY SOURCE FOR SPORTS",
        "address1": "5601 27TH STREET",
        "city": "VERNON",
        "postalCode": "V1T 8Z5",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-542-2852",
        "latitude": "50.286268",
        "longitude": "-119.265807",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "6781"
            },
            {
              "attributeId": "soldToID",
              "text": "6781"
            }
          ]
        }
      },
      {
        "storeId": "50",
        "name": "HOMETOWN SOURCE FOR SPORTS",
        "address1": "11 3RD AVE N",
        "city": "YORKTON",
        "postalCode": "S3N 1C1",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306 783 0150",
        "latitude": "51.2107079",
        "longitude": "-102.45953",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5143"
            },
            {
              "attributeId": "soldToID",
              "text": "5143"
            }
          ]
        }
      },
      {
        "storeId": "449",
        "name": "PLAY IT AGAIN SPORTS - MONTREAL",
        "address1": "2100 BOUL DECARIE",
        "city": "MONTREAL",
        "postalCode": "H4A 3J3",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "514-484-5150",
        "latitude": "45.47361069999999",
        "longitude": "-73.6079156",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6065"
            }
          ]
        }
      },
      {
        "storeId": "290",
        "name": "SPORT CHEK",
        "address1": "UNIT 600, 5001-19 STREET",
        "city": "RED DEER",
        "postalCode": "T4R 3R1",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "52.232088",
        "longitude": "-113.817008",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "261",
        "name": "ENTREPOT DU HOCKEY",
        "address1": "1860 BOUL TALBOT",
        "city": "CICOUTIMI",
        "postalCode": "G7H 7Y2",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "groy@se0484.com",
        "phone": "418-543-3993",
        "latitude": "48.395844",
        "longitude": "-71.070183",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "esthilaire@se0484.com"
            },
            {
              "attributeId": "shipToID",
              "text": "18738"
            },
            {
              "attributeId": "soldToID",
              "text": "18738"
            }
          ]
        }
      },
      {
        "storeId": "511",
        "name": "SPORTS ROUSSEAU",
        "address1": "90 RUE EMILE DESPINS",
        "city": "CHARLEMAGNE",
        "postalCode": "J5Z 3L6",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "ehurtubise@sportsrousseau30.ca",
        "phone": "450-654-6767",
        "latitude": "45.721574",
        "longitude": "-73.491347",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18743"
            },
            {
              "attributeId": "soldToID",
              "text": "18743"
            }
          ]
        }
      },
      {
        "storeId": "257",
        "name": "GO SPORT",
        "address1": "750 RENE-LEVESQUE",
        "city": "DRUMMONDVILLE",
        "postalCode": "J2C 7N7",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "819-850-0431",
        "latitude": "45.8981336",
        "longitude": "-72.5155437",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "15513"
            }
          ]
        }
      },
      {
        "storeId": "315",
        "name": "SPORT CHEK",
        "address1": "250 TRUNK ROAD UNIT D10",
        "city": "DUNCAN",
        "postalCode": "V9L 2P2",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "48.7754565",
        "longitude": "-123.7030504",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "410",
        "name": "SPORT CHEK",
        "address1": "3165 WONDERLAND ROAD SOUTH",
        "city": "LONDON",
        "postalCode": "N6L 1R4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "42.93347199999999",
        "longitude": "-81.2827065",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "602",
        "name": "DUGUAY SPORTS   MU",
        "address1": "400 BOUL TACHE",
        "city": "HULL",
        "postalCode": "J9A 1M5",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "819-771-3512",
        "latitude": "45.4217085",
        "longitude": "-75.7465715",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4706"
            }
          ]
        }
      },
      {
        "storeId": "492",
        "name": "CLEVE'S SPORTING GOODS SDC",
        "address1": "30 THORNHILL DRIVE",
        "city": "DARTMOUTH",
        "postalCode": "B3B 1S1",
        "stateCode": "NS",
        "countryCode": "CA",
        "phone": "902-468-1885",
        "latitude": "44.699023",
        "longitude": "-63.592656",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "429",
        "name": "SPORT CHEK",
        "address1": "150 FIRST STREET",
        "city": "ORANGEVILLE",
        "postalCode": "L9W 3T7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.9316653",
        "longitude": "-80.1022412",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "264",
        "name": "PRO HOCKEY LIFE",
        "address1": "116-4916 130 AVE SE - UNIT A2",
        "city": "CALGARY",
        "postalCode": "T2Z 0G4",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "50.931946",
        "longitude": "-113.961726",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212729"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "613",
        "name": "LACROIX SOURCE FOR SPORTS SDC",
        "address1": "2062 ST JOSEPH BLVD",
        "city": "ORLEANS",
        "postalCode": "K1C 1E6",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "613-824-5196",
        "latitude": "45.4656375",
        "longitude": "-75.53629140000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "18975"
            }
          ]
        }
      },
      {
        "storeId": "496",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "912 COLE HARBOUR RD",
        "city": "COLE HARBOUR",
        "postalCode": "B2V 1E6",
        "stateCode": "NS",
        "countryCode": "CA",
        "phone": "902-434-0022",
        "latitude": "44.669785",
        "longitude": "-63.499229",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "118",
        "name": "LARRY'S SPORT SHOP LTD.",
        "address1": "2029 LONSDALE AVENUE",
        "city": "NORTH VANCOUVER",
        "postalCode": "V7M 2K4",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "sales@myhockeystore.com",
        "phone": "604-987-6630",
        "latitude": "49.327816",
        "longitude": "-123.072467",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "steve@myhockeystore.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "223680"
            },
            {
              "attributeId": "soldToID",
              "text": "7012"
            }
          ]
        }
      },
      {
        "storeId": "126",
        "name": "TIME OUT SOURCE FOR SPORTS",
        "address1": "235 MOUNTAIN HIGHWAY",
        "city": "NORTH VANCOUVER",
        "postalCode": "V7J 3P2",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "stevesz6060@gmail.com",
        "phone": "604-980-9211",
        "latitude": "49.306603",
        "longitude": "-123.03202",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7012"
            },
            {
              "attributeId": "soldToID",
              "text": "7012"
            }
          ]
        }
      },
      {
        "storeId": "395",
        "name": "SPORT CHEK",
        "address1": "1350-16 STREET EAST",
        "city": "OWEN SOUND",
        "postalCode": "N4K 6N7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "44.5761293",
        "longitude": "-80.918766",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "4",
        "name": "JUST HOCKEY SOURCE FOR SPORTS",
        "address1": "900 DON MILLS RD UNIT 6",
        "city": "NORTH YORK",
        "postalCode": "M3C 1V6",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "sogden@justhockeytoronto.com",
        "phone": "866-578-4259",
        "latitude": "43.726987",
        "longitude": "-79.341494",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5339"
            },
            {
              "attributeId": "soldToID",
              "text": "5339"
            }
          ]
        }
      },
      {
        "storeId": "408",
        "name": "SPORT CHEK",
        "address1": "1417 HARMONY ROAD NORTH",
        "city": "OSHAWA",
        "postalCode": "L1H 7K5",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.9419255",
        "longitude": "-78.84811669999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "605",
        "name": "MARC SOURCE FOR SPORTS",
        "address1": "455 BOUL MALONEY EST",
        "city": "GATINEAU",
        "postalCode": "J8P 6Z8",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "ab2@lasourcesdc.com",
        "phone": "819-663-1069",
        "latitude": "45.485225",
        "longitude": "-75.636718",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5652"
            },
            {
              "attributeId": "soldToID",
              "text": "5652"
            }
          ]
        }
      },
      {
        "storeId": "413",
        "name": "SPORT CHEK",
        "address1": "501 TOLLGATE WEST",
        "city": "CORNWALL",
        "postalCode": "K6H 5R6",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.0409639",
        "longitude": "-74.76215169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "379",
        "name": "SPORT CHEK",
        "address1": "7555 MONTROSE RD, UNIT A-30",
        "city": "NIAGARA FALLS",
        "postalCode": "L2H 2E9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.0662077",
        "longitude": "-79.1255702",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "1176",
        "name": "SPORTS ROUSSEAU POINTE-CLAIRE",
        "address1": "183-F HYMUS BLVD",
        "city": "POINTE-CLAIRE",
        "postalCode": "H9R 1E9",
        "stateCode": "QC",
        "countryCode": "CA",
        "latitude": "45.464406",
        "longitude": "-73.811578",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false"
      },
      {
        "storeId": "609",
        "name": "SKATER'S EDGE SDC",
        "address1": "1338 KINGSWAY UNIT #1",
        "city": "SUDBURY",
        "postalCode": "P3B 0A3",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "matt@skatersedgesudbury.com",
        "phone": "705-566-1422",
        "latitude": "49.250577",
        "longitude": "-123.077358",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "12366"
            },
            {
              "attributeId": "soldToID",
              "text": "12366"
            }
          ]
        }
      },
      {
        "storeId": "576",
        "name": "ST ALBERT SPORTS LTD SDC",
        "address1": "10 580 ST ALBERT ROAD",
        "city": "SAINT ALBERT",
        "postalCode": "T8N 6M9",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "dridd@shaw.ca",
        "phone": "780-458-0000",
        "latitude": "53.652373",
        "longitude": "-113.629825",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6764"
            },
            {
              "attributeId": "soldToID",
              "text": "6764"
            }
          ]
        }
      },
      {
        "storeId": "66",
        "name": "SPORTS CONNECTION SOURCE FOR SPORTS",
        "address1": "833 KINGSWAY AVE S E",
        "city": "MEDICINE HAT",
        "postalCode": "T1A 2X5",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "403 529 6130",
        "latitude": "50.030535",
        "longitude": "-110.668822",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "6674"
            },
            {
              "attributeId": "soldToID",
              "text": "6674"
            }
          ]
        }
      },
      {
        "storeId": "305",
        "name": "SPORT CHEK",
        "address1": "60 QUARRY STREET EAST UNIT #2",
        "city": "COCHRANE",
        "postalCode": "T4C 0W6",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "51.1840988",
        "longitude": "-114.468426",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "329",
        "name": "SPORT CHEK",
        "address1": "3664 HIGHWAY 16 EAST",
        "city": "SMITHERS",
        "postalCode": "V0J 2N0",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "54.7803287",
        "longitude": "-127.1623871",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "293",
        "name": "SPORT CHEK",
        "address1": "501 1ST AVENUE S UNIT BO1",
        "city": "LETHBRIDGE",
        "postalCode": "T1J 4L9",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "49.69937230000001",
        "longitude": "-112.8407799",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "385",
        "name": "SPORT CHEK",
        "address1": "80 GREAT LAKES DRIVE #112",
        "city": "BRAMPTON",
        "postalCode": "L6R 2K7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.7281493",
        "longitude": "-79.7650038",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "56",
        "name": "MCTAGGARTS",
        "address1": "29 WHTYE AVE",
        "city": "DRYDEN",
        "postalCode": "P8N 1Z2",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "807 468 8979",
        "latitude": "49.783748",
        "longitude": "-92.838519",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5669"
            }
          ]
        }
      },
      {
        "storeId": "419",
        "name": "SPORT CHEK",
        "address1": "285 GENEVA STREET",
        "city": "ST CATHARINES",
        "postalCode": "L2N 2G1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.1777391",
        "longitude": "-79.2431139",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "369",
        "name": "SPORT CHEK",
        "address1": "HWY 26 & 27, 509 BAYFIELD STREET",
        "city": "BARRIE",
        "postalCode": "L4M 4Z8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.8703543",
        "longitude": "-123.5994473",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "296",
        "name": "SPORT CHEK",
        "address1": "2525-36TH STREET NE #250A",
        "city": "CALGARY",
        "postalCode": "T1Y 5T4",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "51.0738879",
        "longitude": "-113.9856369",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "447",
        "name": "DEVAULT LA SOURCE DU SPORT",
        "address1": "613 NOTRE-DAME RUE, PO BOX 172",
        "city": "REPENTIGNY",
        "postalCode": "J6A 2V3",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "450-561-5153",
        "latitude": "45.748928",
        "longitude": "-73.435373",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "4685"
            }
          ]
        }
      },
      {
        "storeId": "1226",
        "name": "HOCKEY EXPERTS ROCKLAND",
        "address1": "2305 CHEMIN ROCKLAND",
        "city": "MONT-ROYAL",
        "postalCode": "H3P 3E9",
        "stateCode": "QC",
        "countryCode": "CA",
        "latitude": "45.52778",
        "longitude": "-73.6488",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "shipToID",
              "text": "14177"
            },
            {
              "attributeId": "soldToID",
              "text": "14177"
            }
          ]
        }
      },
      {
        "storeId": "551",
        "name": "CARIBOU SKI SOURCE FOR SPORTS",
        "address1": "19 NORTH 1ST AVENUE",
        "city": "WILLIAMS LAKE",
        "postalCode": "V2G 4T6",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-392-5923",
        "latitude": "52.1290713",
        "longitude": "-122.1456524",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5840"
            }
          ]
        }
      },
      {
        "storeId": "1192",
        "name": "HOCKEY MONKEY",
        "address1": "61 BRUNSWICK BLVD",
        "city": "DOLLARD-DES-ORMEAUX",
        "postalCode": "H9B 2N4",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "514-542-4600",
        "latitude": "45.48255",
        "longitude": "-73.79893",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19173"
            },
            {
              "attributeId": "soldToID",
              "text": "19173"
            }
          ]
        }
      },
      {
        "storeId": "7",
        "name": "WARD & PATCH SOURCE FOR SPORTS",
        "address1": "13270 YONGE ST LOWER UNIT",
        "city": "RICHMOND HILL",
        "postalCode": "L4E 2T2",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "905 773-9273",
        "latitude": "43.951154",
        "longitude": "-79.45683",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7845"
            },
            {
              "attributeId": "soldToID",
              "text": "7845"
            }
          ]
        }
      },
      {
        "storeId": "175",
        "name": "DUNNYS SOURCE FOR SPORTS",
        "address1": "154 QUEEN ST E",
        "city": "ST. MARYS",
        "postalCode": "N4X 1C3",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-284-1446",
        "latitude": "43.2593278",
        "longitude": "-81.141346",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4709"
            }
          ]
        }
      },
      {
        "storeId": "3",
        "name": "MAJER HOCKEY",
        "address1": "4610 DUFFERIN STREET UNIT 4B",
        "city": "TORONTO",
        "postalCode": "M3H 5S4",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "joel@majerhockey.com",
        "phone": "877-736-7444",
        "latitude": "43.772581",
        "longitude": "-79.46907",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5309"
            },
            {
              "attributeId": "soldToID",
              "text": "5309"
            }
          ]
        }
      },
      {
        "storeId": "506",
        "name": "SPORTS EXPERTS FR840",
        "address1": "100 ROSEBERRY STREET",
        "city": "CAMBELTON",
        "postalCode": "E3N 2G8",
        "stateCode": "NB",
        "countryCode": "CA",
        "phone": "506-753-3233",
        "latitude": "48.0038914",
        "longitude": "-66.6796868",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14009"
            }
          ]
        }
      },
      {
        "storeId": "415",
        "name": "SPORT CHEK",
        "address1": "1800 SHEPPARD AVE EAST",
        "city": "TORONTO",
        "postalCode": "M2J 5A7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.7779901",
        "longitude": "-79.3440914",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "339",
        "name": "SPORT CHEK",
        "address1": "477 PAUL STREET, UNIT #Y003",
        "city": "DIEPPE",
        "postalCode": "E1A 4X5",
        "stateCode": "NB",
        "countryCode": "CA",
        "latitude": "46.098754",
        "longitude": "-64.76078799999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "454",
        "name": "HOCKEY EXPERTS 3118",
        "address1": "3218 BOULEVARD DE LA GARE",
        "city": "VAUDREUIL-DORI",
        "postalCode": "J7V 8W5",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "450-424-1911",
        "latitude": "45.4049677",
        "longitude": "-74.0454518",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "15463"
            }
          ]
        }
      },
      {
        "storeId": "455",
        "name": "HOCKEY EXPERTS",
        "address1": "401 BOUL CURE-LABELLE",
        "city": "ROSEMERE",
        "postalCode": "J7A 3T2",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "gbeaucher@beaulieusports.com",
        "phone": "450-437-1933",
        "latitude": "45.631405",
        "longitude": "-73.817873",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "ebouchard@beaulieusports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "15735"
            },
            {
              "attributeId": "soldToID",
              "text": "15735"
            }
          ]
        }
      },
      {
        "storeId": "580",
        "name": "ERNIE'S SPORTS EXPERTS",
        "address1": "11500 100TH STREET",
        "city": "GRANDE PRAIRIE",
        "postalCode": "T8V 4C2",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "deano@ernies.ca",
        "phone": "780-539-6262",
        "latitude": "55.184983",
        "longitude": "-118.795823",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "10256"
            },
            {
              "attributeId": "soldToID",
              "text": "10256"
            }
          ]
        }
      },
      {
        "storeId": "420",
        "name": "SPORT CHEK",
        "address1": "7850 WESTON ROAD",
        "city": "VAUGHAN",
        "postalCode": "L4L 9N8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.7907483",
        "longitude": "-79.54901760000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "573",
        "name": "OVERLANDER SPORTS  SDC",
        "address1": "4909 - 50TH STREET",
        "city": "YELLOWKNIFE",
        "postalCode": "X1A 2N7",
        "stateCode": "NT",
        "countryCode": "CA",
        "phone": "780-873-2474",
        "latitude": "62.4550121",
        "longitude": "-114.3730298",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5862"
            }
          ]
        }
      },
      {
        "storeId": "370",
        "name": "SPORT CHEK",
        "address1": "UNIT 4, 80 CONCERT WAY",
        "city": "BARRIE",
        "postalCode": "L4N 6N5",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "44.33897",
        "longitude": "-79.6834257",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "267",
        "name": "PRO HOCKEY LIFE",
        "address1": "ANCHOR O 5000 CANOE PASS WAY",
        "city": "TSAWWASSEN FIRS",
        "postalCode": "V4M 0B3",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.038163",
        "longitude": "-123.085703",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "222996"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "61",
        "name": "PLAY IT AGAIN",
        "address1": "920 MEMORIAL AVENUE",
        "city": "THUNDER BAY",
        "postalCode": "P7B 3Z9",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "playit@tbaytel.net",
        "phone": "807 622 8282",
        "latitude": "48.410377",
        "longitude": "-89.246001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6067"
            },
            {
              "attributeId": "soldToID",
              "text": "6067"
            }
          ]
        }
      },
      {
        "storeId": "333",
        "name": "SPORT CHEK",
        "address1": "3673 PORTAGE AVENUE",
        "city": "WINNIPEG",
        "postalCode": "R3K 2G6",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "49.8841757",
        "longitude": "-97.3146505",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "427",
        "name": "SPORT CHEK",
        "address1": "3100 HOWARD AVENUE SUITE #L1",
        "city": "WINDSOR",
        "postalCode": "N8X 3Y8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "42.2743221",
        "longitude": "-83.0018047",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "505",
        "name": "DOIRON SPORTS EXCELLENCE",
        "address1": "31 GREENHEAD STREET",
        "city": "SAINT JOHN",
        "postalCode": "E2M 5W1",
        "stateCode": "NB",
        "countryCode": "CA",
        "email": "Info@doironsports.ca",
        "phone": "506-672-1288",
        "latitude": "45.261061",
        "longitude": "-66.105416",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "10987"
            },
            {
              "attributeId": "soldToID",
              "text": "10987"
            }
          ]
        }
      },
      {
        "storeId": "74",
        "name": "ATOMIC SPORTS & LEISURE LTD",
        "address1": "202 2ND AVENUE WEST",
        "city": "MEADOW LAKE",
        "postalCode": "S9X 1Y5",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306 236 3288",
        "latitude": "54.13165830000001",
        "longitude": "-108.4340101",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "13755"
            },
            {
              "attributeId": "soldToID",
              "text": "13755"
            }
          ]
        }
      },
      {
        "storeId": "324",
        "name": "SPORT CHEK",
        "address1": "4900-27 STREET UNIT #0340",
        "city": "VERNON",
        "postalCode": "V1T 7G7",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "50.2839138",
        "longitude": "-119.2693074",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "336",
        "name": "SPORT CHEK",
        "address1": "1375 MCPHILLIPS STREET UNIT 1",
        "city": "WINNIPEG",
        "postalCode": "R2V 3V1",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "49.9402571",
        "longitude": "-97.1574851",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "431",
        "name": "SPORT CHEK",
        "address1": "17 CLAPPISON AVE, UNIT 2",
        "city": "WATERDOWN",
        "postalCode": "L0R 2H2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.3183926",
        "longitude": "-79.91378759999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "452",
        "name": "HOCKEY EXPERTS",
        "address1": "1265 7E RUE",
        "city": "VAL D OR",
        "postalCode": "J9P 3R9",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "alegault@sportsexpertsvd.ca",
        "phone": "819-825-6003",
        "latitude": "48.104176",
        "longitude": "-77.787069",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "malarouche@sportsexpertsvd.ca",
                "chgrenier@sportsexpertsvd.ca"
              ]
            },
            {
              "attributeId": "shipToID",
              "text": "14632"
            },
            {
              "attributeId": "soldToID",
              "text": "14632"
            }
          ]
        }
      },
      {
        "storeId": "373",
        "name": "SPORT CHEK",
        "address1": "14 MARTINDALE CRES UNIT 2",
        "city": "ANCASTER",
        "postalCode": "L9K 1J9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.22965",
        "longitude": "-79.9395566",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "125",
        "name": "CYCLONE TAYLOR SPORTS",
        "address1": "14140 TRIANGLE ROAD",
        "city": "RICHMOND",
        "postalCode": "V6W 1B1",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "604-448-1748",
        "latitude": "49.136183",
        "longitude": "-123.066635",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "alternateEmails",
              "value": "zoe@cyclonetaylor.com"
            },
            {
              "attributeId": "soldToID",
              "text": "7004"
            }
          ]
        }
      },
      {
        "storeId": "292",
        "name": "SPORT CHEK",
        "address1": "6455 MACLEOD TRAIL SW UNIT L6",
        "city": "CALGARY",
        "postalCode": "T2H 0K9",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "50.997526",
        "longitude": "-114.0734987",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "266",
        "name": "PRO HOCKEY LIFE",
        "address1": "1412 99TH ST",
        "city": "EDMONTON",
        "postalCode": "T6N 0A8",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.443381",
        "longitude": "-113.485625",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212731"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "49",
        "name": "DOUG'S SOURCE FOR SPORTS",
        "address1": "111 CREE ROAD",
        "city": "THOMPSON",
        "postalCode": "R8N 0B9",
        "stateCode": "MB",
        "countryCode": "CA",
        "phone": "204 677 1888",
        "latitude": "55.741349",
        "longitude": "-97.860141",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4701"
            },
            {
              "attributeId": "soldToID",
              "text": "4701"
            }
          ]
        }
      },
      {
        "storeId": "371",
        "name": "SPORT CHEK",
        "address1": "636 MARCOVE ROAD",
        "city": "MISSISSAUGA",
        "postalCode": "L5T 2R7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.6506985",
        "longitude": "-79.6841664",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "335",
        "name": "SPORT CHEK",
        "address1": "1570-18TH STREET",
        "city": "BRANDON",
        "postalCode": "R7A 5C5",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "49.82521329999999",
        "longitude": "-99.96420889999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "342",
        "name": "SPORT CHEK",
        "address1": "UNIT 102, 430 TOPSAIL ROAD",
        "city": "ST. JOHN’S",
        "postalCode": "A1E 4N1",
        "stateCode": "NFLD",
        "countryCode": "CA",
        "latitude": "47.534302",
        "longitude": "-52.7495519",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "432",
        "name": "SPORT CHEK",
        "address1": "636 MARCOVE ROAD",
        "city": "MISSISSAUGA",
        "postalCode": "L5T 2R7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.6506985",
        "longitude": "-79.6841664",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "482",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "204 CHAIN LAKE DR",
        "city": "HALIFAX",
        "postalCode": "B3S 1C5",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "cleves.bayerslake@sourceforsports.ca",
        "phone": "902-450-5353",
        "latitude": "44.65246",
        "longitude": "-63.673386",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224121"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "581",
        "name": "WINNER'S WAY SOURCE FOR SPORTS",
        "address1": "8802 100TH ST",
        "city": "FORT SASKATCHE",
        "postalCode": "T8L 4R2",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "780-998-2288",
        "latitude": "53.6980933",
        "longitude": "-113.2098073",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "13046"
            }
          ]
        }
      },
      {
        "storeId": "552",
        "name": "SCOFF'S HOCKEY SHOP",
        "address1": "3738 PARKER STREET",
        "city": "BURNABY",
        "postalCode": "V5C 3B1",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "604-298-5630",
        "latitude": "49.2754923",
        "longitude": "-123.0222069",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6513"
            }
          ]
        }
      },
      {
        "storeId": "172",
        "name": "BUCKNERS SPTG GOODS SDC",
        "address1": "151 QUEEN STREET",
        "city": "DUNNVILLE",
        "postalCode": "N1A 1H6",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "905-774-8871",
        "latitude": "42.9023928",
        "longitude": "-79.6180662",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "211849"
            },
            {
              "attributeId": "soldToID",
              "text": "4313"
            }
          ]
        }
      },
      {
        "storeId": "547",
        "name": "DOCKSTEADER SOURCE FOR SPORTS",
        "address1": "101-2381 KING GEORGE HWY.",
        "city": "SURREY",
        "postalCode": "V4A 5A4",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "604-536-6776",
        "latitude": "49.0449126",
        "longitude": "-122.794052",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4691"
            }
          ]
        }
      },
      {
        "storeId": "252",
        "name": "DANIEL LA SOURCE DU SPORT",
        "address1": "3333 RUE DU CARREFOUR LOC H-022A",
        "city": "QUEBEC",
        "postalCode": "G1C 5R9",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "418-661-8179",
        "latitude": "46.860776",
        "longitude": "-71.21739",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6676"
            }
          ]
        }
      },
      {
        "storeId": "272",
        "name": "PRO HOCKEY LIFE",
        "address1": "5945 LATIMER DRIVE",
        "city": "MISSISSAUGA",
        "postalCode": "L5V 1R7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.608168",
        "longitude": "-79.696817",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212470"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "428",
        "name": "SPORT CHEK",
        "address1": "75 CENTENNIAL PARKWAY NORTH",
        "city": "HAMILTON",
        "postalCode": "L8E 2P2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.2311747",
        "longitude": "-79.7655715",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "457",
        "name": "CORBETTS SOURCE FOR SPORTS",
        "address1": "450 SOUTH SERVICE ROAD WEST",
        "city": "OAKVILLE",
        "postalCode": "L6K 2H4",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "corbettssfs@outlook.com ",
        "phone": "905-337-9381",
        "latitude": "43.440406",
        "longitude": "-79.70519",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4573"
            },
            {
              "attributeId": "soldToID",
              "text": "4573"
            }
          ]
        }
      },
      {
        "storeId": "303",
        "name": "SPORT CHEK",
        "address1": "7000 EMERALD DRIVE UNIT 700",
        "city": "SHERWOOD PARK",
        "postalCode": "T8H 0P5",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.568484",
        "longitude": "-113.2804075",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "253",
        "name": "HOCKEY EXPERTS",
        "address1": "675 DE LA CONCORDE UNIT B40",
        "city": "SAINT ROMUALD",
        "postalCode": "G6W 8A7",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "418-834-5397",
        "latitude": "46.728994",
        "longitude": "-71.272042",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "13990"
            }
          ]
        }
      },
      {
        "storeId": "423",
        "name": "SPORT CHEK",
        "address1": "25 PEEL CENTRE DRIVE UNIT 0124A",
        "city": "BRAMPTON",
        "postalCode": "L6T 3R5",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.7154187",
        "longitude": "-79.7215812",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "184",
        "name": "BRANT SPORTS EXCELLENCE",
        "address1": "415 FAIRVIEW DR STE E",
        "city": "BRANTFORD",
        "postalCode": "N3R 7M3",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-752-3900",
        "latitude": "43.1724582",
        "longitude": "-80.25099399999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "12074"
            }
          ]
        }
      },
      {
        "storeId": "444",
        "name": "HOCKEY EXPERTS #3106",
        "address1": "2305 ROCKLAND LOCAL 0320",
        "city": "VILLE MONT-ROYAL",
        "postalCode": "H3P 3E9",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "514-787-1718",
        "latitude": "45.5281968",
        "longitude": "-73.6481237",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14177"
            }
          ]
        }
      },
      {
        "storeId": "5",
        "name": "PLAY IT AGAIN SPORTS - WHITBY",
        "address1": "24 1801 DUNDAS ST E",
        "city": "WHITBY",
        "postalCode": "L1N 7C5",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "905 728-8881",
        "latitude": "43.8871365",
        "longitude": "-78.9037788",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "6056"
            },
            {
              "attributeId": "soldToID",
              "text": "6056"
            }
          ]
        }
      },
      {
        "storeId": "450",
        "name": "INTERSPORT 673",
        "address1": "20 MANTEE MASSON",
        "city": "MASCOUCHE",
        "postalCode": "J7K 3B5",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "450-474-6168",
        "latitude": "45.7215131",
        "longitude": "-73.6218583",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "7650"
            }
          ]
        }
      },
      {
        "storeId": "417",
        "name": "SPORT CHEK",
        "address1": "2445 APPLEBY LINE UNIT #A03",
        "city": "BURLINGTON",
        "postalCode": "L7L 0B6",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.4059737",
        "longitude": "-79.80355060000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "183",
        "name": "PARIS SPORTS CENTRE",
        "address1": "19 BROADWAY STREET WEST",
        "city": "PARIS",
        "postalCode": "N3L 2S3",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-442-0766",
        "latitude": "43.1935654",
        "longitude": "-80.38530659999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "12074"
            }
          ]
        }
      },
      {
        "storeId": "256",
        "name": "HOCKEY EXPERTS 3117",
        "address1": "535 BOUL JUTRAS EST",
        "city": "VICTORIAVILLE",
        "postalCode": "G6P 7H4",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "819-604-4536",
        "latitude": "46.0571568",
        "longitude": "-71.9403471",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "15457"
            }
          ]
        }
      },
      {
        "storeId": "483",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "133 CHURCH ST",
        "city": "ANTIGONISH",
        "postalCode": "B2G 2E3",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "cleves.antigonish@sourceforsports.ca",
        "phone": "902-863-6650",
        "latitude": "45.617833",
        "longitude": "-61.983346",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224122"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "510",
        "name": "SPORTS ROUSSEAU",
        "address1": "1701 BOUL DES PROMENADES",
        "city": "ST-HUBERT",
        "postalCode": "J3Y 5K2",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "mamorin@sportsrousseau30.ca",
        "phone": "450-656-1701",
        "latitude": "45.48913",
        "longitude": "-73.382517",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18742"
            },
            {
              "attributeId": "soldToID",
              "text": "18742"
            }
          ]
        }
      },
      {
        "storeId": "438",
        "name": "SPORT CHEK",
        "address1": "1235 MAIN STREET N #13",
        "city": "MOOSE JAW",
        "postalCode": "S6H 6M4",
        "stateCode": "SK",
        "countryCode": "CA",
        "latitude": "50.4043447",
        "longitude": "-105.5298077",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "75",
        "name": "ADRENALIN SOURCE FOR SPORTS",
        "address1": "9309 MACLEOD TRAIL SOUTH",
        "city": "CALGARY",
        "postalCode": "T2J 0P6",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "John.Kobar@AdrenalinSFS.ca",
        "phone": "403 640 9950",
        "latitude": "50.971967",
        "longitude": "-114.072491",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "quinn.zapach@adrenalinsfs.ca"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "14213"
            },
            {
              "attributeId": "soldToID",
              "text": "14213"
            }
          ]
        }
      },
      {
        "storeId": "2",
        "name": "FONTAINE SOURCE FOR SPORTS SDC",
        "address1": "384 QUEEN STREET",
        "city": "PETERBOROUGH",
        "postalCode": "K9H 3J6",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "705-742-0511",
        "latitude": "44.3054652",
        "longitude": "-78.3174219",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4880"
            },
            {
              "attributeId": "soldToID",
              "text": "4880"
            }
          ]
        }
      },
      {
        "storeId": "381",
        "name": "SPORT CHEK",
        "address1": "401 KENT STREET W #37",
        "city": "LINDSAY",
        "postalCode": "K9V 4Z1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "44.3485431",
        "longitude": "-78.7601955",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "354",
        "name": "SPORT CHEK",
        "address1": "9107 COMMERCIAL STREET",
        "city": "NEW MINAS",
        "postalCode": "B4N 3E6",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "45.0679965",
        "longitude": "-64.4530939",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "607",
        "name": "VALIQUETTE SOURCE FOR SPORTS",
        "address1": "1740 CARLING AVE",
        "city": "OTTAWA",
        "postalCode": "K2A 1E1",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "613-725-5352",
        "latitude": "45.37774719999999",
        "longitude": "-75.7520787",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "7134"
            }
          ]
        }
      },
      {
        "storeId": "288",
        "name": "SPORT CHEK",
        "address1": "CRU F, 15530 - 37 STREET NW",
        "city": "EDMONTON",
        "postalCode": "T5Y0S5",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.6168232",
        "longitude": "-113.400219",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "328",
        "name": "SPORT CHEK",
        "address1": "4741 LAKELSE AVENUE",
        "city": "TERRACE",
        "postalCode": "V8G 4R9",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "54.5163579",
        "longitude": "-128.596308",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "124",
        "name": "CYCLONE TAYLOR SPORTS",
        "address1": "A-6 1020 AUSTIN AVE",
        "city": "COQUITLAM",
        "postalCode": "V3K 3P1",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "mark@cyclonetaylor.com",
        "phone": "604-936-0481",
        "latitude": "49.248717",
        "longitude": "-122.865882",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "justin@cyclonetaylor.com",
                "zoe@cyclonetaylor.com"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224117"
            },
            {
              "attributeId": "soldToID",
              "text": "7004"
            }
          ]
        }
      },
      {
        "storeId": "392",
        "name": "SPORT CHEK",
        "address1": "1735 RICHMOND STREET UNIT 3",
        "city": "LONDON",
        "postalCode": "N5X 3Y2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.0285788",
        "longitude": "-81.2848309",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "281",
        "name": "SPORT CHEK",
        "address1": "UNIT #G1, 901-64TH AVENUE NE",
        "city": "CALGARY",
        "postalCode": "T2E 7P4",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "579",
        "name": "FACTORY SPORTS EXCELLENCE",
        "address1": "4903 - 49TH AVE",
        "city": "LLOYDMINSTER",
        "postalCode": "S9V 0T6",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306-825-7678",
        "latitude": "53.28274469999999",
        "longitude": "-110.0033081",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "7687"
            }
          ]
        }
      },
      {
        "storeId": "391",
        "name": "SPORT CHEK",
        "address1": "199 RATHBURN ROAD W",
        "city": "MISSISSAUGA",
        "postalCode": "L5B 4C1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.5942096",
        "longitude": "-79.649249",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "374",
        "name": "SPORT CHEK",
        "address1": "84 LYBDEN ROAD",
        "city": "BRANTFORD",
        "postalCode": "N3R 6B8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.1713397",
        "longitude": "-80.2403125",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "277",
        "name": "PRO HOCKEY LIFE",
        "address1": "270 NORTH SERVICE RD W UNIT C",
        "city": "OAKVILLE",
        "postalCode": "L6M 2R8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.447527",
        "longitude": "-79.703263",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213376"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "185",
        "name": "MICOR SPORTS LTD",
        "address1": "49 FINCH DR UNIT #9",
        "city": "SARNIA",
        "postalCode": "N7S 5C6",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-337-8787",
        "latitude": "42.9697755",
        "longitude": "-82.354598",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "18937"
            }
          ]
        }
      },
      {
        "storeId": "504",
        "name": "INTERSPORT",
        "address1": "3372 PRINCIPALE",
        "city": "TRACADIE",
        "postalCode": "E1X 1G5",
        "stateCode": "NB",
        "countryCode": "CA",
        "email": "Jmr646@kwik.net",
        "phone": "506-395-3313",
        "latitude": "47.523487",
        "longitude": "-64.909991",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7637"
            },
            {
              "attributeId": "soldToID",
              "text": "7637"
            }
          ]
        }
      },
      {
        "storeId": "394",
        "name": "SPORT CHEK",
        "address1": "435 STONE ROAD WEST UNIT#R1",
        "city": "GUELPH",
        "postalCode": "N1G 2X6",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.5182747",
        "longitude": "-80.2387533",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "488",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "560 WESTVILLE ROAD, UNIT 2",
        "city": "NEW GLASGOW",
        "postalCode": "B2H 2J8",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "cleves.newglasgow@sourceforsports.ca",
        "phone": "902-755-6650",
        "latitude": "45.578236",
        "longitude": "-62.662218",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224127"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "499",
        "name": "MACTAVISH'S SOURCE FOR SPORTS",
        "address1": "228 QUEEN STREET",
        "city": "FREDERICTON",
        "postalCode": "E3B 1A7",
        "stateCode": "NB",
        "countryCode": "CA",
        "email": "Mactavsfsprders@gmail.com",
        "phone": "506-450-6006",
        "latitude": "45.964551",
        "longitude": "-66.647017",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5640"
            },
            {
              "attributeId": "soldToID",
              "text": "5640"
            }
          ]
        }
      },
      {
        "storeId": "404",
        "name": "SPORT CHEK",
        "address1": "1150 STEELES AVENUE EAST",
        "city": "MILTON",
        "postalCode": "L9T 6C8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.5406345",
        "longitude": "-79.87276849999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "67",
        "name": "PEMBINA SOURCE FOR SPORTS",
        "address1": "19 - 2077 PEMBINA HWY",
        "city": "WINNIPEG",
        "postalCode": "R3T 5J9",
        "stateCode": "MB",
        "countryCode": "CA",
        "phone": "204 275 3406",
        "latitude": "49.8149884",
        "longitude": "-97.1530851",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "6711"
            },
            {
              "attributeId": "soldToID",
              "text": "6711"
            }
          ]
        }
      },
      {
        "storeId": "QRC-LOGISTICS-LTD",
        "name": "QRC Logistics Ltd",
        "address1": "8020 Fifth Line",
        "city": "Halton Hills",
        "postalCode": "L7G 0B8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.632731",
        "longitude": "-79.878411",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            }
          ]
        }
      },
      {
        "storeId": "285",
        "name": "SPORT CHEK",
        "address1": "3070 - 9713 HARDIN STREET",
        "city": "FORT MCMURRAY",
        "postalCode": "T9H 1L2",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "56.72433849999999",
        "longitude": "-111.3791633",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "388",
        "name": "SPORT CHEK",
        "address1": "1 PROMENADE CIRCLE UNIT 117-8",
        "city": "THORNHILL",
        "postalCode": "L4J 4P8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.8059989",
        "longitude": "-79.45307249999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "446",
        "name": "HOCKEY SUPREMACY INC",
        "address1": "122 PAUL GAUGUIN",
        "city": "CANDIAC",
        "postalCode": "J5R 6X2",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "450-632-8787",
        "latitude": "45.3748163",
        "longitude": "-73.5261555",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "18840"
            }
          ]
        }
      },
      {
        "storeId": "299",
        "name": "SPORT CHEK",
        "address1": "5406 DISCOVEY WAY UNIT #104",
        "city": "LEDUC",
        "postalCode": "T9E 8L9",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.2709",
        "longitude": "-113.56637",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "425",
        "name": "SPORT CHEK",
        "address1": "1349 LASALLE BLVD",
        "city": "SUDBURY",
        "postalCode": "P3A 1Z2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "46.5199854",
        "longitude": "-80.9462559",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "301",
        "name": "SPORT CHEK",
        "address1": "3214 DUNMORE ROAD SE",
        "city": "MEDICINE HAT",
        "postalCode": "T1B 2X2",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "50.00664760000001",
        "longitude": "-110.6483287",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "70",
        "name": "WESTERN CYCLE SOURCE FOR SPORTS",
        "address1": "1550 8TH AVENUE",
        "city": "REGINA",
        "postalCode": "S4R 1E4",
        "stateCode": "SK",
        "countryCode": "CA",
        "email": "john@westerncycle.ca",
        "phone": "306 522 5678",
        "latitude": "50.456879",
        "longitude": "-104.603042",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "jeff@westerncycle.ca"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7226"
            },
            {
              "attributeId": "soldToID",
              "text": "7226"
            }
          ]
        }
      },
      {
        "storeId": "582",
        "name": "SIN BIN SPORTS",
        "address1": "2010B Sherwood Drive",
        "city": "SHERWOOD PARK",
        "postalCode": "T8A 0Z1",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "780-417-7462",
        "latitude": "53.525844",
        "longitude": "-113.294732",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "13621"
            },
            {
              "attributeId": "soldToID",
              "text": "13621"
            }
          ]
        }
      },
      {
        "storeId": "340",
        "name": "SPORT CHEK",
        "address1": "2441 KING GEORGE HIGHWAY UNIT 49",
        "city": "MIRAMICHI",
        "postalCode": "E1V 6W2",
        "stateCode": "NB",
        "countryCode": "CA",
        "latitude": "47.0307424",
        "longitude": "-65.49343999999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "337",
        "name": "SPORT CHEK",
        "address1": "1225 ST MARY'S ROAD UNIT#54A",
        "city": "WINNEPEG",
        "postalCode": "R2M 5E5",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "49.8288696",
        "longitude": "-97.11046630000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "325",
        "name": "SPORT CHEK",
        "address1": "805 CLOVERDALE AVENUE SUITE #104",
        "city": "VICTORIA",
        "postalCode": "V8X 2S9",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "48.4501559",
        "longitude": "-123.3703265",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "611",
        "name": "ROOKEZ EDGE SOURCE FOR SPORTS",
        "address1": "400 SECOND ST W",
        "city": "CORNWALL",
        "postalCode": "K6H 6B8",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "613-938-0001",
        "latitude": "45.0156622",
        "longitude": "-74.7371547",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14210"
            }
          ]
        }
      },
      {
        "storeId": "398",
        "name": "SPORT CHEK",
        "address1": "1500 RIVERSIDE DRIVE UNIT#A4",
        "city": "TIMMINS",
        "postalCode": "P4R 1A1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.4114855",
        "longitude": "-75.66309520000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "344",
        "name": "SPORT CHEK",
        "address1": "MAPLE VALLEY ROAD UNIT # M-02A",
        "city": "CORNERBROOK",
        "postalCode": "A2H 6L8",
        "stateCode": "NL",
        "countryCode": "CA",
        "latitude": "47.3686534",
        "longitude": "-122.0228237",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "380",
        "name": "SPORT CHEK",
        "address1": "15 ROBINSON LANE, UNIT C",
        "city": "PEMBROKE",
        "postalCode": "K8A 0A5",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.81483430000001",
        "longitude": "-77.0757209",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "6",
        "name": "TORONTO HOCKEY REPAIR",
        "address1": "1592 BLOOR STREET WEST",
        "city": "TORONTO",
        "postalCode": "M6P 1A7",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "416 533-1791",
        "latitude": "43.6561258",
        "longitude": "-79.45485839999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "7020"
            },
            {
              "attributeId": "soldToID",
              "text": "7020"
            }
          ]
        }
      },
      {
        "storeId": "176",
        "name": "DUNNYS SOURCE FOR SPORTS",
        "address1": "90 ERIE ST",
        "city": "STRATFORD",
        "postalCode": "N5A 2M4",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-271-1442",
        "latitude": "43.3700817",
        "longitude": "-80.984323",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4709"
            }
          ]
        }
      },
      {
        "storeId": "367",
        "name": "SPORT CHEK",
        "address1": "THAMES LEA PLAZA, 653 GRAND AVENUE WEST",
        "city": "CHATHAM",
        "postalCode": "N7L 1C5",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "42.3979898",
        "longitude": "-82.2119206",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "2000",
        "name": "DUKES SOURCE FOR SPORTS",
        "address1": "3876 BLOOR STREET W",
        "city": "ETOBICOKE",
        "postalCode": "M9B 1L3",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "dukes@sourceforsports.ca",
        "phone": "416-233-2011",
        "latitude": "43.640585",
        "longitude": "-79.540819",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4708"
            },
            {
              "attributeId": "soldToID",
              "text": "4708"
            }
          ]
        }
      },
      {
        "storeId": "180",
        "name": "PERANIS HOCKEY WORLD",
        "address1": "4380 WELLINGTON RD S. UNIT # 2",
        "city": "LONDON",
        "postalCode": "N6E 2Z6",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "jwainio@peranis.com",
        "phone": "519-685-2227",
        "latitude": "42.918187",
        "longitude": "-81.205578",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211382"
            },
            {
              "attributeId": "soldToID",
              "text": "6013"
            }
          ]
        }
      },
      {
        "storeId": "76",
        "name": "SUPREME SOURCE FOR SPORTS",
        "address1": "208 MAIN STREET",
        "city": "KINDERSLEY",
        "postalCode": "S0L 1S0",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306 463 4244",
        "latitude": "51.467226",
        "longitude": "-109.153824",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "18967"
            },
            {
              "attributeId": "soldToID",
              "text": "18967"
            }
          ]
        }
      },
      {
        "storeId": "321",
        "name": "SPORT CHEK",
        "address1": "2955 PHIPPS ROAD",
        "city": "VICTORIA",
        "postalCode": "V9B 2P5",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "48.4390151",
        "longitude": "-123.505624",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "46",
        "name": "B & P CYCLE AND SPORTS 2000 INC",
        "address1": "1717 52ND STREET S.E.",
        "city": "CALGARY",
        "postalCode": "T2A 1V1",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "403 272 7141",
        "latitude": "51.038618",
        "longitude": "-113.9588048",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4292"
            },
            {
              "attributeId": "soldToID",
              "text": "4292"
            }
          ]
        }
      },
      {
        "storeId": "270",
        "name": "PRO HOCKEY LIFE",
        "address1": "1 BASS PRO MILLS DR - UNIT C3",
        "city": "VAUGHAN",
        "postalCode": "L4K 5W4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.826479",
        "longitude": "-79.535316",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212245"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "350",
        "name": "SPORT CHEK",
        "address1": "245 ROBIE STREET #109",
        "city": "TRURO",
        "postalCode": "B2N 5N6",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "44.640799",
        "longitude": "-63.5869916",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "403",
        "name": "SPORT CHEK",
        "address1": "3275 MONARCH DRIVE UNIT #1",
        "city": "ORILLIA",
        "postalCode": "L3V 7Z4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "44.609154",
        "longitude": "-79.451461",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "9998",
        "name": "JD'S SKATE HAUS",
        "address1": "6925 CENTURY AVE",
        "city": "MISSISSAUGA",
        "postalCode": "L5N 0E3",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "Brad.Savelson@BAUER.COM",
        "latitude": "43.602816",
        "longitude": "-79.750472",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19609"
            },
            {
              "attributeId": "soldToID",
              "text": "19609"
            }
          ]
        }
      },
      {
        "storeId": "59",
        "name": "OLYMPIAN SPORTS DIV. MU",
        "address1": "1844 MCORMOND DR #146",
        "city": "SASKATOON",
        "postalCode": "S7S 0A6",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306 249 4565",
        "latitude": "52.1489605",
        "longitude": "-106.5691447",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5843"
            }
          ]
        }
      },
      {
        "storeId": "127",
        "name": "CHEVYS SOURCE FOR SPORTS",
        "address1": "#126 1876 COOPER ROAD",
        "city": "KELOWNA",
        "postalCode": "V1Y 9N6",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "greg@chevys-sfs.com",
        "phone": "250-712-0777",
        "latitude": "49.877225",
        "longitude": "-119.443044",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7145"
            },
            {
              "attributeId": "soldToID",
              "text": "7145"
            }
          ]
        }
      },
      {
        "storeId": "352",
        "name": "SPORT CHEK",
        "address1": "25 LEMLAIR ROW UNIT 10-2",
        "city": "DARTMOUTH",
        "postalCode": "B3B 0C6",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "44.69976519999999",
        "longitude": "-63.56615429999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "382",
        "name": "SPORT CHEK",
        "address1": "70 KING WILLIAM STREET B-02",
        "city": "HUNTSVILLE",
        "postalCode": "P1H 1A5",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.3351844",
        "longitude": "-79.20669339999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "407",
        "name": "SPORT CHEK",
        "address1": "300 LAKESHORE DRIVE UNIT 101",
        "city": "NORTHBAY",
        "postalCode": "P1A 3V2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "46.2822831",
        "longitude": "-79.4460288",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "1",
        "name": "DUKE'S CYCLE AND SPORT",
        "address1": "3876 BLOOR ST WEST",
        "city": "ETOBICOKE",
        "postalCode": "M9B 1L3",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "zackwilloughby@hotmail.com",
        "phone": "416 233-2011",
        "latitude": "43.640436",
        "longitude": "-79.54172",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4708"
            },
            {
              "attributeId": "soldToID",
              "text": "4708"
            }
          ]
        }
      },
      {
        "storeId": "345",
        "name": "SPORT CHEK",
        "address1": "132 BENNETT DRIVE",
        "city": "GANDER",
        "postalCode": "A1V 2H2",
        "stateCode": "NL",
        "countryCode": "CA",
        "latitude": "48.9513743",
        "longitude": "-54.6032904",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "317",
        "name": "SPORT CHEK",
        "address1": "19800 LOUGHEED HWY UNIT 405",
        "city": "PITT MEADOWS",
        "postalCode": "V3Y 2W1",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.2198721",
        "longitude": "-122.6718788",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "406",
        "name": "SPORT CHEK",
        "address1": "1925 DUNDAS STREET EAST UNIT #14",
        "city": "LONDON",
        "postalCode": "N5V 1P7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.0030131",
        "longitude": "-81.1730183",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "405",
        "name": "SPORT CHEK",
        "address1": "1105 WELLINGTON ROAD UNIT 93",
        "city": "LONDON",
        "postalCode": "N6E 1V4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "42.9323785",
        "longitude": "-81.226152",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "502",
        "name": "SPORTWHEELS SPORTS EXCELLENCE #7787",
        "address1": "209 SACKVILLE DRIVE",
        "city": "LOWER SACKVILLE",
        "postalCode": "B4C 2R5",
        "stateCode": "NS",
        "countryCode": "CA",
        "phone": "902-864-2333",
        "latitude": "44.7587309",
        "longitude": "-63.6682905",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6758"
            }
          ]
        }
      },
      {
        "storeId": "54",
        "name": "TAGG'S SOURCE FOR SPORTS",
        "address1": "578 SCOTT STREET",
        "city": "FORT FRANCES",
        "postalCode": "P9A 1G9",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "807 274 9209",
        "latitude": "48.610206",
        "longitude": "-93.386856",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5669"
            },
            {
              "attributeId": "soldToID",
              "text": "5669"
            }
          ]
        }
      },
      {
        "storeId": "268",
        "name": "PRO HOCKEY LIFE",
        "address1": "860 ST JAMES ST",
        "city": "WINNIPEG",
        "postalCode": "R3G 3J7",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "49.890071",
        "longitude": "-97.202395",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213174"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "443",
        "name": "ICI LA SOURCE DU SPORT",
        "address1": "5746 RUE JEAN-TALON E",
        "city": "SAINT LEONARD",
        "postalCode": "H1S 1M2",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "514-254-6111",
        "latitude": "45.584322",
        "longitude": "-73.580571",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5672"
            }
          ]
        }
      },
      {
        "storeId": "442",
        "name": "AU GRAND BAZAR LA SOURCE DU SPORT",
        "address1": "1141 RUE PRINCIPALE",
        "city": "GRANBY",
        "postalCode": "J2J 0M3",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "j.paradis@grandbazar.ca",
        "phone": "450-378-2022",
        "latitude": "45.420253",
        "longitude": "-72.770344",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "marco@grandbazar.ca"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4153"
            },
            {
              "attributeId": "soldToID",
              "text": "4153"
            }
          ]
        }
      },
      {
        "storeId": "554",
        "name": "KIRBY'S SOURCE FOR SPORTS",
        "address1": "894 CLOVERDALE AVENUE",
        "city": "VICTORIA",
        "postalCode": "V8X 2S8",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "sean@kirbyssports.com",
        "phone": "250-480-5030",
        "latitude": "48.451942",
        "longitude": "-123.368827",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "kirby@kirbyssports.com",
                "mark@kirbyssports.com",
                "jordyn@kirbyssports.com"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "10977"
            },
            {
              "attributeId": "soldToID",
              "text": "10977"
            }
          ]
        }
      },
      {
        "storeId": "353",
        "name": "SPORT CHEK",
        "address1": "215 CHAIN LAKE DR UNIT F 215",
        "city": "HALIFAX",
        "postalCode": "B3S 1C9",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "44.65342099999999",
        "longitude": "-63.67885",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "181",
        "name": "BRIAN'S CUSTOM PRO SHOP",
        "address1": "1495 TECUMSEH RD. E",
        "city": "WINDSOR",
        "postalCode": "N8W 1C2",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-254-5733",
        "latitude": "42.300419",
        "longitude": "-83.0036954",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "7488"
            }
          ]
        }
      },
      {
        "storeId": "494",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "730 SACKVILLE DR",
        "city": "LOWER SACKVILLE",
        "postalCode": "B4E 1R7",
        "stateCode": "NS",
        "countryCode": "CA",
        "phone": "902-865-7183",
        "latitude": "44.770584",
        "longitude": "-63.693823",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "485",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "9089 COMMERCIAL ST",
        "city": "NEW MINAS",
        "postalCode": "B4N 3E6",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "cleves.newminas@sourceforsports.ca",
        "phone": "902681-6650",
        "latitude": "45.067888",
        "longitude": "-64.453985",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224124"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "316",
        "name": "SPORT CHEK",
        "address1": "1320 WEST TRANS CANADA HWY #Y0500",
        "city": "KAMLOOPS",
        "postalCode": "V1S 1J2",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "50.6553762",
        "longitude": "-120.3714533",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "383",
        "name": "SPORT CHEK",
        "address1": "55 MOUNTAIN ROAD UNIT C4",
        "city": "COLLINGWOOD",
        "postalCode": "L9Y 4M2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "44.5027574",
        "longitude": "-80.2380608",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "48",
        "name": "CLASSIC SOURCE FOR SPORTS",
        "address1": "#321 201 SOUTHRIDGE DRIVE",
        "city": "OKOTOKS",
        "postalCode": "T1S 2E1",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "403 938 5772",
        "latitude": "50.70561",
        "longitude": "-113.97333",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4551"
            },
            {
              "attributeId": "soldToID",
              "text": "4551"
            }
          ]
        }
      },
      {
        "storeId": "119",
        "name": "MALLARD'S SOURCE FOR SPORTS",
        "address1": "660 18TH STREET",
        "city": "CASTLEGAR",
        "postalCode": "V1N 2M9",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-365-5588",
        "latitude": "49.299603",
        "longitude": "-117.656457",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5646"
            },
            {
              "attributeId": "soldToID",
              "text": "5646"
            }
          ]
        }
      },
      {
        "storeId": "312",
        "name": "SPORT CHEK",
        "address1": "19705 FRASER HWY",
        "city": "LANGLEY",
        "postalCode": "V3A 7E9",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.1146628",
        "longitude": "-122.6741906",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "366",
        "name": "SPORT CHEK",
        "address1": "3401 DUFFERIN STREET",
        "city": "TORONTO",
        "postalCode": "M6A 2T9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.7246843",
        "longitude": "-79.4541729",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "484",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "68 ROBIE ST",
        "city": "TRURO",
        "postalCode": "B2N 1L2",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "cleves.truro@sourceforsports.ca",
        "phone": "902-897-1122",
        "latitude": "45.366279",
        "longitude": "-63.313586",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224123"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "575",
        "name": "RED DEER SOURCE FOR SPORTS",
        "address1": "2250 50TH AVENUE",
        "city": "RED DEER",
        "postalCode": "T4R 1W5",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "403-347-3385",
        "latitude": "52.240134",
        "longitude": "-113.815218",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6285"
            }
          ]
        }
      },
      {
        "storeId": "283",
        "name": "SPORT CHEK",
        "address1": "261055 CROSSIRON BLVD., ANCHOR R",
        "city": "ROCKY VIEW",
        "postalCode": "T4A 0G3",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "51.2005054",
        "longitude": "-113.9946538",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "378",
        "name": "SPORT CHEK",
        "address1": "225 THE BOARDWALK UNIT #3",
        "city": "KITCHENER",
        "postalCode": "N2N 0B1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.4348009",
        "longitude": "-80.5624703",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "251",
        "name": "PLANTE SPORTS EXCELLENCE",
        "address1": "GALERIES DU CAP, 300 RUE BARKOFF",
        "city": "TROIS RIVIERES",
        "postalCode": "G8T 2A3",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "andre.plante@plantesports.com",
        "phone": "819-375-3858",
        "latitude": "46.37271",
        "longitude": "-72.559204",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "jf.lafreniere@plantesports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4577"
            },
            {
              "attributeId": "soldToID",
              "text": "4577"
            }
          ]
        }
      },
      {
        "storeId": "498",
        "name": "JESSOMES SOURCE FOR SPORTS",
        "address1": "692 VICTORIA ST",
        "city": "EDMUNDSTON",
        "postalCode": "E3V 3S9",
        "stateCode": "NB",
        "countryCode": "CA",
        "email": "peter@jessomesport.com",
        "phone": "506-735-6292",
        "latitude": "47.3891237",
        "longitude": "-68.3419303",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5323"
            },
            {
              "attributeId": "soldToID",
              "text": "5323"
            }
          ]
        }
      },
      {
        "storeId": "282",
        "name": "SPORT CHEK",
        "address1": "UNIT # 120 - 350R SHAWVILLE BLVD. SE",
        "city": "CALGARY",
        "postalCode": "T2Y 3S4",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "116",
        "name": "GERICK CYCLE & SPORTS LTD",
        "address1": "930 ROSSLAND AVENUE",
        "city": "TRAIL",
        "postalCode": "V1R 3N6",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-364-1661",
        "latitude": "49.09669150000001",
        "longitude": "-117.7165516",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4973"
            },
            {
              "attributeId": "soldToID",
              "text": "4973"
            }
          ]
        }
      },
      {
        "storeId": "129",
        "name": "MISSION SPORTS INC SEC",
        "address1": "#4 2121 SPRINGFIELD ROAD",
        "city": "KELOWNA",
        "postalCode": "V1Y 7X1",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-763-7499",
        "latitude": "49.87679",
        "longitude": "-119.44266",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "12996"
            },
            {
              "attributeId": "soldToID",
              "text": "12996"
            }
          ]
        }
      },
      {
        "storeId": "375",
        "name": "SPORT CHEK",
        "address1": "9255 WOODBINE AVENUE",
        "city": "MARKHAM",
        "postalCode": "L6C 1Y9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.8694259",
        "longitude": "-79.36142989999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "355",
        "name": "SPORT CHEK",
        "address1": "421 LEHAVE STREET",
        "city": "BRIDGEWATER",
        "postalCode": "B4V 3A2",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "44.377198",
        "longitude": "-64.5154506",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "322",
        "name": "SPORT CHEK",
        "address1": "1151-10 AVENUE SW UNIT 255",
        "city": "SALMON ARM",
        "postalCode": "V1E 1T3",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "50.6943785",
        "longitude": "-119.2988747",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "358",
        "name": "SPORT CHEK",
        "address1": "UNIT #HH4, 17600 YONGE STREET",
        "city": "NEWMARKET",
        "postalCode": "L3Y 4Z1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "439",
        "name": "SPORT CHEK",
        "address1": "2715 GORDON RD, UNIT 1Y2-A",
        "city": "REGINA",
        "postalCode": "S4S 6H8",
        "stateCode": "SK",
        "countryCode": "CA",
        "latitude": "50.4025624",
        "longitude": "-104.6219193",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "448",
        "name": "PLAY IT AGAIN SPORTS - KIRKLAND",
        "address1": "2973 BOUL ST CHARLES",
        "city": "KIRKLAND",
        "postalCode": "H9H 3B5",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "kpogue@videotron.ca",
        "phone": "514-697-1079",
        "latitude": "45.448998",
        "longitude": "-73.854007",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "gerardghantous@sympatico.ca"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6044"
            },
            {
              "attributeId": "soldToID",
              "text": "6044"
            }
          ]
        }
      },
      {
        "storeId": "458",
        "name": "T & T HOCKEY SHOP  SOURCE FOR SPORTS",
        "address1": "8 CARDEN ST",
        "city": "GUELPH",
        "postalCode": "N1H 3A2",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-836-8631",
        "latitude": "43.543687",
        "longitude": "-80.249283",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5133"
            }
          ]
        }
      },
      {
        "storeId": "486",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "17 OLD BRIDGE STREET",
        "city": "BRIDGEWATER",
        "postalCode": "B4V 3T6",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "cleves.bridgewater@sourceforsports.ca",
        "phone": "902-543-2475",
        "latitude": "44.379219",
        "longitude": "-64.516737",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224125"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "445",
        "name": "HOCKEY EXPERTS",
        "address1": "1495, RUE KING OUEST",
        "city": "SHERBROOKE",
        "postalCode": "J1J 2C1",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "yannickgodbout@hotmail.com",
        "phone": "819-346-4050",
        "latitude": "45.398809",
        "longitude": "-71.913081",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "hockeyexperts3108@hotmail.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "14351"
            },
            {
              "attributeId": "soldToID",
              "text": "14351"
            }
          ]
        }
      },
      {
        "storeId": "287",
        "name": "SPORT CHEK",
        "address1": "UNIT #100W, 3625 SHAGANAPPI TR. NW",
        "city": "CALGARY",
        "postalCode": "T3A 0E2",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "436",
        "name": "SPORT CHEK",
        "address1": "2223 VICTORIA AVENUE EAST",
        "city": "REGINA",
        "postalCode": "S4N 6E4",
        "stateCode": "SK",
        "countryCode": "CA",
        "latitude": "50.444989",
        "longitude": "-104.5521108",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "503",
        "name": "SOURCE FOR SPORTS SUMMERSIDE LTD",
        "address1": "454 GRANVILLE ST",
        "city": "SUMMERSIDE",
        "postalCode": "C1N 4K7",
        "stateCode": "PE",
        "countryCode": "CA",
        "phone": "902-436-3600",
        "latitude": "46.4111223",
        "longitude": "-63.78377150000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "7484"
            }
          ]
        }
      },
      {
        "storeId": "356",
        "name": "SPORT CHEK",
        "address1": "UNIT # 300, B3 - 147 LAIRD DRIVE",
        "city": "TORONTO",
        "postalCode": "M4G 4K1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "349",
        "name": "SPORT CHEK",
        "address1": "76 STARRS ROAD",
        "city": "YARMOUTH",
        "postalCode": "B5A 2T5",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "43.8447853",
        "longitude": "-66.1052716",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "479",
        "name": "MARITIME SPORTS",
        "address1": "242 LEWISVILLE RD",
        "city": "MONCTON",
        "postalCode": "E1A 2R5",
        "stateCode": "NB",
        "countryCode": "CA",
        "email": "maritime@sourceforsports.ca",
        "phone": "506-858-8421",
        "latitude": "46.101715",
        "longitude": "-64.765855",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224118"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "553",
        "name": "PLAYERS BENCH SPORTS AND EVOLVE BIKE",
        "address1": "2299 WESTWOOD DRIVE",
        "city": "PRINCE GEORGE",
        "postalCode": "V2N 4H3",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "sales@pgplayersbench.ca",
        "phone": "250-564-6002",
        "latitude": "53.9013",
        "longitude": "-122.782877",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7762"
            },
            {
              "attributeId": "soldToID",
              "text": "7762"
            }
          ]
        }
      },
      {
        "storeId": "289",
        "name": "SPORT CHEK",
        "address1": "2551, 8882 170TH STREET",
        "city": "EDMONTON",
        "postalCode": "T5T 4M2",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.5224397",
        "longitude": "-113.6218712",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "402",
        "name": "SPORT CHEK",
        "address1": "355 HESPELER ROAD UNIT #330",
        "city": "CAMBRIDGE",
        "postalCode": "N1R 6B3",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.39112840000001",
        "longitude": "-80.3220505",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "397",
        "name": "SPORT CHEK",
        "address1": "1067 ONTARIO STREET UNIT S2",
        "city": "STRATFORD",
        "postalCode": "N5A 6W6",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.3699529",
        "longitude": "-80.9455275",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "399",
        "name": "SPORT CHEK",
        "address1": "125 RIOCAN AVENUE UNIT #2",
        "city": "NEPEAN",
        "postalCode": "K2J 5G4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.2699985",
        "longitude": "-75.7394882",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "430",
        "name": "SPORT CHEK",
        "address1": "636 MARCOVE ROAD",
        "city": "MISSISSAUGA",
        "postalCode": "L5T 2R7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.6506985",
        "longitude": "-79.6841664",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "348",
        "name": "SPORT CHEK",
        "address1": "181 DAMASCUS ROAD UNIT 2",
        "city": "BEDFORD",
        "postalCode": "B4A 0C2",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "44.7513285",
        "longitude": "-63.6474432",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "426",
        "name": "SPORT CHEK",
        "address1": "1000 FORT WILLIAMS ROAD",
        "city": "THUNDER BAY",
        "postalCode": "P7B 6B9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "48.40226920000001",
        "longitude": "-89.2440292",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "53",
        "name": "SOURCE FOR SPORTS",
        "address1": "365J MARQUIS RD WEST",
        "city": "PRINCE ALBERT",
        "postalCode": "S6V 7L4",
        "stateCode": "SK",
        "countryCode": "CA",
        "email": "scott.pasfs@sasktel.net",
        "phone": "306 764 3259",
        "latitude": "53.179706",
        "longitude": "-105.764268",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "mike.pasfs@sasktel.net"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5515"
            },
            {
              "attributeId": "soldToID",
              "text": "5515"
            }
          ]
        }
      },
      {
        "storeId": "338",
        "name": "SPORT CHEK",
        "address1": "UNIT Y005, 519 WESTMORELAND ROAD (MCALLISTER PLACE MALL)",
        "city": "SAINT JOHN",
        "postalCode": "E2J 3W9",
        "stateCode": "NB",
        "countryCode": "CA",
        "latitude": "45.3086451",
        "longitude": "-66.016058",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "555",
        "name": "KIRBY'S SOURCE FOR SPORTS",
        "address1": "UNIT 4-1925 BOWEN ROAD",
        "city": "NANAIMO",
        "postalCode": "V9S 1H1",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "kirby@kirbyssports.com",
        "phone": "250-585-5066",
        "latitude": "49.1857929",
        "longitude": "-123.9846118",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "221432"
            },
            {
              "attributeId": "soldToID",
              "text": "10977"
            }
          ]
        }
      },
      {
        "storeId": "115",
        "name": "DOLSON SOURCE FOR SPORTS",
        "address1": "251-1320 W TRANS CANADA",
        "city": "KAMLOOPS",
        "postalCode": "V1S 1J2",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-372-5531",
        "latitude": "50.655415",
        "longitude": "-120.371969",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4694"
            },
            {
              "attributeId": "soldToID",
              "text": "4694"
            }
          ]
        }
      },
      {
        "storeId": "276",
        "name": "PRO HOCKEY LIFE",
        "address1": "75 CONSUMERS DR - BLDG U",
        "city": "WHITBY",
        "postalCode": "L1N 1C4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.867842",
        "longitude": "-78.914724",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212478"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "360",
        "name": "SPORT CHEK",
        "address1": "UNIT #L019A, 645 LANSDOWNE STREET WEST",
        "city": "PETERBOROUGH",
        "postalCode": "K9J 7Y5",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "132",
        "name": "COAST TO COAST HOCKEY SHOP",
        "address1": "446 FRONT STREET EAST",
        "city": "TORONTO",
        "postalCode": "M5A 0J6",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "416-698-7405",
        "latitude": "43.6527325",
        "longitude": "-79.3576557",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "222670"
            },
            {
              "attributeId": "soldToID",
              "text": "18801"
            }
          ]
        }
      },
      {
        "storeId": "451",
        "name": "SPORTS AUX PUCES ST - JEROME",
        "address1": "8 BOULEVARD DE LA SALETTE SUITE",
        "city": "SAINT JEROME",
        "postalCode": "J7Y 5C8",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "450-565-9886",
        "latitude": "45.7965138",
        "longitude": "-74.02716769999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "13233"
            }
          ]
        }
      },
      {
        "storeId": "311",
        "name": "SPORT CHEK",
        "address1": "UNIT 126, 6631 ISLAND HWY. NORTH",
        "city": "NANAIMO",
        "postalCode": "V9T 4T7",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.2354174",
        "longitude": "-124.0501976",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "377",
        "name": "SPORT CHEK",
        "address1": "218 YONGE STREET UNIT CRU-R1",
        "city": "TORONTO",
        "postalCode": "M5B 2H6",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "scott.ritchie@bauer.com",
        "latitude": "43.653199",
        "longitude": "-79.380717",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "alternateEmails",
              "value": "rohit.thaduvai@bauer.com"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "304",
        "name": "SPORT CHEK",
        "address1": "100 SOUTHBANK BOULEVARD",
        "city": "OKOTOKS",
        "postalCode": "T1S 0L3",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "50.7054869",
        "longitude": "-113.9484915",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "319",
        "name": "SPORT CHEK",
        "address1": "2929 BARNETT HIGHWAY UNIT 1400",
        "city": "COQUITLAM",
        "postalCode": "V3B 5R5",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.2795624",
        "longitude": "-122.7984466",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "433",
        "name": "SPORT CHEK",
        "address1": "475 GRANVILLE STREET",
        "city": "SUMMERSIDE",
        "postalCode": "C1N 4P7",
        "stateCode": "PE",
        "countryCode": "CA",
        "latitude": "46.4122254",
        "longitude": "-63.7808422",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "545",
        "name": "ALL SEASONS SOURCE FOR SPORTS",
        "address1": "4555 LAKELSE AVE",
        "city": "TERRACE",
        "postalCode": "V8G 1P7",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-635-2982",
        "latitude": "54.5163466",
        "longitude": "-128.5861708",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4123"
            }
          ]
        }
      },
      {
        "storeId": "64",
        "name": "ROYAL SPORT SHOP SEC",
        "address1": "650 RALIEGH STREET",
        "city": "WINNIPEG",
        "postalCode": "R2K 3Z9",
        "stateCode": "MB",
        "countryCode": "CA",
        "email": "royalpem@mymts.net",
        "phone": "204 668 4584",
        "latitude": "49.919494",
        "longitude": "-97.084863",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Gerald.haasbeek@mymts.net"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6316"
            },
            {
              "attributeId": "soldToID",
              "text": "6316"
            }
          ]
        }
      },
      {
        "storeId": "120",
        "name": "MALLARD'S SKI & SPORT SDC",
        "address1": "532 BAKER STREET",
        "city": "NELSON",
        "postalCode": "V1N 4H9",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-352-3200",
        "latitude": "49.4919445",
        "longitude": "-117.2932257",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "213100"
            },
            {
              "attributeId": "soldToID",
              "text": "5646"
            }
          ]
        }
      },
      {
        "storeId": "501",
        "name": "SPORTSCRAFT SOURCE FOR SPORTS",
        "address1": "20 ROPEWALK LANE",
        "city": "SAINT JOHN'S",
        "postalCode": "A1E 5T2",
        "stateCode": "NL",
        "countryCode": "CA",
        "email": "Crocker_mark@yahoo.com",
        "phone": "709-753-7558",
        "latitude": "47.555296",
        "longitude": "-52.734713",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6667"
            },
            {
              "attributeId": "soldToID",
              "text": "6667"
            }
          ]
        }
      },
      {
        "storeId": "368",
        "name": "SPORT CHEK",
        "address1": "UNIT 2400, 110 PLACE D'ORLEANS DRIVE",
        "city": "ORLEANS",
        "postalCode": "K1C 2L9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.4781702",
        "longitude": "-75.5155527",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "63",
        "name": "PROFESSIONAL SKATE",
        "address1": "3515 18TH STREET S W",
        "city": "CALGARY",
        "postalCode": "T2T 4T9",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "josh@psscalgary.com",
        "phone": "403 243 3663",
        "latitude": "51.022621",
        "longitude": "-114.10528",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6121"
            },
            {
              "attributeId": "soldToID",
              "text": "6121"
            }
          ]
        }
      },
      {
        "storeId": "332",
        "name": "SPORT CHEK",
        "address1": "178 PTH 12 NORTH",
        "city": "STEINBACH",
        "postalCode": "R5G 1T7",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "49.547208",
        "longitude": "-96.69141499999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "500",
        "name": "RUDDERHAM'S SOURCE FOR SPORTS",
        "address1": "21 KELTIC DRIVE",
        "city": "SYDNEY RIVER",
        "postalCode": "B1S 1P4",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "rudder08@hotmail.com",
        "phone": "902-562-3666",
        "latitude": "46.109112",
        "longitude": "-60.223918",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6319"
            },
            {
              "attributeId": "soldToID",
              "text": "6319"
            }
          ]
        }
      },
      {
        "storeId": "69",
        "name": "TUXEDO SOURCE FOR SPORTS",
        "address1": "2520 CENTRE ST N",
        "city": "CALGARY",
        "postalCode": "T2E 2V2",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "kevin@tuxedosports.ca",
        "phone": "403 277 2872",
        "latitude": "51.074998",
        "longitude": "-114.062163",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "ryanr@tuxedosports.ca"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7062"
            },
            {
              "attributeId": "soldToID",
              "text": "7062"
            }
          ]
        }
      },
      {
        "storeId": "376",
        "name": "SPORT CHEK",
        "address1": "9350 YONGE STREET UNIT Y-2",
        "city": "RICHMOND HILL",
        "postalCode": "L4C 5G2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.8548902",
        "longitude": "-79.43487739999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "45",
        "name": "AL ANDERSON SOURCE FOR SPORTS",
        "address1": "208 AVENUE B SOUTH",
        "city": "SASKATOON",
        "postalCode": "S7M 1M4",
        "stateCode": "SK",
        "countryCode": "CA",
        "email": "chris@alandersons.com",
        "phone": "306 652 9412",
        "latitude": "52.127282",
        "longitude": "-106.671443",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "bretzky@alandersons.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4131"
            },
            {
              "attributeId": "soldToID",
              "text": "4131"
            }
          ]
        }
      },
      {
        "storeId": "318",
        "name": "SPORT CHEK",
        "address1": "12101-72 AVENUE UNIT 120",
        "city": "SURREY",
        "postalCode": "V3W 2M1",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.1356423",
        "longitude": "-122.8862994",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "273",
        "name": "PRO HOCKEY LIFE",
        "address1": "50 SPORTSWORLD CROSSING RD UNIT 6",
        "city": "KITCHENER",
        "postalCode": "N2P 0A6",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.409837",
        "longitude": "-80.395178",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212472"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "459",
        "name": "SANDERSON SOURCE  SDC",
        "address1": "56 BROADWAY AVE",
        "city": "ORANGEVILLE",
        "postalCode": "L9W 1J4",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-942-4891",
        "latitude": "43.9202054",
        "longitude": "-80.0917722",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "6470"
            }
          ]
        }
      },
      {
        "storeId": "437",
        "name": "SPORT CHEK",
        "address1": "400 KING ST #1220",
        "city": "ESTEVAN",
        "postalCode": "S4A 2B4",
        "stateCode": "SK",
        "countryCode": "CA",
        "latitude": "38.8044397",
        "longitude": "-77.04394309999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "306",
        "name": "SPORT CHEK",
        "address1": "UNIT # 1140, 6551 NO. 3 ROAD",
        "city": "RICHMOND",
        "postalCode": "V6Y 2B6",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "585",
        "name": "HABITUAL SPORTS",
        "address1": "BAY 18-36 RIEDEL ST",
        "city": "FORT MCMURRAY",
        "postalCode": "T9H 3E1",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "587-276-1097",
        "latitude": "56.72472",
        "longitude": "-111.362449",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "18542"
            }
          ]
        }
      },
      {
        "storeId": "284",
        "name": "SPORT CHEK",
        "address1": "UNIT #1160, 33 HERITAGE MEADOWS WAY SE",
        "city": "CALGARY",
        "postalCode": "T2H 3B8",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "0",
        "name": "ALL PRO SOURCE FOR SPORTS",
        "address1": "38 PARKSIDE DRIVE UNIT 5",
        "city": "NEWMARKET",
        "postalCode": "L3Y 8J9",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "905 898-5481",
        "latitude": "44.054909",
        "longitude": "-79.472974",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4121"
            },
            {
              "attributeId": "soldToID",
              "text": "4121"
            }
          ]
        }
      },
      {
        "storeId": "361",
        "name": "SPORT CHEK",
        "address1": "UNIT Y-006, 945 GARDINERS ROAD",
        "city": "KINGSTON",
        "postalCode": "K7M 7H4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "44.2563363",
        "longitude": "-76.57217100000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "493",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "5657 SPRING GARDEN RD",
        "city": "HALIFAX",
        "postalCode": "B3J 3R4",
        "stateCode": "NS",
        "countryCode": "CA",
        "phone": "902-420-1649",
        "latitude": "44.642951",
        "longitude": "-63.578548",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "548",
        "name": "SPORTS ZONE SPORTS EXCELLENCE",
        "address1": "33147 SOUTH FRASER WAY",
        "city": "ABBOTSFORD",
        "postalCode": "V2S 2B1",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "604-852-1640",
        "latitude": "49.050818",
        "longitude": "-122.305748",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4847"
            }
          ]
        }
      },
      {
        "storeId": "269",
        "name": "PRO HOCKEY LIFE",
        "address1": "200 HECTOR GATE",
        "city": "DARTMOUTH",
        "postalCode": "B3B 0E6",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "44.706355",
        "longitude": "-63.560511",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "213173"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "255",
        "name": "HOCKEY LJP INC",
        "address1": "12515 1E AVE",
        "city": "SAINT GEORGES",
        "postalCode": "G5Y 2E4",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "418-228-8199",
        "latitude": "46.0583423",
        "longitude": "-70.53802040000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "15109"
            }
          ]
        }
      },
      {
        "storeId": "275",
        "name": "PRO HOCKEY LIFE",
        "address1": "2420 BANK ST",
        "city": "OTTAWA",
        "postalCode": "K1V 8S1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.35391",
        "longitude": "-75.649947",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212476"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "606",
        "name": "SOO SOURCE FOR SPORTS",
        "address1": "208 QUEEN ST. E.",
        "city": "SAULT STE MARIE",
        "postalCode": "P6A 1Y7",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "soosports@hotmail.com",
        "latitude": "46.51512",
        "longitude": "-84.337256",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6642"
            },
            {
              "attributeId": "soldToID",
              "text": "6642"
            }
          ]
        }
      },
      {
        "storeId": "386",
        "name": "SPORT CHEK",
        "address1": "1250 FANSHAWE PARK RD W UNIT 101",
        "city": "LONDON",
        "postalCode": "N6G 5B1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.0115947",
        "longitude": "-81.3316421",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "182",
        "name": "PERANIS HOCKEY SHOP",
        "address1": "7540 TECUMSHE RD E",
        "city": "WINDSOR",
        "postalCode": "N8T 1E9",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "jwainio@peranis.com",
        "phone": "519-974-8081",
        "latitude": "42.314066",
        "longitude": "-82.936341",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6013"
            },
            {
              "attributeId": "soldToID",
              "text": "6013"
            }
          ]
        }
      },
      {
        "storeId": "310",
        "name": "SPORT CHEK",
        "address1": "788 ROBSON STREET",
        "city": "VANCOUVER",
        "postalCode": "V6Z 1A1",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.2817921",
        "longitude": "-123.1208345",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "421",
        "name": "SPORT CHEK",
        "address1": "221 GLENDALE AVENUE UNIT 119",
        "city": "ST CATHERINES",
        "postalCode": "L2T 2K9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.1377241",
        "longitude": "-79.2256419",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "58",
        "name": "OLYMPIAN SPORTS DIV. MU",
        "address1": "101 IDYLWYLD DRIVE NORTH",
        "city": "SASKATOON",
        "postalCode": "S7L 0Y6",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306 934 6771",
        "latitude": "52.1295641",
        "longitude": "-106.6706906",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5843"
            },
            {
              "attributeId": "soldToID",
              "text": "5843"
            }
          ]
        }
      },
      {
        "storeId": "583",
        "name": "ERNIES SPORTS EXPERTS",
        "address1": "9600-93 AVE - UNIT 3020",
        "city": "FORT ST JOHN",
        "postalCode": "V1J 5Z2",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "lugi@ernies.ca",
        "phone": "250-785-7771",
        "latitude": "56.237072",
        "longitude": "-120.842171",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "14223"
            },
            {
              "attributeId": "soldToID",
              "text": "14223"
            }
          ]
        }
      },
      {
        "storeId": "390",
        "name": "SPORT CHEK",
        "address1": "320 TAUNTON ROAD EAST BLDG G",
        "city": "WHITBY",
        "postalCode": "L1R 0H4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.92081",
        "longitude": "-78.94420389999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "389",
        "name": "SPORT CHEK",
        "address1": "12730 HIGHWAY 50 UNIT #1",
        "city": "BOLTON",
        "postalCode": "L7E 4G1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.8618983",
        "longitude": "-79.7154946",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "343",
        "name": "SPORT CHEK",
        "address1": "75 ABERDEEN DRIVE",
        "city": "ST. JOHN’S",
        "postalCode": "A1A 5N6",
        "stateCode": "NFLD",
        "countryCode": "CA",
        "latitude": "47.6175821",
        "longitude": "-52.7161526",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "263",
        "name": "PRO HOCKEY LIFE",
        "address1": "261055 CROSSIRON BLVD - LOCAL 6B",
        "city": "CALGARY",
        "postalCode": "T4A 0G3",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "51.203221",
        "longitude": "-113.993071",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212728"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "409",
        "name": "SPORT CHEK",
        "address1": "140 QUEENSWAY EAST",
        "city": "SIMCOE",
        "postalCode": "N3Y 4Y7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "42.8477757",
        "longitude": "-80.2937352",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "411",
        "name": "SPORT CHEK",
        "address1": "75 GUNNS ROAD UNIT 105",
        "city": "TORONTO",
        "postalCode": "M6N 0A3",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.6745428",
        "longitude": "-79.4714918",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "546",
        "name": "CHEAM SOURCE FOR SPORTS",
        "address1": "9077 YOUNG ROAD",
        "city": "CHILLIWACK",
        "postalCode": "V2P 4R3",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "604-792-1130",
        "latitude": "49.1671712",
        "longitude": "-121.9530068",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4540"
            }
          ]
        }
      },
      {
        "storeId": "294",
        "name": "SPORT CHEK",
        "address1": "151 CENTURY CROSSING 100",
        "city": "SPRUCE GROVE",
        "postalCode": "T7X 0C8",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.5426363",
        "longitude": "-113.8779006",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "550",
        "name": "THE HOCKEY SHOP - SOURCE FOR SPORTS",
        "address1": "20202 66 AVE UNIT F1",
        "city": "LANGLEY",
        "postalCode": "V2Y 1P3",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "sales@thehockeyshop.com",
        "phone": "604-589-8299",
        "latitude": "49.189455",
        "longitude": "-122.847405",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5135"
            },
            {
              "attributeId": "soldToID",
              "text": "5135"
            }
          ]
        }
      },
      {
        "storeId": "1201",
        "name": "JD's Skate Haus",
        "address1": "60 RUE JEAN-PAUL-CAYER",
        "city": "BLAINVILLE",
        "postalCode": "J7C 0N9",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "Marc-Olivier.Lessard@bauer.com",
        "latitude": "45.686299",
        "longitude": "-73.921703",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "isAcceptingInStorePickup",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19609"
            },
            {
              "attributeId": "soldToID",
              "text": "19609"
            }
          ]
        }
      },
      {
        "storeId": "68",
        "name": "BRANDON SOURCE FOR SPORTS",
        "address1": "2025 BRANDON AVENUE",
        "city": "BRANDON",
        "postalCode": "R7B 4E5",
        "stateCode": "MB",
        "countryCode": "CA",
        "email": "joel@brandonsourceforsports.com",
        "phone": "204 727 0756",
        "latitude": "49.833421",
        "longitude": "-99.965926",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "blbarnes@mymts.net"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6749"
            },
            {
              "attributeId": "soldToID",
              "text": "6749"
            }
          ]
        }
      },
      {
        "storeId": "254",
        "name": "HOCKEY EXPERTS #3101",
        "address1": "2946 BOUL DES RECOLLETS",
        "city": "TROIS RIVIERES",
        "postalCode": "G9A 6J2",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "819-378-9374",
        "latitude": "46.3319299",
        "longitude": "-72.5716377",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14063"
            }
          ]
        }
      },
      {
        "storeId": "57",
        "name": "DISCOVERY CO-OPERATIVE LTD",
        "address1": "1902-9800 TERRITORIAL DR",
        "city": "NORTH BATTLEFO",
        "postalCode": "S9A 3W6",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306 446 7276",
        "latitude": "52.7904508",
        "longitude": "-108.3039103",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5788"
            },
            {
              "attributeId": "soldToID",
              "text": "5788"
            }
          ]
        }
      },
      {
        "storeId": "604",
        "name": "FIGURE 8 SKATE SPECIALISTS",
        "address1": "380 INDUSTRIAL AVE",
        "city": "OTTAWA",
        "postalCode": "K1G 0Y9",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "613-731-4007",
        "latitude": "45.4111621",
        "longitude": "-75.65273909999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4876"
            }
          ]
        }
      },
      {
        "storeId": "435",
        "name": "SPORT CHEK",
        "address1": "3310 - 8TH STREET EAST",
        "city": "SASKATOON",
        "postalCode": "S7H 5M3",
        "stateCode": "SK",
        "countryCode": "CA",
        "latitude": "52.11421319999999",
        "longitude": "-106.6010301",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "574",
        "name": "SKATE - TECH LTD.",
        "address1": "9212 51ST AVE",
        "city": "EDMONTON",
        "postalCode": "T6E 5L8",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "darrells@proskate.ca",
        "phone": "780-438-9059",
        "latitude": "53.488666",
        "longitude": "-113.469151",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6122"
            },
            {
              "attributeId": "soldToID",
              "text": "6122"
            }
          ]
        }
      },
      {
        "storeId": "65",
        "name": "ROYAL SPORT SHOP SEC",
        "address1": "750 PEMBINA HIGHWAY",
        "city": "WINNIPEG",
        "postalCode": "R3M 2M7",
        "stateCode": "MB",
        "countryCode": "CA",
        "email": "royalpem@mymts.net",
        "phone": "204 453 7437",
        "latitude": "49.859069",
        "longitude": "-97.149901",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "Gerald.haasbeek@mymts.net"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "211537"
            },
            {
              "attributeId": "soldToID",
              "text": "6316"
            }
          ]
        }
      },
      {
        "storeId": "173",
        "name": "BUCKNERS SOURCE FOR SPORTS",
        "address1": "545 NIAGARA STREET",
        "city": "WELLAND",
        "postalCode": "L3C 1L7",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "905-734-6422",
        "latitude": "43.00568",
        "longitude": "-79.252963",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "211850"
            },
            {
              "attributeId": "soldToID",
              "text": "4313"
            }
          ]
        }
      },
      {
        "storeId": "262",
        "name": "GO HOCKEY",
        "address1": "989 BOULEVARD PIERRE-BERTRAND SUD",
        "city": "QUEBEC",
        "postalCode": "G1M 2E8",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "581-300-3434",
        "latitude": "46.8273121",
        "longitude": "-71.2759787",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "18786"
            }
          ]
        }
      },
      {
        "storeId": "171",
        "name": "BUCKNERS SOURCE FOR SPORTS",
        "address1": "3681 PORTAGE ROAD",
        "city": "NIAGRA FALLS",
        "postalCode": "L2J 2K8",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "905-356-2943",
        "latitude": "43.120106",
        "longitude": "-79.100375",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "208961"
            },
            {
              "attributeId": "soldToID",
              "text": "4313"
            }
          ]
        }
      },
      {
        "storeId": "1173",
        "name": "Sports Rousseau Terrebonne",
        "address1": "1000, boul. des Seigneurs",
        "city": "Terrebonne",
        "postalCode": "J6W 1V1",
        "stateCode": "QUEBEC",
        "countryCode": "CA",
        "phone": "450-471-6996",
        "latitude": "45.70128",
        "longitude": "-73.64257",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "19644"
            },
            {
              "attributeId": "soldToID",
              "text": "19644"
            }
          ]
        }
      },
      {
        "storeId": "178",
        "name": "FRONT ROW SPORTS MU",
        "address1": "133 FRONT ST NO - UNIT 3",
        "city": "THOROLD",
        "postalCode": "L2V 0A3",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "marrone@frontrowsport.com",
        "phone": "905-680-4588",
        "latitude": "43.131933",
        "longitude": "-79.200964",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4890"
            },
            {
              "attributeId": "soldToID",
              "text": "4890"
            }
          ]
        }
      },
      {
        "storeId": "170",
        "name": "BUCKNERS SOURCE FOR SPORTS",
        "address1": "474 MAIN ST W",
        "city": "PORT COLBOURNE",
        "postalCode": "L3K 3W1",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "905-835-5835",
        "latitude": "42.89866",
        "longitude": "-79.259934",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "4313"
            },
            {
              "attributeId": "soldToID",
              "text": "4313"
            }
          ]
        }
      },
      {
        "storeId": "441",
        "name": "SPORT CHEK",
        "address1": "301 CONFEDERATION DRIVE",
        "city": "SASKATOON",
        "postalCode": "S7L 5C3",
        "stateCode": "SK",
        "countryCode": "CA",
        "latitude": "52.130598",
        "longitude": "-106.7248795",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "384",
        "name": "SPORT CHEK",
        "address1": "2401 HIGHWAY 2 UNIT 1 & 2",
        "city": "BOWMANVILLE",
        "postalCode": "L1C 4V4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.7455103",
        "longitude": "-87.0825297",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "610",
        "name": "HOULE SPORTS CUMBERLAND",
        "address1": "2055 TENTH LINE RD UNIT 10",
        "city": "ORLEANS",
        "postalCode": "K4A 4C5",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "ralph@houlesports.ca",
        "phone": "613-830-6663",
        "latitude": "45.45946",
        "longitude": "-75.486412",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "14142"
            },
            {
              "attributeId": "soldToID",
              "text": "14142"
            }
          ]
        }
      },
      {
        "storeId": "187",
        "name": "2ND CENTURY SOURCE FOR SPORTS",
        "address1": "425 WEST ST N",
        "city": "ORILLIA",
        "postalCode": "L3V 7R2",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "705-325-1672",
        "latitude": "44.6227661",
        "longitude": "-79.43426869999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "19504"
            }
          ]
        }
      },
      {
        "storeId": "259",
        "name": "L'ENTREPOT DU HOCKEY QUEBEC",
        "address1": "915 BOU PIERRE - BERTRAND",
        "city": "QUEBEC",
        "postalCode": "G1M 2E7",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "sdrouin@groupebouchersports.com",
        "phone": "418-681-0787",
        "latitude": "46.825892",
        "longitude": "-71.274913",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "sharvey@groupebouchersports.com"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18736"
            },
            {
              "attributeId": "soldToID",
              "text": "18736"
            }
          ]
        }
      },
      {
        "storeId": "478",
        "name": "THE BIKE SHOP",
        "address1": "375 UNIVERSITY AVENUE",
        "city": "CHARLOTTETOWN",
        "postalCode": "C1A 4N4",
        "stateCode": "PE",
        "countryCode": "CA",
        "email": "Terry@sourceforsportspei.com",
        "phone": "902-566-9898",
        "latitude": "46.244146",
        "longitude": "-63.134443",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4320"
            },
            {
              "attributeId": "soldToID",
              "text": "4320"
            }
          ]
        }
      },
      {
        "storeId": "577",
        "name": "TOP SOURCE FOR SPORTS",
        "address1": "4828-44 STREET",
        "city": "LLOYDMINSTER",
        "postalCode": "S9V 0G8",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306-825-8851",
        "latitude": "53.27819100000001",
        "longitude": "-110.0024421",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "7017"
            }
          ]
        }
      },
      {
        "storeId": "418",
        "name": "SPORT CHEK",
        "address1": "1920 EGLINTON AVENUE EAST",
        "city": "SCARBOROUGH",
        "postalCode": "M1L 2L9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.7279151",
        "longitude": "-79.2908297",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "117",
        "name": "ICE LEVEL SOURCE FOR SPORTS",
        "address1": "UNIT 8060- 11688 STEVENSON HWY",
        "city": "RICHMOND",
        "postalCode": "V7A 1N6",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "stevejung34@gmail.com",
        "phone": "604-244-8686",
        "latitude": "49.13194",
        "longitude": "-123.092883",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5219"
            },
            {
              "attributeId": "soldToID",
              "text": "5219"
            }
          ]
        }
      },
      {
        "storeId": "490",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "1055 PROSPECT ST",
        "city": "FREDERICTON",
        "postalCode": "E3B 3B9",
        "stateCode": "NB",
        "countryCode": "CA",
        "phone": "506-457-2040",
        "latitude": "45.941906",
        "longitude": "-66.66685",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "387",
        "name": "SPORT CHEK",
        "address1": "777 GUELPH LINE",
        "city": "BURLINGTON",
        "postalCode": "L7R 3N2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.3485131",
        "longitude": "-79.7935979",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "481",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "60 AKERLEY BLVD #2",
        "city": "DARTMOUTH",
        "postalCode": "B3B 1R8",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "cleves.burnside@sourceforsports.ca",
        "phone": "902-468-1885",
        "latitude": "44.710893",
        "longitude": "-63.600412",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224120"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "52",
        "name": "KEYSTONE SOURCE FOR SPORTS",
        "address1": "417 MAIN STREET",
        "city": "SELKIRK",
        "postalCode": "R1A 1V2",
        "stateCode": "MB",
        "countryCode": "CA",
        "phone": "204 482 7552",
        "latitude": "50.14559",
        "longitude": "-96.872228",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5398"
            },
            {
              "attributeId": "soldToID",
              "text": "5398"
            }
          ]
        }
      },
      {
        "storeId": "586",
        "name": "TBS HOCKEY STORE",
        "address1": "#4 6013-48 AVENUE",
        "city": "RED DEER",
        "postalCode": "T4N 3V5",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "kim@getitattbs.com",
        "phone": "403-342-2277",
        "latitude": "52.28043",
        "longitude": "-113.81088",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19206"
            },
            {
              "attributeId": "soldToID",
              "text": "19206"
            }
          ]
        }
      },
      {
        "storeId": "179",
        "name": "HERM'S SPORT EXCHANGE INC",
        "address1": "820 WHARNCLIFFE RD S",
        "city": "LONDON",
        "postalCode": "N6J 2N4",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "519-649-0600",
        "latitude": "42.9422854",
        "longitude": "-81.2563014",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5123"
            }
          ]
        }
      },
      {
        "storeId": "412",
        "name": "SPORT CHEK",
        "address1": "399 NORWICH AVENUE",
        "city": "WOODSTOCK",
        "postalCode": "N4S 3W4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.1188201",
        "longitude": "-80.7361541",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "612",
        "name": "SKATERS NORTH SOURCE FOR SPORTS",
        "address1": "1321-B FISHER ST",
        "city": "NORTH BAY",
        "postalCode": "P1B 2H2",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "paulmc@skatersnorth.com",
        "phone": "705-478-7396",
        "latitude": "46.312041",
        "longitude": "-79.446142",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18710"
            },
            {
              "attributeId": "soldToID",
              "text": "18710"
            }
          ]
        }
      },
      {
        "storeId": "73",
        "name": "GOAL TEC",
        "address1": "400 DUCHESS STREET",
        "city": "SASKATOON",
        "postalCode": "S7K 0R1",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "306 242 6035",
        "latitude": "52.142764",
        "longitude": "-106.655941",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "11749"
            },
            {
              "attributeId": "soldToID",
              "text": "11749"
            }
          ]
        }
      },
      {
        "storeId": "314",
        "name": "SPORT CHEK",
        "address1": "2100K WILLOWBROOKE DRIVE",
        "city": "CRANBROOK",
        "postalCode": "V1C 7H2",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.52910199999999",
        "longitude": "-115.7467154",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "47",
        "name": "BERT & MACS SOURCE FOR SPORTS",
        "address1": "1108 1 AVE S",
        "city": "LETHBRIDGE",
        "postalCode": "T1J 0B2",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "dcourt@bertandmacsports.com",
        "phone": "403 327 3221",
        "latitude": "49.698006",
        "longitude": "-112.830343",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4314"
            },
            {
              "attributeId": "soldToID",
              "text": "4314"
            }
          ]
        }
      },
      {
        "storeId": "60",
        "name": "PLAY IT AGAIN SPORTS - 11285",
        "address1": "730 ST ANNE ROAD - UNIT U",
        "city": "WINNIPEG",
        "postalCode": "R2N 0A2",
        "stateCode": "MB",
        "countryCode": "CA",
        "email": "playitagainwinnipeg@gmail.com",
        "phone": "204 256 1115",
        "latitude": "49.823701",
        "longitude": "-97.085262",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6037"
            },
            {
              "attributeId": "soldToID",
              "text": "6037"
            }
          ]
        }
      },
      {
        "storeId": "346",
        "name": "SPORT CHEK",
        "address1": "UNIT# E57, 800 GRAND LAKE ROAD",
        "city": "SYDNEY",
        "postalCode": "B1P 6S9",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "491",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "101 MCALLISTER DR",
        "city": "SAINT JOHN",
        "postalCode": "E2J 2S5",
        "stateCode": "NB",
        "countryCode": "CA",
        "phone": "506-657-2040",
        "latitude": "45.312531",
        "longitude": "-66.020362",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "186",
        "name": "4 HUNDRED SOURCE FOR SPORTS",
        "address1": "70 BARRIE VIEW DRIVE",
        "city": "BARRIE",
        "postalCode": "L4N 8V4",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "sean.venedam@4hundredbarrie.com",
        "phone": "705-734-2323",
        "latitude": "44.336585",
        "longitude": "-79.689061",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19274"
            },
            {
              "attributeId": "soldToID",
              "text": "19274"
            }
          ]
        }
      },
      {
        "storeId": "331",
        "name": "SPORT CHEK",
        "address1": "UNIT #1, 1570 REGENT AVENUE",
        "city": "WINNIPEG",
        "postalCode": "R2C 2Y9",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "313",
        "name": "SPORT CHEK",
        "address1": "MAJOR 1, 4700 KINGSWAY",
        "city": "BURNABY",
        "postalCode": "V5H 4M1",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.22644750000001",
        "longitude": "-123.0025662",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "400",
        "name": "SPORT CHEK",
        "address1": "785 KANATA AVENUE UNIT #Q1",
        "city": "KANATA",
        "postalCode": "K2T 1H8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.310427",
        "longitude": "-75.90884009999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "308",
        "name": "SPORT CHEK",
        "address1": "1000 PARK ROYAL MALL SOUTH",
        "city": "WEST VANCOUVER",
        "postalCode": "V7T 1A1",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.3249851",
        "longitude": "-123.1380562",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "480",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "86 STARRS RD",
        "city": "YARMOUTH",
        "postalCode": "B5A 2T5",
        "stateCode": "NS",
        "countryCode": "CA",
        "email": "cleves.yarmouth@sourceforsports.ca",
        "phone": "902-742-8135",
        "latitude": "43.843779",
        "longitude": "-66.103085",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224119"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "440",
        "name": "SPORT CHEK",
        "address1": "201-1 AVENUE SOUTH UNIT T215C",
        "city": "SASKATOON",
        "postalCode": "S7K 1J9",
        "stateCode": "SK",
        "countryCode": "CA",
        "latitude": "52.1275247",
        "longitude": "-106.6666825",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "274",
        "name": "PRO HOCKEY LIFE",
        "address1": "1779 STONE CHURCH RD E - UNIT 4",
        "city": "HAMILTON",
        "postalCode": "L8J 0B4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.195308",
        "longitude": "-79.811289",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212474"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "177",
        "name": "LONDON'S SOURCE FOR SPORTS",
        "address1": "406 WHARNCLIFFE RD S",
        "city": "LONDON",
        "postalCode": "N6J 2M4",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "mike@sourcelondon.com",
        "phone": "519-673-3810",
        "latitude": "42.963003",
        "longitude": "-81.260874",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212462"
            },
            {
              "attributeId": "soldToID",
              "text": "4763"
            }
          ]
        }
      },
      {
        "storeId": "608",
        "name": "PLAY IT AGAIN SPORTS KANATA",
        "address1": "488 TERRY FOX DR",
        "city": "KANATA",
        "postalCode": "K2T 1L3",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "evan@playitagainsportsottawa.com",
        "phone": "613-599-9937",
        "latitude": "45.309317",
        "longitude": "-75.921466",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "9296"
            },
            {
              "attributeId": "soldToID",
              "text": "9296"
            }
          ]
        }
      },
      {
        "storeId": "487",
        "name": "CLEVE'S SPORTING GOODS SDC",
        "address1": "15 FASHION DRIVE, UNIT 2",
        "city": "SAINT JOHN",
        "postalCode": "E2J 0A7",
        "stateCode": "NB",
        "countryCode": "CA",
        "email": "cleves.saintjohn@sourceforsports.ca",
        "phone": "506-657-2040",
        "latitude": "45.302013",
        "longitude": "-66.026207",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224126"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "297",
        "name": "SPORT CHEK",
        "address1": "3803 CALGARY TRAIL S UNIT 190",
        "city": "EDMONTON",
        "postalCode": "T6J 5M8",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.47391",
        "longitude": "-113.4944182",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "362",
        "name": "SPORT CHEK",
        "address1": "UNIT# Y005, 1200 ST. LAURENT BLVD.",
        "city": "OTTAWA",
        "postalCode": "K1K 3B8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "300",
        "name": "SPORT CHEK",
        "address1": "6603-51 STREET",
        "city": "COLD LAKE",
        "postalCode": "T9M 1C8",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "54.43225229999999",
        "longitude": "-110.2052848",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "122",
        "name": "CYCLONE TAYLOR SPORTS",
        "address1": "6575 OAK ST",
        "city": "VANCOUVER",
        "postalCode": "V6P 3Z3",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "mark@cyclonetaylor.com",
        "phone": "604-266-3316",
        "latitude": "49.226007",
        "longitude": "-123.128785",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "justin@cyclonetaylor.com",
                "zoe@cyclonetaylor.com"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224115"
            },
            {
              "attributeId": "soldToID",
              "text": "7004"
            }
          ]
        }
      },
      {
        "storeId": "295",
        "name": "SPORT CHEK",
        "address1": "6703-48 AVENUE UNIT #130",
        "city": "CAMROSE",
        "postalCode": "T4V 3K3",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.0172779",
        "longitude": "-112.8577813",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "334",
        "name": "SPORT CHEK",
        "address1": "1731 KENASTON BLVD UNIT C",
        "city": "WINNIPEG",
        "postalCode": "R3Y 1V5",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "49.8201787",
        "longitude": "-97.19488299999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "414",
        "name": "SPORT CHEK",
        "address1": "135 HARWOOD AVE N UNIT #1",
        "city": "AJAX",
        "postalCode": "L1Z 1E8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.862752",
        "longitude": "-79.026232",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "424",
        "name": "SPORT CHEK",
        "address1": "1355 KINGSTON ROAD UNIT 120",
        "city": "PICKERING",
        "postalCode": "L1V 1B8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.8361864",
        "longitude": "-79.08604150000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "128",
        "name": "GAME TIME SPORTS",
        "address1": "101 500 VEES DRIVE",
        "city": "PENTICTON",
        "postalCode": "V2A 7Y6",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-492-7447",
        "latitude": "49.4939681",
        "longitude": "-119.6026206",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "11117"
            },
            {
              "attributeId": "soldToID",
              "text": "11117"
            }
          ]
        }
      },
      {
        "storeId": "62",
        "name": "PLAYERS BENCH SPORTS",
        "address1": "612 13TH ST",
        "city": "LETHBRIDGE",
        "postalCode": "T1H 2S8",
        "stateCode": "AB",
        "countryCode": "CA",
        "phone": "403 327 7777",
        "latitude": "49.7080838",
        "longitude": "-112.8244244",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "6081"
            },
            {
              "attributeId": "soldToID",
              "text": "6081"
            }
          ]
        }
      },
      {
        "storeId": "320",
        "name": "SPORT CHEK",
        "address1": "2701 SKAHA LAKE ROAD UNIT #101",
        "city": "PENTICTON",
        "postalCode": "V2A 9B8",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.4657704",
        "longitude": "-119.5871532",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "265",
        "name": "PRO HOCKEY LIFE",
        "address1": "164 MAYFIELD COMMONS",
        "city": "EDMONTON",
        "postalCode": "T5P 4B3",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.542247",
        "longitude": "-113.613641",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212730"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "347",
        "name": "SPORT CHEK",
        "address1": "UNIT #1, 7001 MUMFORD ROAD",
        "city": "HALIFAX",
        "postalCode": "B3L 4L9",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "365",
        "name": "SPORT CHEK",
        "address1": "UNIT #1- 809, 100 CITY CENTRE DRIVE",
        "city": "MISSISSAUGA",
        "postalCode": "L5B 2C9",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "309",
        "name": "SPORT CHEK",
        "address1": "UNIT #1410, 2271 HARVEY AVENUE",
        "city": "KELOWNA",
        "postalCode": "V1Y 6H2",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "507",
        "name": "SPORTS ROUSSEAU",
        "address1": "183-F BOULEVARD HYMUS",
        "city": "POINTE-CLAIRE",
        "postalCode": "H9R 1E9",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "kthmurray_2000@yahoo.com",
        "phone": "514-683-5333",
        "latitude": "45.485775",
        "longitude": "-73.796732",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "jquinn@qsmgroup.ca",
                "jpblanchette@qsmgroup.ca"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "14314"
            },
            {
              "attributeId": "soldToID",
              "text": "14314"
            }
          ]
        }
      },
      {
        "storeId": "351",
        "name": "SPORT CHEK",
        "address1": "689 WESTVILLE ROAD UNIT 135",
        "city": "NEW GLASGOW",
        "postalCode": "B2H 2J6",
        "stateCode": "NS",
        "countryCode": "CA",
        "latitude": "45.58035779999999",
        "longitude": "-62.6663424",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "286",
        "name": "SPORT CHEK",
        "address1": "1320 99 STREET NW",
        "city": "EDMONTON",
        "postalCode": "T6N 0A8",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "53.4418288",
        "longitude": "-113.4846227",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "489",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "52 WYSE ST",
        "city": "MONCTON",
        "postalCode": "E1G 0Z5",
        "stateCode": "NB",
        "countryCode": "CA",
        "phone": "506-855-2040",
        "latitude": "46.118749",
        "longitude": "-64.826975",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "280",
        "name": "SPORT CHEK",
        "address1": "48 CROWFOOT TERRACE NW",
        "city": "CALGARY",
        "postalCode": "T3G 4J8",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "51.1280929",
        "longitude": "-114.1999682",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "512",
        "name": "SPORTS ROUSSEAU: BOISBRIAND 3154",
        "address1": "3600, boul. Grande-Allée",
        "city": "Boisbriand",
        "postalCode": "J7H 1M9",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "ehurtubise@sportsrousseau30.ca",
        "phone": "450-419-4189",
        "latitude": "45.631662",
        "longitude": "-73.85857",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18744"
            },
            {
              "attributeId": "soldToID",
              "text": "18744"
            }
          ]
        }
      },
      {
        "storeId": "603",
        "name": "E.D. DERBYSHIRE & SONS",
        "address1": "2560 PRINCESS ST",
        "city": "KINGSTON",
        "postalCode": "K7P 2S8",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "613-384-0011",
        "latitude": "44.2599965",
        "longitude": "-76.56984899999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4759"
            }
          ]
        }
      },
      {
        "storeId": "495",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "61 GARY MARTIN DRIVE",
        "city": "BEDFORD",
        "postalCode": "B4B 0G7",
        "stateCode": "NS",
        "countryCode": "CA",
        "phone": "902-835-5825",
        "latitude": "44.725181",
        "longitude": "-63.704876",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "359",
        "name": "SPORT CHEK",
        "address1": "LAMBTON MALL, UNIT 170, 1380 LONDON ROAD",
        "city": "SARNIA",
        "postalCode": "N7S 1P8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "42.9824993",
        "longitude": "-82.3523048",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "456",
        "name": "AL'S SOURCE FOR SPORTS",
        "address1": "3485 FAIRVIEW ST",
        "city": "BURLINGTON",
        "postalCode": "L7N 2R4",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "Als@SourceForSports.ca",
        "phone": "905-634-8888",
        "latitude": "43.358605",
        "longitude": "-79.782112",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "4127"
            },
            {
              "attributeId": "soldToID",
              "text": "4127"
            }
          ]
        }
      },
      {
        "storeId": "357",
        "name": "SPORT CHEK",
        "address1": "CRU 1690, 25 THE WEST MALL",
        "city": "ETOBICOKE",
        "postalCode": "M9C 1B8",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.611813",
        "longitude": "-79.55706339999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "393",
        "name": "SPORT CHEK",
        "address1": "419 KING STREET WEST UNIT 1150",
        "city": "OSHAWA",
        "postalCode": "L1J 2K5",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.8907422",
        "longitude": "-78.87987009999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "422",
        "name": "SPORT CHEK",
        "address1": "785 BRITANNIA ROAD WEST",
        "city": "MISSISSAUGA",
        "postalCode": "L5V 2Y1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.6107139",
        "longitude": "-79.69968879999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "549",
        "name": "HAPPY'S SOURCE FOR SPORTS",
        "address1": "256 6TH STREET",
        "city": "COURTENAY",
        "postalCode": "V9N 1M1",
        "stateCode": "BC",
        "countryCode": "CA",
        "phone": "250-334-4143",
        "latitude": "49.6902272",
        "longitude": "-124.9973496",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5113"
            },
            {
              "attributeId": "soldToID",
              "text": "5113"
            }
          ]
        }
      },
      {
        "storeId": "123",
        "name": "CYCLONE TAYLOR SPORTS",
        "address1": "106 5433 152 ND STREET",
        "city": "SURREY",
        "postalCode": "V3S 5A5",
        "stateCode": "BC",
        "countryCode": "CA",
        "email": "mark@cyclonetaylor.com",
        "phone": "604-575-8801",
        "latitude": "49.101009",
        "longitude": "-122.801787",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "justin@cyclonetaylor.com",
                "zoe@cyclonetaylor.com"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "224116"
            },
            {
              "attributeId": "soldToID",
              "text": "7004"
            }
          ]
        }
      },
      {
        "storeId": "258",
        "name": "EVOLUTECH",
        "address1": "1045 RUE VINCENT-MASSEY",
        "city": "VILLE DE QUEBEC",
        "postalCode": "G1N 4M8",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "418-527-0000",
        "latitude": "46.803666",
        "longitude": "-71.250555",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "15872"
            }
          ]
        }
      },
      {
        "storeId": "330",
        "name": "SPORT CHEK",
        "address1": "UNIT 130A, 1485 PORTAGE AVENUE",
        "city": "WINNIPEG",
        "postalCode": "R3G 0W4",
        "stateCode": "MB",
        "countryCode": "CA",
        "latitude": "49.883912",
        "longitude": "-97.19889169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "396",
        "name": "SPORT CHEK",
        "address1": "655 FAIRWAY ROAD SOUTH",
        "city": "KITCHENER",
        "postalCode": "N2C 1X4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.4193142",
        "longitude": "-80.4503328",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "323",
        "name": "SPORT CHEK",
        "address1": "9855 AUSTIN AVENUE UNIT #102",
        "city": "BURNABY",
        "postalCode": "V3J 1N4",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.2516991",
        "longitude": "-122.8961476",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "416",
        "name": "SPORT CHEK",
        "address1": "1111 ELGIN STREET WEST UNIT #M7",
        "city": "COBOURG",
        "postalCode": "K9A 5H7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.97024769999999",
        "longitude": "-78.1997536",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "453",
        "name": "ACTION MULTI SPORTS",
        "address1": "46 DE LA CITE DES JEUNES",
        "city": "VAUDREUIL",
        "postalCode": "J7V 9L5",
        "stateCode": "QC",
        "countryCode": "CA",
        "phone": "450-424-3092",
        "latitude": "45.408792",
        "longitude": "-74.037487",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "soldToID",
              "text": "14818"
            }
          ]
        }
      },
      {
        "storeId": "55",
        "name": "MCTAGGARTS",
        "address1": "133 MAIN STREET SOUTH",
        "city": "KENORA",
        "postalCode": "P9N 1T1",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "807 468 2225",
        "latitude": "49.766857",
        "longitude": "-94.490299",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "5669"
            }
          ]
        }
      },
      {
        "storeId": "271",
        "name": "PRO HOCKEY LIFE",
        "address1": "140 ROLAND MICHENER DRIVE",
        "city": "KANATA",
        "postalCode": "K2T 1K4",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "45.309132",
        "longitude": "-75.911943",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "212468"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "434",
        "name": "SPORT CHEK",
        "address1": "UNIT 1, 670 UNIVERSITY AVENUE",
        "city": "CHARLOTTETOWN",
        "postalCode": "C1E 1H6",
        "stateCode": "PEI",
        "countryCode": "CA",
        "latitude": "46.26605259999999",
        "longitude": "-63.1448876",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "460",
        "name": "Sports Zone Sports",
        "address1": "92 LODGE STREET",
        "city": "WATERLOO",
        "postalCode": "N2J 2V6",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "info@sportszonecanada.com",
        "phone": "519-725-8643",
        "latitude": "43.475797",
        "longitude": "-80.519411",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "11842"
            },
            {
              "attributeId": "soldToID",
              "text": "11842"
            }
          ]
        }
      },
      {
        "storeId": "298",
        "name": "SPORT CHEK",
        "address1": "1200-37 STREET SW UNIT 54",
        "city": "CALGARY",
        "postalCode": "T3C 1S2",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "51.042752",
        "longitude": "-114.140263",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "302",
        "name": "SPORT CHEK",
        "address1": "109 STREET & PRINCESS ELIZABETH",
        "city": "EDMONTON",
        "postalCode": "T5G 3A6",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "40.8023751",
        "longitude": "-73.96430889999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "260",
        "name": "ENTREPOT DU HOCKEY QUEBEC",
        "address1": "1255 AVENUE JULES-VERNE",
        "city": "QUEBEC",
        "postalCode": "G2E 6L6",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "sdrouin@groupebouchersports.com",
        "phone": "418-780-0783",
        "latitude": "46.789752",
        "longitude": "-71.351753",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18737"
            },
            {
              "attributeId": "soldToID",
              "text": "18737"
            }
          ]
        }
      },
      {
        "storeId": "341",
        "name": "SPORT CHEK",
        "address1": "1381 REGENT STREET UNIT Y200A",
        "city": "FREDERICTON",
        "postalCode": "E3C 1A2",
        "stateCode": "NB",
        "countryCode": "CA",
        "latitude": "45.9355926",
        "longitude": "-66.6632434",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "401",
        "name": "SPORT CHEK",
        "address1": "1933 REGENT STREET UNIT #51",
        "city": "SUDBURY",
        "postalCode": "P3E 5R2",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "46.4489363",
        "longitude": "-81.002724",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "497",
        "name": "CLEVE'S SOURCE FOR SPORTS",
        "address1": "963 CENTRAL AVE",
        "city": "GREENWOOD",
        "postalCode": "B0P 1N0",
        "stateCode": "NS",
        "countryCode": "CA",
        "phone": "902-765-2475",
        "latitude": "44.968618",
        "longitude": "-64.927287",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "4562"
            }
          ]
        }
      },
      {
        "storeId": "508",
        "name": "SPORTS ROUSSEAU",
        "address1": "4440 AUTOROUTE 440",
        "city": "LAVAL",
        "postalCode": "H7T 2P7",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "mamorin@sportsrousseau30.com",
        "phone": "450-681-4440",
        "latitude": "45.560104",
        "longitude": "-73.78635",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "alternateEmails",
              "value": "pjarry@sportsrousseau30.ca"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "hideFromSearch",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18740"
            },
            {
              "attributeId": "soldToID",
              "text": "18740"
            }
          ]
        }
      },
      {
        "storeId": "174",
        "name": "BUCKNERS SOURCE FOR SPORTS",
        "address1": "104 WELLAND AVENUE",
        "city": "ST CATHERINES",
        "postalCode": "L2R 2N3",
        "stateCode": "ON",
        "countryCode": "CA",
        "phone": "905-641-0066",
        "latitude": "43.163105",
        "longitude": "-79.246275",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "211851"
            },
            {
              "attributeId": "soldToID",
              "text": "4313"
            }
          ]
        }
      },
      {
        "storeId": "196",
        "name": "MONKEY CANADA",
        "address1": "61 BRUNSWICK BLVD",
        "city": "DOLLARD DES ORMEAUX",
        "postalCode": "H9B 2N4",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "Greg.goyer@monkeysports.com",
        "phone": "514-542-4600",
        "latitude": "45.48255",
        "longitude": "-73.79893",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "alternateEmails",
              "value": "customerservicesupervisor@monkeysports.com"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19173"
            },
            {
              "attributeId": "soldToID",
              "text": "19173"
            }
          ]
        }
      },
      {
        "storeId": "364",
        "name": "SPORT CHEK",
        "address1": "UNIT #0580, 1642 MERIVALE ROAD",
        "city": "OTTAWA",
        "postalCode": "K2G 4A1",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "36.044",
        "longitude": "-96.00893169999999",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "72",
        "name": "EXTREME HOCKEY",
        "address1": "1700 ELPHINSTONE STREET",
        "city": "REGINA",
        "postalCode": "S4P 2Z6",
        "stateCode": "SK",
        "countryCode": "CA",
        "phone": "639 528 8326",
        "latitude": "50.45116",
        "longitude": "-104.6358458",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "9968"
            }
          ]
        }
      },
      {
        "storeId": "307",
        "name": "SPORT CHEK",
        "address1": "3115 MASSEY DRIVE",
        "city": "PRINCE GEORGE",
        "postalCode": "V2N 2S9",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "53.9001471",
        "longitude": "-122.7781856",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "279",
        "name": "PRO HOCKEY LIFE",
        "address1": "1 HEREFORD STREET",
        "city": "BRAMPTON",
        "postalCode": "L6Y 0J7",
        "stateCode": "ON",
        "countryCode": "CA",
        "latitude": "43.62314",
        "longitude": "-79.779188",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "221713"
            },
            {
              "attributeId": "soldToID",
              "text": "6682"
            }
          ]
        }
      },
      {
        "storeId": "291",
        "name": "SPORT CHEK",
        "address1": "5855-68TH AVENUE SE BLDG A",
        "city": "CALGARY",
        "postalCode": "T2C 5A7",
        "stateCode": "AB",
        "countryCode": "CA",
        "latitude": "50.99369739999999",
        "longitude": "-113.9456482",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "51",
        "name": "KEYSTONE SPORTS EXCELLENCE",
        "address1": "170 SASKATCHEWAN AVE WEST",
        "city": "PORTAGE LA PRAIRE",
        "postalCode": "R1N 0M1",
        "stateCode": "MB",
        "countryCode": "CA",
        "phone": "204 857 8982",
        "latitude": "49.9733373",
        "longitude": "-98.29367640000001",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "5397"
            },
            {
              "attributeId": "soldToID",
              "text": "5397"
            }
          ]
        }
      },
      {
        "storeId": "578",
        "name": "UNITED SPORT AND CYCLE",
        "address1": "7620 GATEWAY BLVD NW",
        "city": "EDMONTON",
        "postalCode": "T6E 4Z8",
        "stateCode": "AB",
        "countryCode": "CA",
        "email": "jhall@unitedsport.ca",
        "phone": "780-433-1181",
        "latitude": "53.512873",
        "longitude": "-113.495566",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "true"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "goalieRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "7091"
            },
            {
              "attributeId": "soldToID",
              "text": "7091"
            }
          ]
        }
      },
      {
        "storeId": "509",
        "name": "SPORTS ROUSSEAU: VSL #3153",
        "address1": "3275, COTE VERTU, LOCAL #2",
        "city": "VILLE ST-LAURENT",
        "postalCode": "H4R 1Y8",
        "stateCode": "QC",
        "countryCode": "CA",
        "email": "brunnings@qsmgroup.ca",
        "phone": "514-745-3202",
        "latitude": "45.497157",
        "longitude": "-73.706071",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "alternateEmails",
              "value": [
                "jquinn@qsmgroup.ca",
                "clemelin@qsmgroup.ca"
              ]
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "18741"
            },
            {
              "attributeId": "soldToID",
              "text": "18741"
            }
          ]
        }
      },
      {
        "storeId": "326",
        "name": "SPORT CHEK",
        "address1": "777 DUNSMUIR STREET",
        "city": "VANCOUVER",
        "postalCode": "V7Y 1A1",
        "stateCode": "BC",
        "countryCode": "CA",
        "latitude": "49.2843731",
        "longitude": "-123.1164403",
        "store-locator-enabled-flag": "true",
        "demandware-pos-enabled-flag": "false",
        "pos-enabled-flag": "false",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "soldToID",
              "text": "14309"
            }
          ]
        }
      },
      {
        "storeId": "20304",
        "name": "Redmond Corner",
        "address1": "4705 Indian Trail Fairview Rd",
        "city": "Union",
        "postalCode": "28079",
        "stateCode": "NC",
        "countryCode": "US",
        "email": "arbarron22@gmail.com",
        "phone": "919-247-0756",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "shipToID",
              "text": "20304"
            },
            {
              "attributeId": "soldToID",
              "text": "20304"
            }
          ]
        }
      },
      {
        "storeId": "5133",
        "name": "T&T Hockey Shop Source for Sports",
        "address1": "8 Carden Street",
        "city": "Guelph",
        "postalCode": "N1H 3A2",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "todd@hockeynut.ca",
        "phone": "519 836-8631",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "5133"
            },
            {
              "attributeId": "soldToID",
              "text": "5133"
            }
          ]
        }
      },
      {
        "storeId": "19888",
        "name": "WEST STAR SPORTS EXCELLENCE",
        "address1": "3105 UNITY DRIVE UNITS 30/31",
        "city": "MISSISSAUGA",
        "postalCode": "L5L 4L3",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "scott@weststarathletics.com",
        "phone": "905-820-9428",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "19888"
            },
            {
              "attributeId": "soldToID",
              "text": "19888"
            }
          ]
        }
      },
      {
        "storeId": "6470",
        "name": "SANDERSON SOURCE FOR SPORTS",
        "address1": "56 BROADWAY AVE",
        "city": "ORANGEVILLE",
        "postalCode": "L9W 1J4",
        "stateCode": "ON",
        "countryCode": "CA",
        "email": "sandersonsourceforsports@gmail.com",
        "phone": "519 942-4891",
        "customAttributes": {
          "customAttribute": [
            {
              "attributeId": "BOSS",
              "text": "false"
            },
            {
              "attributeId": "eliteStickRetailer",
              "text": "true"
            },
            {
              "attributeId": "shipToID",
              "text": "6470"
            },
            {
              "attributeId": "soldToID",
              "text": "6470"
            }
          ]
        }
      },
    ]
};

storeObject.store.sort(function (storeA, storeB) {
  if (storeA.name < storeB.name) {
    return -1;
  }
  if (storeA.name > storeB.name) {
    return 1;
  }
  return 0;
});

//migrated order history from SFCC site (to be cleaned up after 60days fo golive)
const migratedWarrantyOrders = {
	"0045633": "2022-08-19T3:40:22 PM GMT",
	"0056474": "2022-08-19T3:40:22 PM GMT"
};

// Initialize store object
window.addEventListener("DOMContentLoaded", function() {
    storeObject;
	migratedWarrantyOrders;
})